/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const API_BASE_URL = new InjectionToken<string>
    ('API URL', {
        providedIn: 'root',
        factory: () => environment.apiUri
    });

@Injectable({
    providedIn: 'root'
})
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getListAccount(request: GetListAccountRequest | null | undefined): Observable<PaginatorResponseOfGetListAccountResponse | null> {
        let url_ = this.baseUrl + "/api/Account/GetListAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListAccount(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfGetListAccountResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfGetListAccountResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListAccount(response: HttpResponseBase): Observable<PaginatorResponseOfGetListAccountResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfGetListAccountResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfGetListAccountResponse | null>(<any>null);
    }

    getAccountByKeySearch(keySearch: string | null): Observable<AccountDto[] | null> {
        let url_ = this.baseUrl + "/api/Account/GetAccountByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<AccountDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountByKeySearch(response: HttpResponseBase): Observable<AccountDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AccountDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto[] | null>(<any>null);
    }

    detail(accountId: string | null): Observable<AccountDto | null> {
        let url_ = this.baseUrl + "/api/Account/Detail?";
        if (accountId === undefined)
            throw new Error("The parameter 'accountId' must be defined.");
        else if (accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetail(<any>response_);
                } catch (e) {
                    return <Observable<AccountDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processDetail(response: HttpResponseBase): Observable<AccountDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AccountDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto | null>(<any>null);
    }

    delete(accountId: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/Delete?";
        if (accountId === undefined)
            throw new Error("The parameter 'accountId' must be defined.");
        else if (accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    deleteList(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/DeleteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    create(request: CreateAccountRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Account/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    updatePassword(request: UpdatePasswordRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/UpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    update(request: UpdateAccountRequest | null | undefined): Observable<AccountDto | null> {
        let url_ = this.baseUrl + "/api/Account/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AccountDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AccountDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AccountDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto | null>(<any>null);
    }

    getProfile(): Observable<AccountDto | null> {
        let url_ = this.baseUrl + "/api/Account/GetProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(<any>response_);
                } catch (e) {
                    return <Observable<AccountDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<AccountDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AccountDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto | null>(<any>null);
    }

    updateProfile(request: UpdateProfileAccountRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Account/UpdateProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfile(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProfile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    changePassword(request: ChangePasswordAccountRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getListRoleAllowManager(): Observable<AccountRoleDto[] | null> {
        let url_ = this.baseUrl + "/api/Account/GetListRoleAllowManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListRoleAllowManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListRoleAllowManager(<any>response_);
                } catch (e) {
                    return <Observable<AccountRoleDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountRoleDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListRoleAllowManager(response: HttpResponseBase): Observable<AccountRoleDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AccountRoleDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountRoleDto[] | null>(<any>null);
    }

    getListRoleUsingPermission(): Observable<AccountRoleDto[] | null> {
        let url_ = this.baseUrl + "/api/Account/GetListRoleUsingPermission";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListRoleUsingPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListRoleUsingPermission(<any>response_);
                } catch (e) {
                    return <Observable<AccountRoleDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountRoleDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListRoleUsingPermission(response: HttpResponseBase): Observable<AccountRoleDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AccountRoleDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountRoleDto[] | null>(<any>null);
    }

    checkIsEmailExists(request: CheckIsEmailExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/CheckIsEmailExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsEmailExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsEmailExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsEmailExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsUsernameExists(request: CheckIsUsernameExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/CheckIsUsernameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsUsernameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsUsernameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsUsernameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsPhoneNumberExists(request: CheckIsPhoneNumberExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/CheckIsPhoneNumberExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsPhoneNumberExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsPhoneNumberExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsPhoneNumberExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    filterWithTag(keySearch: string | null): Observable<FilterWithTagAccountResponse[] | null> {
        let url_ = this.baseUrl + "/api/Account/FilterWithTag?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFilterWithTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterWithTag(<any>response_);
                } catch (e) {
                    return <Observable<FilterWithTagAccountResponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilterWithTagAccountResponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processFilterWithTag(response: HttpResponseBase): Observable<FilterWithTagAccountResponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(FilterWithTagAccountResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FilterWithTagAccountResponse[] | null>(<any>null);
    }

    currentAccount(): Observable<AccountDto | null> {
        let url_ = this.baseUrl + "/api/Account/CurrentAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCurrentAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentAccount(<any>response_);
                } catch (e) {
                    return <Observable<AccountDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processCurrentAccount(response: HttpResponseBase): Observable<AccountDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AccountDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDto | null>(<any>null);
    }

    checkIsPhoneZaloExists(request: CheckIsPhoneZaloExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/CheckIsPhoneZaloExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsPhoneZaloExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsPhoneZaloExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsPhoneZaloExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsLinkFacebookExists(request: CheckIsLinkFacebookExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/CheckIsLinkFacebookExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsLinkFacebookExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsLinkFacebookExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsLinkFacebookExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TinTucClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(request: CreateTinTucRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TinTuc/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    update(request: UpdateTinTucRequest | null | undefined): Observable<TinTucDto | null> {
        let url_ = this.baseUrl + "/api/TinTuc/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TinTucDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<TinTucDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TinTucDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TinTucDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TinTucDto | null>(<any>null);
    }

    xoaListTinTuc(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TinTuc/XoaListTinTuc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processXoaListTinTuc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processXoaListTinTuc(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processXoaListTinTuc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/TinTuc/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    updatePublisedTime(request: UpdatePublisedTimeRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TinTuc/UpdatePublisedTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePublisedTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePublisedTime(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePublisedTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    detailForManager(id: string): Observable<TinTucDto | null> {
        let url_ = this.baseUrl + "/api/TinTuc/DetailForManager/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDetailForManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetailForManager(<any>response_);
                } catch (e) {
                    return <Observable<TinTucDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<TinTucDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processDetailForManager(response: HttpResponseBase): Observable<TinTucDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TinTucDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TinTucDto | null>(<any>null);
    }

    getList(request: GetListTinTucRequest | null | undefined): Observable<PaginatorResponseOfGetListTinTucResponse | null> {
        let url_ = this.baseUrl + "/api/TinTuc/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfGetListTinTucResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfGetListTinTucResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PaginatorResponseOfGetListTinTucResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfGetListTinTucResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfGetListTinTucResponse | null>(<any>null);
    }

    getTopList(count: number | null): Observable<GetTopListTinTucResponse[] | null> {
        let url_ = this.baseUrl + "/api/TinTuc/GetTopList?";
        if (count === undefined)
            throw new Error("The parameter 'count' must be defined.");
        else if (count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTopList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopList(<any>response_);
                } catch (e) {
                    return <Observable<GetTopListTinTucResponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTopListTinTucResponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopList(response: HttpResponseBase): Observable<GetTopListTinTucResponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(GetTopListTinTucResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTopListTinTucResponse[] | null>(<any>null);
    }

    filterAccountCreate(keySearch: string | null): Observable<FilterAccountTinTucResponse[] | null> {
        let url_ = this.baseUrl + "/api/TinTuc/FilterAccountCreate?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFilterAccountCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterAccountCreate(<any>response_);
                } catch (e) {
                    return <Observable<FilterAccountTinTucResponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilterAccountTinTucResponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processFilterAccountCreate(response: HttpResponseBase): Observable<FilterAccountTinTucResponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(FilterAccountTinTucResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FilterAccountTinTucResponse[] | null>(<any>null);
    }

    danhSachTinTuc(request: GetListTinTucRequest | null | undefined): Observable<PaginatorResponseOfTinTucDto | null> {
        let url_ = this.baseUrl + "/api/TinTuc/DanhSachTinTuc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDanhSachTinTuc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDanhSachTinTuc(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfTinTucDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfTinTucDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processDanhSachTinTuc(response: HttpResponseBase): Observable<PaginatorResponseOfTinTucDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfTinTucDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfTinTucDto | null>(<any>null);
    }

    chiTietTinTuc(id: string): Observable<TinTucDto | null> {
        let url_ = this.baseUrl + "/api/TinTuc/ChiTietTinTuc/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChiTietTinTuc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChiTietTinTuc(<any>response_);
                } catch (e) {
                    return <Observable<TinTucDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<TinTucDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processChiTietTinTuc(response: HttpResponseBase): Observable<TinTucDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TinTucDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TinTucDto | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(request: LoginRequest | null | undefined): Observable<LoginResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? LoginResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse | null>(<any>null);
    }

    refreshToken(request: RefreshTokenRequest | null | undefined): Observable<LoginResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<LoginResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? LoginResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse | null>(<any>null);
    }

    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/Authentication/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    createTokenForgotPasswordFromPhone(phoneNumber: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Authentication/CreateTokenForgotPasswordFromPhone?";
        if (phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        else if (phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTokenForgotPasswordFromPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTokenForgotPasswordFromPhone(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTokenForgotPasswordFromPhone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    createTokenForgotPasswordFromEmail(email: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/Authentication/CreateTokenForgotPasswordFromEmail?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if (email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTokenForgotPasswordFromEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTokenForgotPasswordFromEmail(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTokenForgotPasswordFromEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    checkOTPCodeValidForForgotPassword(otpCode: string | null, accountId: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Authentication/CheckOTPCodeValidForForgotPassword?";
        if (otpCode === undefined)
            throw new Error("The parameter 'otpCode' must be defined.");
        else if (otpCode !== null)
            url_ += "otpCode=" + encodeURIComponent("" + otpCode) + "&";
        if (accountId === undefined)
            throw new Error("The parameter 'accountId' must be defined.");
        else if (accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckOTPCodeValidForForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOTPCodeValidForForgotPassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckOTPCodeValidForForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    changePasswordOfForgot(request: ChangePasswordOfForgotRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Authentication/ChangePasswordOfForgot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePasswordOfForgot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordOfForgot(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePasswordOfForgot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BodyUsedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBodyUsedByKeySearch(keySearch: string | null): Observable<BodyUsedDto[] | null> {
        let url_ = this.baseUrl + "/api/BodyUsed/GetBodyUsedByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBodyUsedByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBodyUsedByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<BodyUsedDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<BodyUsedDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetBodyUsedByKeySearch(response: HttpResponseBase): Observable<BodyUsedDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(BodyUsedDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BodyUsedDto[] | null>(<any>null);
    }

    create(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/BodyUsed/Create?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else if (name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkBodyUsedNameExists(request: CheckNameExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/BodyUsed/CheckBodyUsedNameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckBodyUsedNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckBodyUsedNameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckBodyUsedNameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getDetail(id: number): Observable<BodyUsedDto | null> {
        let url_ = this.baseUrl + "/api/BodyUsed/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<BodyUsedDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<BodyUsedDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<BodyUsedDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? BodyUsedDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BodyUsedDto | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(request: CreateCategoryRequest | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Category/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    update(request: UpdateCategoryRequest | null | undefined): Observable<CategoryDto | null> {
        let url_ = this.baseUrl + "/api/Category/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CategoryDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CategoryDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto | null>(<any>null);
    }

    xoaDanhMuc(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Category/XoaDanhMuc/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processXoaDanhMuc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processXoaDanhMuc(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processXoaDanhMuc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    deteleList(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Category/DeteleList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeteleList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeteleList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeteleList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkCategoryNameExists(request: CheckNameExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Category/CheckCategoryNameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCategoryNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCategoryNameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCategoryNameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getCategoryParentByKeySearch(keySearch: string | null): Observable<CategoryDto[] | null> {
        let url_ = this.baseUrl + "/api/Category/GetCategoryParentByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoryParentByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryParentByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryParentByKeySearch(response: HttpResponseBase): Observable<CategoryDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto[] | null>(<any>null);
    }

    getCategoryByKeySearch(keySearch: string | null): Observable<CategoryDto[] | null> {
        let url_ = this.baseUrl + "/api/Category/GetCategoryByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoryByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryByKeySearch(response: HttpResponseBase): Observable<CategoryDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto[] | null>(<any>null);
    }

    getDetail(id: number): Observable<CategoryDto | null> {
        let url_ = this.baseUrl + "/api/Category/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<CategoryDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CategoryDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto | null>(<any>null);
    }

    pagingCategory(request: GetListCategoryRequest | null | undefined): Observable<PaginatorResponseOfCategoryResponse | null> {
        let url_ = this.baseUrl + "/api/Category/PagingCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPagingCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPagingCategory(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfCategoryResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfCategoryResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processPagingCategory(response: HttpResponseBase): Observable<PaginatorResponseOfCategoryResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfCategoryResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfCategoryResponse | null>(<any>null);
    }

    listCategoryByParentId(parentId: number): Observable<CategoryResponse[] | null> {
        let url_ = this.baseUrl + "/api/Category/ListCategoryByParentId?";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined and cannot be null.");
        else
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListCategoryByParentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListCategoryByParentId(<any>response_);
                } catch (e) {
                    return <Observable<CategoryResponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryResponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processListCategoryByParentId(response: HttpResponseBase): Observable<CategoryResponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CategoryResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryResponse[] | null>(<any>null);
    }

    getAllCategoryTree(): Observable<CategoryResponse[] | null> {
        let url_ = this.baseUrl + "/api/Category/GetAllCategoryTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCategoryTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategoryTree(<any>response_);
                } catch (e) {
                    return <Observable<CategoryResponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryResponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCategoryTree(response: HttpResponseBase): Observable<CategoryResponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CategoryResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryResponse[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getReceiptBookItemEnum(): Observable<ObjectEnumOfReceiptBookItemEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetReceiptBookItemEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReceiptBookItemEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptBookItemEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfReceiptBookItemEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfReceiptBookItemEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceiptBookItemEnum(response: HttpResponseBase): Observable<ObjectEnumOfReceiptBookItemEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfReceiptBookItemEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfReceiptBookItemEnum[] | null>(<any>null);
    }

    getOrderTypeEnum(): Observable<ObjectEnumOfOrderTypeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetOrderTypeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderTypeEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderTypeEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfOrderTypeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfOrderTypeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderTypeEnum(response: HttpResponseBase): Observable<ObjectEnumOfOrderTypeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfOrderTypeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfOrderTypeEnum[] | null>(<any>null);
    }

    getOrderChanelEnum(): Observable<ObjectEnumOfOrderChanelEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetOrderChanelEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderChanelEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderChanelEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfOrderChanelEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfOrderChanelEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderChanelEnum(response: HttpResponseBase): Observable<ObjectEnumOfOrderChanelEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfOrderChanelEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfOrderChanelEnum[] | null>(<any>null);
    }

    getOrderCustomerStatusEnum(): Observable<ObjectEnumOfOrderCustomerStatusEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetOrderCustomerStatusEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderCustomerStatusEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderCustomerStatusEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfOrderCustomerStatusEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfOrderCustomerStatusEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderCustomerStatusEnum(response: HttpResponseBase): Observable<ObjectEnumOfOrderCustomerStatusEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfOrderCustomerStatusEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfOrderCustomerStatusEnum[] | null>(<any>null);
    }

    getPaymentTypeEnum(): Observable<ObjectEnumOfPaymentTypeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetPaymentTypeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentTypeEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentTypeEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfPaymentTypeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfPaymentTypeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentTypeEnum(response: HttpResponseBase): Observable<ObjectEnumOfPaymentTypeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfPaymentTypeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfPaymentTypeEnum[] | null>(<any>null);
    }

    getPurchaseOrderStatusEnum(): Observable<ObjectEnumOfPurchaseOrderStatusEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetPurchaseOrderStatusEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderStatusEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderStatusEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfPurchaseOrderStatusEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfPurchaseOrderStatusEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetPurchaseOrderStatusEnum(response: HttpResponseBase): Observable<ObjectEnumOfPurchaseOrderStatusEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfPurchaseOrderStatusEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfPurchaseOrderStatusEnum[] | null>(<any>null);
    }

    getDiscountTypeEnum(): Observable<ObjectEnumOfDiscountTypeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetDiscountTypeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDiscountTypeEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscountTypeEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfDiscountTypeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfDiscountTypeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDiscountTypeEnum(response: HttpResponseBase): Observable<ObjectEnumOfDiscountTypeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfDiscountTypeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfDiscountTypeEnum[] | null>(<any>null);
    }

    getListProductPickupStatusEnum(): Observable<ObjectEnumOfProductPickupStatusEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListProductPickupStatusEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListProductPickupStatusEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListProductPickupStatusEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfProductPickupStatusEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfProductPickupStatusEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListProductPickupStatusEnum(response: HttpResponseBase): Observable<ObjectEnumOfProductPickupStatusEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfProductPickupStatusEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfProductPickupStatusEnum[] | null>(<any>null);
    }

    getListCashFlowNegativeEnum(): Observable<ObjectEnumOfCashFlowNegativeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListCashFlowNegativeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListCashFlowNegativeEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListCashFlowNegativeEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfCashFlowNegativeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfCashFlowNegativeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListCashFlowNegativeEnum(response: HttpResponseBase): Observable<ObjectEnumOfCashFlowNegativeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfCashFlowNegativeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfCashFlowNegativeEnum[] | null>(<any>null);
    }

    getListOrderCustomerTypeEnum(): Observable<ObjectEnumOfOrderCustomerTypeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListOrderCustomerTypeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListOrderCustomerTypeEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListOrderCustomerTypeEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfOrderCustomerTypeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfOrderCustomerTypeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListOrderCustomerTypeEnum(response: HttpResponseBase): Observable<ObjectEnumOfOrderCustomerTypeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfOrderCustomerTypeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfOrderCustomerTypeEnum[] | null>(<any>null);
    }

    getListSupplierType(): Observable<ObjectEnumOfSupplierTypeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListSupplierType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListSupplierType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListSupplierType(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfSupplierTypeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfSupplierTypeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListSupplierType(response: HttpResponseBase): Observable<ObjectEnumOfSupplierTypeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfSupplierTypeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfSupplierTypeEnum[] | null>(<any>null);
    }

    getListGender(): Observable<ObjectEnumOfGenderEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListGender";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListGender(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListGender(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfGenderEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfGenderEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListGender(response: HttpResponseBase): Observable<ObjectEnumOfGenderEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfGenderEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfGenderEnum[] | null>(<any>null);
    }

    getListCustomer(): Observable<ObjectEnumOfCustomerTypeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListCustomer(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfCustomerTypeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfCustomerTypeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListCustomer(response: HttpResponseBase): Observable<ObjectEnumOfCustomerTypeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfCustomerTypeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfCustomerTypeEnum[] | null>(<any>null);
    }

    getListFileType(): Observable<ObjectEnumOfFileTypeEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListFileType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListFileType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListFileType(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfFileTypeEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfFileTypeEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListFileType(response: HttpResponseBase): Observable<ObjectEnumOfFileTypeEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfFileTypeEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfFileTypeEnum[] | null>(<any>null);
    }

    getListMucDoUuTienTinTucEnum(): Observable<ObjectEnumOfMucDoUuTienTinTucEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListMucDoUuTienTinTucEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListMucDoUuTienTinTucEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListMucDoUuTienTinTucEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfMucDoUuTienTinTucEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfMucDoUuTienTinTucEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListMucDoUuTienTinTucEnum(response: HttpResponseBase): Observable<ObjectEnumOfMucDoUuTienTinTucEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfMucDoUuTienTinTucEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfMucDoUuTienTinTucEnum[] | null>(<any>null);
    }

    getFileEnum(): Observable<ObjectEnumOfImageEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetFileEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfImageEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfImageEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileEnum(response: HttpResponseBase): Observable<ObjectEnumOfImageEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfImageEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfImageEnum[] | null>(<any>null);
    }

    getListLoaiHang(): Observable<ObjectEnumOfProductEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetListLoaiHang";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListLoaiHang(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListLoaiHang(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfProductEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfProductEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListLoaiHang(response: HttpResponseBase): Observable<ObjectEnumOfProductEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfProductEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfProductEnum[] | null>(<any>null);
    }

    getProductStatus(): Observable<ObjectEnumOfProductStatusEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetProductStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductStatus(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfProductStatusEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfProductStatusEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductStatus(response: HttpResponseBase): Observable<ObjectEnumOfProductStatusEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfProductStatusEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfProductStatusEnum[] | null>(<any>null);
    }

    getStoreEnum(): Observable<ObjectEnumOfStoreEnum[] | null> {
        let url_ = this.baseUrl + "/api/Common/GetStoreEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetStoreEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreEnum(<any>response_);
                } catch (e) {
                    return <Observable<ObjectEnumOfStoreEnum[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectEnumOfStoreEnum[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetStoreEnum(response: HttpResponseBase): Observable<ObjectEnumOfStoreEnum[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ObjectEnumOfStoreEnum.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectEnumOfStoreEnum[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CRMPhuongXaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    filterWithTag(req: FilterCrmPhuongXaWithTagRequest | null | undefined): Observable<CRM_PhuongXaDto[] | null> {
        let url_ = this.baseUrl + "/api/CRMPhuongXa/FilterWithTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFilterWithTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterWithTag(<any>response_);
                } catch (e) {
                    return <Observable<CRM_PhuongXaDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_PhuongXaDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processFilterWithTag(response: HttpResponseBase): Observable<CRM_PhuongXaDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CRM_PhuongXaDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_PhuongXaDto[] | null>(<any>null);
    }

    getDetail(maPhuongXa: string | null): Observable<CRM_PhuongXaDto | null> {
        let url_ = this.baseUrl + "/api/CRMPhuongXa/GetDetail?";
        if (maPhuongXa === undefined)
            throw new Error("The parameter 'maPhuongXa' must be defined.");
        else if (maPhuongXa !== null)
            url_ += "maPhuongXa=" + encodeURIComponent("" + maPhuongXa) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<CRM_PhuongXaDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_PhuongXaDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<CRM_PhuongXaDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CRM_PhuongXaDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_PhuongXaDto | null>(<any>null);
    }

    getAll(): Observable<CRM_PhuongXaDto[] | null> {
        let url_ = this.baseUrl + "/api/CRMPhuongXa/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CRM_PhuongXaDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_PhuongXaDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CRM_PhuongXaDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CRM_PhuongXaDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_PhuongXaDto[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CRMQuanHuyenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    filterWithTag(req: FilterCrmQuanHuyenWithTagRequest | null | undefined): Observable<CRM_QuanHuyenDto[] | null> {
        let url_ = this.baseUrl + "/api/CRMQuanHuyen/FilterWithTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFilterWithTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterWithTag(<any>response_);
                } catch (e) {
                    return <Observable<CRM_QuanHuyenDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_QuanHuyenDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processFilterWithTag(response: HttpResponseBase): Observable<CRM_QuanHuyenDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CRM_QuanHuyenDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_QuanHuyenDto[] | null>(<any>null);
    }

    getDetail(maQuanHuyen: string | null): Observable<CRM_QuanHuyenDto | null> {
        let url_ = this.baseUrl + "/api/CRMQuanHuyen/GetDetail?";
        if (maQuanHuyen === undefined)
            throw new Error("The parameter 'maQuanHuyen' must be defined.");
        else if (maQuanHuyen !== null)
            url_ += "maQuanHuyen=" + encodeURIComponent("" + maQuanHuyen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<CRM_QuanHuyenDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_QuanHuyenDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<CRM_QuanHuyenDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CRM_QuanHuyenDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_QuanHuyenDto | null>(<any>null);
    }

    getAll(): Observable<CRM_QuanHuyenDto[] | null> {
        let url_ = this.baseUrl + "/api/CRMQuanHuyen/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CRM_QuanHuyenDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_QuanHuyenDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CRM_QuanHuyenDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CRM_QuanHuyenDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_QuanHuyenDto[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CRMTinhThanhClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    filterWithTag(keySearch: string | null): Observable<CRM_TinhThanhDto[] | null> {
        let url_ = this.baseUrl + "/api/CRMTinhThanh/FilterWithTag?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFilterWithTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterWithTag(<any>response_);
                } catch (e) {
                    return <Observable<CRM_TinhThanhDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_TinhThanhDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processFilterWithTag(response: HttpResponseBase): Observable<CRM_TinhThanhDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CRM_TinhThanhDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_TinhThanhDto[] | null>(<any>null);
    }

    getDetail(maTinhThanh: string | null): Observable<CRM_TinhThanhDto | null> {
        let url_ = this.baseUrl + "/api/CRMTinhThanh/GetDetail?";
        if (maTinhThanh === undefined)
            throw new Error("The parameter 'maTinhThanh' must be defined.");
        else if (maTinhThanh !== null)
            url_ += "maTinhThanh=" + encodeURIComponent("" + maTinhThanh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<CRM_TinhThanhDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_TinhThanhDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<CRM_TinhThanhDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CRM_TinhThanhDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_TinhThanhDto | null>(<any>null);
    }

    getAll(): Observable<CRM_TinhThanhDto[] | null> {
        let url_ = this.baseUrl + "/api/CRMTinhThanh/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CRM_TinhThanhDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CRM_TinhThanhDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CRM_TinhThanhDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CRM_TinhThanhDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CRM_TinhThanhDto[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listCustomerPagination(request: GetListCategoryRequest | null | undefined): Observable<PaginatorResponseOfCustomerDto | null> {
        let url_ = this.baseUrl + "/api/Customer/ListCustomerPagination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListCustomerPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListCustomerPagination(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfCustomerDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfCustomerDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processListCustomerPagination(response: HttpResponseBase): Observable<PaginatorResponseOfCustomerDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfCustomerDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfCustomerDto | null>(<any>null);
    }

    getCustomerByKeySearch(keySearch: string | null): Observable<CustomerDto[] | null> {
        let url_ = this.baseUrl + "/api/Customer/GetCustomerByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerByKeySearch(response: HttpResponseBase): Observable<CustomerDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CustomerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[] | null>(<any>null);
    }

    xoaCustomer(request: DeleteModelRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer/XoaCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processXoaCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processXoaCustomer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processXoaCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    activeOrDeactive(resquest: ActiveDeactiveModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer/ActiveOrDeactive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resquest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActiveOrDeactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeactive(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActiveOrDeactive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getDetail(id: number): Observable<CustomerDto | null> {
        let url_ = this.baseUrl + "/api/Customer/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<CustomerDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CustomerDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto | null>(<any>null);
    }

    createOrUpdate(request: CreateCustomerRequest | null | undefined): Observable<string | null> {
        let url_ = this.baseUrl + "/api/Customer/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<string | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string | null>(<any>null);
    }

    checkIsCodeExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Customer/CheckIsCodeExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsCodeExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsCodeExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsCodeExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DailyExpenseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createReport(request: CreateDailyExpenseReportRequest | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/DailyExpense/CreateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReport(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateReport(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    updateReport(request: UpdateDailyExpenseReportRequest | null | undefined): Observable<DailyExpenseReportDto> {
        let url_ = this.baseUrl + "/api/DailyExpense/UpdateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReport(<any>response_);
                } catch (e) {
                    return <Observable<DailyExpenseReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DailyExpenseReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReport(response: HttpResponseBase): Observable<DailyExpenseReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DailyExpenseReportDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyExpenseReportDto>(<any>null);
    }

    deleteReport(id: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DailyExpense/DeleteReport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getReportDetail(id: number): Observable<DailyExpenseReportDto> {
        let url_ = this.baseUrl + "/api/DailyExpense/GetReportDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReportDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDetail(<any>response_);
                } catch (e) {
                    return <Observable<DailyExpenseReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DailyExpenseReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportDetail(response: HttpResponseBase): Observable<DailyExpenseReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DailyExpenseReportDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyExpenseReportDto>(<any>null);
    }

    getReportList(request: GetExpenseReportListRequest | null | undefined): Observable<PaginatorResponseOfDailyExpenseReportDto> {
        let url_ = this.baseUrl + "/api/DailyExpense/GetReportList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReportList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportList(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfDailyExpenseReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfDailyExpenseReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportList(response: HttpResponseBase): Observable<PaginatorResponseOfDailyExpenseReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaginatorResponseOfDailyExpenseReportDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfDailyExpenseReportDto>(<any>null);
    }

    addDetail(request: CreateExpenseDetailRequest | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/DailyExpense/AddDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDetail(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAddDetail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    updateDetail(request: UpdateExpenseDetailRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DailyExpense/UpdateDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDetail(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDetail(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deleteDetail(id: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DailyExpense/DeleteDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDetail(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDetail(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    submitReport(request: SubmitExpenseReportRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DailyExpense/SubmitReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitReport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    approveReport(request: ApproveExpenseReportRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DailyExpense/ApproveReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApproveReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveReport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processApproveReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    rejectReport(request: RejectExpenseReportRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DailyExpense/RejectReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRejectReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectReport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRejectReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getSummary(fromDate: Date, toDate: Date, storeId: number | null | undefined, employeeId: string | null | undefined): Observable<ExpenseSummaryResponse> {
        let url_ = this.baseUrl + "/api/DailyExpense/GetSummary?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (storeId !== undefined && storeId !== null)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseSummaryResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseSummaryResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<ExpenseSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ExpenseSummaryResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseSummaryResponse>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DanhMucQuocGiaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    list(request: GetListDanhMucQuocGiaRequest | null | undefined): Observable<PaginatorResponseOfDanhMucQuocGiaDto | null> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfDanhMucQuocGiaDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfDanhMucQuocGiaDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processList(response: HttpResponseBase): Observable<PaginatorResponseOfDanhMucQuocGiaDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfDanhMucQuocGiaDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfDanhMucQuocGiaDto | null>(<any>null);
    }

    create(request: CreateDanhMucQuocGiaRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    update(request: UpdateDanhMucQuocGiaRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    xoaDanhSachQuocGia(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/XoaDanhSachQuocGia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processXoaDanhSachQuocGia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processXoaDanhSachQuocGia(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processXoaDanhSachQuocGia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkTenQuocGiaExists(request: CheckTenQuocGiaExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/CheckTenQuocGiaExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckTenQuocGiaExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTenQuocGiaExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckTenQuocGiaExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getDanhMucQuocGiaByKeySearch(keySearch: string | null): Observable<DanhMucQuocGiaDto[] | null> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/GetDanhMucQuocGiaByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDanhMucQuocGiaByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDanhMucQuocGiaByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<DanhMucQuocGiaDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<DanhMucQuocGiaDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDanhMucQuocGiaByKeySearch(response: HttpResponseBase): Observable<DanhMucQuocGiaDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DanhMucQuocGiaDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DanhMucQuocGiaDto[] | null>(<any>null);
    }

    getDetail(id: number): Observable<DanhMucQuocGiaDto | null> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<DanhMucQuocGiaDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<DanhMucQuocGiaDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<DanhMucQuocGiaDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DanhMucQuocGiaDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DanhMucQuocGiaDto | null>(<any>null);
    }

    getListDanhMucQuocGia(): Observable<DanhMucQuocGiaDto[] | null> {
        let url_ = this.baseUrl + "/api/DanhMucQuocGia/GetListDanhMucQuocGia";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListDanhMucQuocGia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListDanhMucQuocGia(<any>response_);
                } catch (e) {
                    return <Observable<DanhMucQuocGiaDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<DanhMucQuocGiaDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListDanhMucQuocGia(response: HttpResponseBase): Observable<DanhMucQuocGiaDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DanhMucQuocGiaDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DanhMucQuocGiaDto[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DanhMucThanhPhoQuanHuyenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(request: CreateDanhMucThanhPhoQuanHuyenRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DanhMucThanhPhoQuanHuyen/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    update(request: UpdateDanhMucThanhPhoQuanHuyenRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DanhMucThanhPhoQuanHuyen/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DanhMucThanhPhoQuanHuyen/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkTenThanhPhoQuanHuyenExists(request: CheckTenThanhPhoQuanHuyenExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DanhMucThanhPhoQuanHuyen/CheckTenThanhPhoQuanHuyenExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckTenThanhPhoQuanHuyenExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTenThanhPhoQuanHuyenExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckTenThanhPhoQuanHuyenExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    filterWithTag(request: FilterWithTagDanhMucThanhPhoQuanHuyenRequest | null | undefined): Observable<DanhMucThanhPhoQuanHuyenDto[] | null> {
        let url_ = this.baseUrl + "/api/DanhMucThanhPhoQuanHuyen/FilterWithTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFilterWithTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterWithTag(<any>response_);
                } catch (e) {
                    return <Observable<DanhMucThanhPhoQuanHuyenDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<DanhMucThanhPhoQuanHuyenDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processFilterWithTag(response: HttpResponseBase): Observable<DanhMucThanhPhoQuanHuyenDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DanhMucThanhPhoQuanHuyenDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DanhMucThanhPhoQuanHuyenDto[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    dataChartSale(request: ChartRequestModel | null | undefined): Observable<ChartResponseModel | null> {
        let url_ = this.baseUrl + "/api/Dashboard/DataChartSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDataChartSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataChartSale(<any>response_);
                } catch (e) {
                    return <Observable<ChartResponseModel | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChartResponseModel | null>><any>_observableThrow(response_);
        }));
    }

    protected processDataChartSale(response: HttpResponseBase): Observable<ChartResponseModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ChartResponseModel.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChartResponseModel | null>(<any>null);
    }

    dataChartSaleTop10(request: ChartRequestModel | null | undefined): Observable<ChartResponseModel | null> {
        let url_ = this.baseUrl + "/api/Dashboard/DataChartSaleTop10";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDataChartSaleTop10(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataChartSaleTop10(<any>response_);
                } catch (e) {
                    return <Observable<ChartResponseModel | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChartResponseModel | null>><any>_observableThrow(response_);
        }));
    }

    protected processDataChartSaleTop10(response: HttpResponseBase): Observable<ChartResponseModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ChartResponseModel.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChartResponseModel | null>(<any>null);
    }

    getNegativeSaleItems(request: ChartRequestModel | null | undefined): Observable<{ count: number; totalNegativeAmount: number; items: NegativeSaleItemResponse[] } | null> {
        let url_ = this.baseUrl + "/api/Dashboard/NegativeSaleItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNegativeSaleItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNegativeSaleItems(<any>response_);
                } catch (e) {
                    return <Observable<{ count: number; totalNegativeAmount: number; items: NegativeSaleItemResponse[] } | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<{ count: number; totalNegativeAmount: number; items: NegativeSaleItemResponse[] } | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetNegativeSaleItems(response: HttpResponseBase): Observable<{ count: number; totalNegativeAmount: number; items: NegativeSaleItemResponse[] } | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const result200 = {
                    count: resultData200?.Count ?? 0,
                    totalNegativeAmount: resultData200?.TotalMoney ?? 0,
                    items: Array.isArray(resultData200?.Items)
                        ? resultData200.Items.map((item: any) => NegativeSaleItemResponse.fromJS(item))
                        : []
                };
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ count: number; totalNegativeAmount: number; items: NegativeSaleItemResponse[] } | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmailSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEmailSettings(): Observable<EmailSettingsResponse> {
        let url_ = this.baseUrl + "/api/email-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailSettings(<any>response_);
                } catch (e) {
                    return <Observable<EmailSettingsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailSettingsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailSettings(response: HttpResponseBase): Observable<EmailSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmailSettingsResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSettingsResponse>(<any>null);
    }

    saveEmailSettings(dto: EmailSettingsDto | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/email-settings/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmailSettings(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSaveEmailSettings(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    testEmail(request: TestEmailRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/email-settings/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTestEmail(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deleteEmailSettings(id: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/email-settings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEmailSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmailSettings(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEmailSettings(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExpenseCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createCategory(request: CreateExpenseCategoryRequest | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/CreateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCategory(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCategory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    updateCategory(request: UpdateExpenseCategoryRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/UpdateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategory(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCategory(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deleteCategory(id: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/DeleteCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getCategoryDetail(id: number): Observable<ExpenseCategoryDto> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/GetCategoryDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoryDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryDetail(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryDetail(response: HttpResponseBase): Observable<ExpenseCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ExpenseCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseCategoryDto>(<any>null);
    }

    getAllCategories(includeInactive: boolean | undefined, categoryType: string | null | undefined): Observable<ExpenseCategoryDto[]> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/GetAllCategories?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (categoryType !== undefined && categoryType !== null)
            url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategories(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseCategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseCategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCategories(response: HttpResponseBase): Observable<ExpenseCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ExpenseCategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseCategoryDto[]>(<any>null);
    }

    getCategoriesByParent(parentId: number | null | undefined, categoryType: string | null | undefined): Observable<ExpenseCategoryDto[]> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/GetCategoriesByParent?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (categoryType !== undefined && categoryType !== null)
            url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoriesByParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesByParent(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseCategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseCategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoriesByParent(response: HttpResponseBase): Observable<ExpenseCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ExpenseCategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseCategoryDto[]>(<any>null);
    }

    getCategoryTree(categoryType: string | null | undefined): Observable<ExpenseCategoryTreeResponse[]> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/GetCategoryTree?";
        if (categoryType !== undefined && categoryType !== null)
            url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoryTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryTree(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseCategoryTreeResponse[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseCategoryTreeResponse[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryTree(response: HttpResponseBase): Observable<ExpenseCategoryTreeResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ExpenseCategoryTreeResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseCategoryTreeResponse[]>(<any>null);
    }

    searchCategories(keyword: string | null, categoryType: string | null | undefined): Observable<ExpenseCategoryDto[]> {
        let url_ = this.baseUrl + "/api/ExpenseCategory/SearchCategories?";
        if (keyword === undefined)
            throw new Error("The parameter 'keyword' must be defined.");
        else if (keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (categoryType !== undefined && categoryType !== null)
            url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCategories(<any>response_);
                } catch (e) {
                    return <Observable<ExpenseCategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExpenseCategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processSearchCategories(response: HttpResponseBase): Observable<ExpenseCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ExpenseCategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpenseCategoryDto[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    upload(): Observable<UploadImageResponse | null> {
        let url_ = this.baseUrl + "/api/File/Upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<UploadImageResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadImageResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadImageResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UploadImageResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadImageResponse | null>(<any>null);
    }

    uploadFiles(): Observable<UploadImageResponse[] | null> {
        let url_ = this.baseUrl + "/api/File/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(<any>response_);
                } catch (e) {
                    return <Observable<UploadImageResponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadImageResponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<UploadImageResponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(UploadImageResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadImageResponse[] | null>(<any>null);
    }

    getFile(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/File/GetFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    ckEditorUploadImage(): Observable<CkEditorUploadFileResponse | null> {
        let url_ = this.baseUrl + "/api/File/CkEditorUploadImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCkEditorUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCkEditorUploadImage(<any>response_);
                } catch (e) {
                    return <Observable<CkEditorUploadFileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CkEditorUploadFileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCkEditorUploadImage(response: HttpResponseBase): Observable<CkEditorUploadFileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CkEditorUploadFileResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CkEditorUploadFileResponse | null>(<any>null);
    }

    getFileUpload(id: string): Observable<FileUploadResponse | null> {
        let url_ = this.baseUrl + "/api/File/GetFileUpload/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileUpload(<any>response_);
                } catch (e) {
                    return <Observable<FileUploadResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileUploadResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileUpload(response: HttpResponseBase): Observable<FileUploadResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileUploadResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileUploadResponse | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ManufacturerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getManufacturerByKeySearch(keySearch: string | null): Observable<ManufacturerDto[] | null> {
        let url_ = this.baseUrl + "/api/Manufacturer/GetManufacturerByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetManufacturerByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManufacturerByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<ManufacturerDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ManufacturerDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetManufacturerByKeySearch(response: HttpResponseBase): Observable<ManufacturerDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ManufacturerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManufacturerDto[] | null>(<any>null);
    }

    create(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Manufacturer/Create?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else if (name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkManufacturerNameExists(request: CheckNameExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Manufacturer/CheckManufacturerNameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckManufacturerNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckManufacturerNameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckManufacturerNameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getDetail(id: number): Observable<ManufacturerDto | null> {
        let url_ = this.baseUrl + "/api/Manufacturer/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<ManufacturerDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ManufacturerDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<ManufacturerDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ManufacturerDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManufacturerDto | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MonitoringClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDashboardStats(fromDate: Date | null | undefined, toDate: Date | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring/GetDashboardStats?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboardStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardStats(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardStats(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getLogs(filter: MonitoringLogFilter | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring/GetLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogs(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetLogs(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getTimeSeries(fromDate: Date, toDate: Date, groupBy: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring/GetTimeSeries?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (groupBy !== undefined && groupBy !== null)
            url_ += "groupBy=" + encodeURIComponent("" + groupBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimeSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeSeries(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimeSeries(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getTopApis(fromDate: Date | null | undefined, toDate: Date | null | undefined, top: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring/GetTopApis?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTopApis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopApis(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopApis(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getRecentErrors(count: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring/GetRecentErrors?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRecentErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentErrors(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentErrors(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deleteOldLogs(daysToKeep: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring/DeleteOldLogs?";
        if (daysToKeep === null)
            throw new Error("The parameter 'daysToKeep' cannot be null.");
        else if (daysToKeep !== undefined)
            url_ += "daysToKeep=" + encodeURIComponent("" + daysToKeep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteOldLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOldLogs(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOldLogs(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getRecaptchaQuota(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring/GetRecaptchaQuota";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRecaptchaQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecaptchaQuota(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecaptchaQuota(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    testSendToAdmin(message: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification/test-admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestSendToAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestSendToAdmin(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTestSendToAdmin(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    testSendToAll(message: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification/test-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestSendToAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestSendToAll(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTestSendToAll(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getUnreadCount(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification/unread-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUnreadCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadCount(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnreadCount(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getList(pageIndex: number | undefined, pageSize: number | undefined, onlyUnread: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification/list?";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (onlyUnread === null)
            throw new Error("The parameter 'onlyUnread' cannot be null.");
        else if (onlyUnread !== undefined)
            url_ += "onlyUnread=" + encodeURIComponent("" + onlyUnread) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    markAsRead(request: MarkAsReadRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification/mark-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    delete(request: DeleteNotificationRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deleteBulk(request: DeleteBulkNotificationRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification/delete-bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulk(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBulk(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationFirebaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    registerFirebaseToken(request: RegisterTokenRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification-firebase/register-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegisterFirebaseToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterFirebaseToken(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterFirebaseToken(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    unregisterFirebaseToken(firebaseToken: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/notification-firebase/unregister-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(firebaseToken);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnregisterFirebaseToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnregisterFirebaseToken(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUnregisterFirebaseToken(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrderCustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listAll(request: OrderCustomerSearchModel | null | undefined): Observable<ListOrderCustomerResponseModel[] | null> {
        let url_ = this.baseUrl + "/api/OrderCustomer/ListAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListAll(<any>response_);
                } catch (e) {
                    return <Observable<ListOrderCustomerResponseModel[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListOrderCustomerResponseModel[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processListAll(response: HttpResponseBase): Observable<ListOrderCustomerResponseModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListOrderCustomerResponseModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListOrderCustomerResponseModel[] | null>(<any>null);
    }

    exportExcel(request: OrderCustomerSearchModel | null | undefined): Observable<ListOrderCustomerResponseModel[] | null> {
        let url_ = this.baseUrl + "/api/OrderCustomer/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(<any>response_);
                } catch (e) {
                    return <Observable<ListOrderCustomerResponseModel[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListOrderCustomerResponseModel[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<ListOrderCustomerResponseModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ListOrderCustomerResponseModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListOrderCustomerResponseModel[] | null>(<any>null);
    }

    cancelOrderCustomer(orderCustomerId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderCustomer/CancelOrderCustomer?";
        if (orderCustomerId === undefined || orderCustomerId === null)
            throw new Error("The parameter 'orderCustomerId' must be defined and cannot be null.");
        else
            url_ += "orderCustomerId=" + encodeURIComponent("" + orderCustomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelOrderCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelOrderCustomer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelOrderCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    lstOrderForCustomer(request: OrderCustomerSearchModel | null | undefined): Observable<PaginatorResponseOfListOrderCustomerResponseModel | null> {
        let url_ = this.baseUrl + "/api/OrderCustomer/LstOrderForCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLstOrderForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLstOrderForCustomer(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfListOrderCustomerResponseModel | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfListOrderCustomerResponseModel | null>><any>_observableThrow(response_);
        }));
    }

    protected processLstOrderForCustomer(response: HttpResponseBase): Observable<PaginatorResponseOfListOrderCustomerResponseModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfListOrderCustomerResponseModel.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfListOrderCustomerResponseModel | null>(<any>null);
    }

    listOrderItemCustomer(request: OrderItemRequestSearchModel | null | undefined): Observable<PaginatorResponseOfListOrderItemResponseModel | null> {
        let url_ = this.baseUrl + "/api/OrderCustomer/ListOrderItemCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListOrderItemCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListOrderItemCustomer(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfListOrderItemResponseModel | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfListOrderItemResponseModel | null>><any>_observableThrow(response_);
        }));
    }

    protected processListOrderItemCustomer(response: HttpResponseBase): Observable<PaginatorResponseOfListOrderItemResponseModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfListOrderItemResponseModel.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfListOrderItemResponseModel | null>(<any>null);
    }

    listOrderCustomer(request: OrderCustomerSearchModel | null | undefined): Observable<PaginatorResponseOfListOrderCustomerResponseModel | null> {
        let url_ = this.baseUrl + "/api/OrderCustomer/ListOrderCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListOrderCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListOrderCustomer(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfListOrderCustomerResponseModel | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfListOrderCustomerResponseModel | null>><any>_observableThrow(response_);
        }));
    }

    protected processListOrderCustomer(response: HttpResponseBase): Observable<PaginatorResponseOfListOrderCustomerResponseModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfListOrderCustomerResponseModel.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfListOrderCustomerResponseModel | null>(<any>null);
    }

    getDetail(orderCustomerId: string | null): Observable<OrderCustomerDto | null> {
        let url_ = this.baseUrl + "/api/OrderCustomer/GetDetail?";
        if (orderCustomerId === undefined)
            throw new Error("The parameter 'orderCustomerId' must be defined.");
        else if (orderCustomerId !== null)
            url_ += "orderCustomerId=" + encodeURIComponent("" + orderCustomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<OrderCustomerDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCustomerDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<OrderCustomerDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OrderCustomerDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCustomerDto | null>(<any>null);
    }

    updateInfoOrder(request: OrderInfoModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderCustomer/UpdateInfoOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateInfoOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfoOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateInfoOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    deleteOrderItem(orderItemId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderCustomer/DeleteOrderItem?";
        if (orderItemId === undefined || orderItemId === null)
            throw new Error("The parameter 'orderItemId' must be defined and cannot be null.");
        else
            url_ += "orderItemId=" + encodeURIComponent("" + orderItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrderItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    addOrUpdate(request: AddOrUpdateOrderItemCustomerModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderCustomer/AddOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    create(request: OrderCustomerModel | null | undefined): Observable<string | null> {
        let url_ = this.baseUrl + "/api/OrderCustomer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<string | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string | null>(<any>null);
    }

    processPartialPayment(request: PartialPaymentRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderCustomer/ProcessPartialPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProcessPartialPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessPartialPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProcessPartialPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    delete(orderCustomerId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OrderCustomer/Delete?";
        if (orderCustomerId === undefined || orderCustomerId === null)
            throw new Error("The parameter 'orderCustomerId' must be defined and cannot be null.");
        else
            url_ += "orderCustomerId=" + encodeURIComponent("" + orderCustomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentMethodClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllPaymentMethods(includeInactive: boolean | undefined): Observable<PaymentMethodDto[]> {
        let url_ = this.baseUrl + "/api/PaymentMethod/GetAllPaymentMethods?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPaymentMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaymentMethods(<any>response_);
                } catch (e) {
                    return <Observable<PaymentMethodDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPaymentMethods(response: HttpResponseBase): Observable<PaymentMethodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(PaymentMethodDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto[]>(<any>null);
    }

    getPaymentMethodByCode(code: string | null): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/api/PaymentMethod/GetPaymentMethodByCode?";
        if (code === undefined)
            throw new Error("The parameter 'code' must be defined.");
        else if (code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentMethodByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentMethodByCode(<any>response_);
                } catch (e) {
                    return <Observable<PaymentMethodDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentMethodByCode(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentMethodDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto>(<any>null);
    }

    createPaymentMethod(request: CreatePaymentMethodRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PaymentMethod/CreatePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePaymentMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentMethod(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentMethod(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    updatePaymentMethod(request: UpdatePaymentMethodRequest | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PaymentMethod/UpdatePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePaymentMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentMethod(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePaymentMethod(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deletePaymentMethod(id: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PaymentMethod/DeletePaymentMethod/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePaymentMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaymentMethod(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePaymentMethod(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PermissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllMenuCMS(): Observable<CmsMenu[] | null> {
        let url_ = this.baseUrl + "/api/Permission/GetAllMenuCMS";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllMenuCMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMenuCMS(<any>response_);
                } catch (e) {
                    return <Observable<CmsMenu[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CmsMenu[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMenuCMS(response: HttpResponseBase): Observable<CmsMenu[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CmsMenu.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsMenu[] | null>(<any>null);
    }

    getMenusForCMS(): Observable<CmsMenu[] | null> {
        let url_ = this.baseUrl + "/api/Permission/GetMenusForCMS";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMenusForCMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenusForCMS(<any>response_);
                } catch (e) {
                    return <Observable<CmsMenu[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CmsMenu[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenusForCMS(response: HttpResponseBase): Observable<CmsMenu[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CmsMenu.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsMenu[] | null>(<any>null);
    }

    setPermissionRole(request: SetPermissionRoleRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Permission/SetPermissionRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetPermissionRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPermissionRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetPermissionRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    setPermissionAccount(request: SetPermissionAccountRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Permission/SetPermissionAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetPermissionAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPermissionAccount(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetPermissionAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getMenuCMSForManagerRole(role: RoleEnum | null): Observable<CmsMenu[] | null> {
        let url_ = this.baseUrl + "/api/Permission/GetMenuCMSForManagerRole?";
        if (role === undefined)
            throw new Error("The parameter 'role' must be defined.");
        else if (role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMenuCMSForManagerRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenuCMSForManagerRole(<any>response_);
                } catch (e) {
                    return <Observable<CmsMenu[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CmsMenu[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenuCMSForManagerRole(response: HttpResponseBase): Observable<CmsMenu[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CmsMenu.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsMenu[] | null>(<any>null);
    }

    getMenuCMSForManagerAccount(accountId: string | null): Observable<CmsMenu[] | null> {
        let url_ = this.baseUrl + "/api/Permission/GetMenuCMSForManagerAccount?";
        if (accountId === undefined)
            throw new Error("The parameter 'accountId' must be defined.");
        else if (accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMenuCMSForManagerAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMenuCMSForManagerAccount(<any>response_);
                } catch (e) {
                    return <Observable<CmsMenu[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<CmsMenu[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenuCMSForManagerAccount(response: HttpResponseBase): Observable<CmsMenu[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CmsMenu.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsMenu[] | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PositionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPositionByKeySearch(keySearch: string | null): Observable<PositionDto[] | null> {
        let url_ = this.baseUrl + "/api/Position/GetPositionByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPositionByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<PositionDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PositionDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetPositionByKeySearch(response: HttpResponseBase): Observable<PositionDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(PositionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PositionDto[] | null>(<any>null);
    }

    create(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Position/Create?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else if (name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkPositionNameExists(request: CheckNameExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Position/CheckPositionNameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckPositionNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPositionNameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckPositionNameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getDetail(id: number): Observable<PositionDto | null> {
        let url_ = this.baseUrl + "/api/Position/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<PositionDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PositionDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<PositionDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PositionDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PositionDto | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProductByKeySearch(keySearch: string | null, isHomepage: boolean | null | undefined, isSearchBuDon: boolean | null | undefined, pageIndex: number | undefined): Observable<ProductDto[] | null> {
        let url_ = this.baseUrl + "/api/Product/GetProductByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        if (isHomepage !== undefined && isHomepage !== null)
            url_ += "isHomepage=" + encodeURIComponent("" + isHomepage) + "&";
        if (isSearchBuDon !== undefined && isSearchBuDon !== null)
            url_ += "isSearchBuDon=" + encodeURIComponent("" + isSearchBuDon) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductByKeySearch(response: HttpResponseBase): Observable<ProductDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[] | null>(<any>null);
    }

    listProduct(request: GetListProductRequest | null | undefined): Observable<PaginatorResponseOfGetListProductResponse | null> {
        let url_ = this.baseUrl + "/api/Product/ListProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListProduct(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfGetListProductResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfGetListProductResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processListProduct(response: HttpResponseBase): Observable<PaginatorResponseOfGetListProductResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfGetListProductResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfGetListProductResponse | null>(<any>null);
    }

    listAll(request: GetListProductRequest | null | undefined): Observable<ProductsInfoCountResponse | null> {
        let url_ = this.baseUrl + "/api/Product/ListAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListAll(<any>response_);
                } catch (e) {
                    return <Observable<ProductsInfoCountResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductsInfoCountResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processListAll(response: HttpResponseBase): Observable<ProductsInfoCountResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ProductsInfoCountResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductsInfoCountResponse | null>(<any>null);
    }

    checkProductInventoryWrong(request: GetListProductRequest | null | undefined): Observable<PaginatorResponseOfGetListProductResponse | null> {
        let url_ = this.baseUrl + "/api/Product/CheckProductInventoryWrong";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckProductInventoryWrong(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProductInventoryWrong(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfGetListProductResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfGetListProductResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCheckProductInventoryWrong(response: HttpResponseBase): Observable<PaginatorResponseOfGetListProductResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfGetListProductResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfGetListProductResponse | null>(<any>null);
    }

    listPurchaseOrderHistory(request: ListPurchaseOrderHistoryRequest | null | undefined): Observable<PaginatorResponseOfListPurchaseOrderHistory | null> {
        let url_ = this.baseUrl + "/api/Product/ListPurchaseOrderHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListPurchaseOrderHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPurchaseOrderHistory(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfListPurchaseOrderHistory | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfListPurchaseOrderHistory | null>><any>_observableThrow(response_);
        }));
    }

    protected processListPurchaseOrderHistory(response: HttpResponseBase): Observable<PaginatorResponseOfListPurchaseOrderHistory | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfListPurchaseOrderHistory.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfListPurchaseOrderHistory | null>(<any>null);
    }

    listSaleDateHistory(request: ListSaleDateHistoryRequest | null | undefined): Observable<PaginatorResponseOfListSaleDateHistoryResponse | null> {
        let url_ = this.baseUrl + "/api/Product/ListSaleDateHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListSaleDateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListSaleDateHistory(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfListSaleDateHistoryResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfListSaleDateHistoryResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processListSaleDateHistory(response: HttpResponseBase): Observable<PaginatorResponseOfListSaleDateHistoryResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfListSaleDateHistoryResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfListSaleDateHistoryResponse | null>(<any>null);
    }

    listAllProductByIds(request: ListProductByCategoryRequest | null | undefined): Observable<GetListProductResponse[] | null> {
        let url_ = this.baseUrl + "/api/Product/ListAllProductByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListAllProductByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListAllProductByIds(<any>response_);
                } catch (e) {
                    return <Observable<GetListProductResponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetListProductResponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processListAllProductByIds(response: HttpResponseBase): Observable<GetListProductResponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(GetListProductResponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetListProductResponse[] | null>(<any>null);
    }

    updateDelete(productId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Product/UpdateDelete?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    updateDeleteList(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Product/UpdateDeleteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeleteList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDeleteList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    updateStatus(productId: string, status: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Product/UpdateStatus?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    createOrUpdate(request: ProductRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Product/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getDetail(productId: string): Observable<GetListProductResponse | null> {
        let url_ = this.baseUrl + "/api/Product/GetDetail?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetListProductResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetListProductResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<GetListProductResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetListProductResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetListProductResponse | null>(<any>null);
    }

    checkIsCodeExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Product/CheckIsCodeExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsCodeExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsCodeExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsCodeExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsBarCodeExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Product/CheckIsBarCodeExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsBarCodeExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsBarCodeExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsBarCodeExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsRegistrationNumberExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Product/CheckIsRegistrationNumberExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsRegistrationNumberExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsRegistrationNumberExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsRegistrationNumberExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsAbbreviationsExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Product/CheckIsAbbreviationsExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsAbbreviationsExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsAbbreviationsExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsAbbreviationsExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsTitleExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Product/CheckIsTitleExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsTitleExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsTitleExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsTitleExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProductPickupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listProductPickup(request: GetListProductPickupRequest | null | undefined): Observable<PaginatorResponseOfGetListProductPickupResponse | null> {
        let url_ = this.baseUrl + "/api/ProductPickup/ListProductPickup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListProductPickup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListProductPickup(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfGetListProductPickupResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfGetListProductPickupResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processListProductPickup(response: HttpResponseBase): Observable<PaginatorResponseOfGetListProductPickupResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfGetListProductPickupResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfGetListProductPickupResponse | null>(<any>null);
    }

    deleteProductPickup(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ProductPickup/DeleteProductPickup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProductPickup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductPickup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteProductPickup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getDetail(id: string, productId: string | null | undefined): Observable<ProductPickupDto | null> {
        let url_ = this.baseUrl + "/api/ProductPickup/GetDetail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<ProductPickupDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductPickupDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<ProductPickupDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ProductPickupDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPickupDto | null>(<any>null);
    }

    quickUpdateProductPickup(request: QuickUpdateProductPickupRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ProductPickup/QuickUpdateProductPickup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processQuickUpdateProductPickup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickUpdateProductPickup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processQuickUpdateProductPickup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    taoPhieuBuHang(request: CreateProductPickupRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ProductPickup/TaoPhieuBuHang";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTaoPhieuBuHang(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaoPhieuBuHang(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTaoPhieuBuHang(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getSupplierPayments(productPickupId: string): Observable<SupplierPaymentDto[] | null> {
        let url_ = this.baseUrl + "/api/ProductPickup/GetSupplierPayments?";
        if (productPickupId === undefined || productPickupId === null)
            throw new Error("The parameter 'productPickupId' must be defined and cannot be null.");
        else
            url_ += "productPickupId=" + encodeURIComponent("" + productPickupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSupplierPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierPayments(<any>response_);
                } catch (e) {
                    return <Observable<SupplierPaymentDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierPaymentDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupplierPayments(response: HttpResponseBase): Observable<SupplierPaymentDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SupplierPaymentDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierPaymentDto[] | null>(<any>null);
    }

    updateSupplierPayment(request: UpdateSupplierPaymentRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ProductPickup/UpdateSupplierPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSupplierPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplierPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSupplierPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProductUnitClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProductUnitByKeySearch(keySearch: string | null): Observable<ProductUnitDto[] | null> {
        let url_ = this.baseUrl + "/api/ProductUnit/GetProductUnitByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductUnitByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductUnitByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<ProductUnitDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductUnitDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductUnitByKeySearch(response: HttpResponseBase): Observable<ProductUnitDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ProductUnitDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductUnitDto[] | null>(<any>null);
    }

    create(name: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/ProductUnit/Create?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else if (name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkProductUnitNameExists(request: CheckNameExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ProductUnit/CheckProductUnitNameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckProductUnitNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProductUnitNameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckProductUnitNameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getDetail(id: number): Observable<ProductUnitDto | null> {
        let url_ = this.baseUrl + "/api/ProductUnit/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<ProductUnitDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductUnitDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<ProductUnitDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ProductUnitDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductUnitDto | null>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PurchaseOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listPurchaseOrder(request: SearchPurchaseOrderRequest | null | undefined): Observable<PaginatorResponseOfListPurchaseOrderResponse | null> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/ListPurchaseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListPurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPurchaseOrder(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfListPurchaseOrderResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfListPurchaseOrderResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processListPurchaseOrder(response: HttpResponseBase): Observable<PaginatorResponseOfListPurchaseOrderResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfListPurchaseOrderResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfListPurchaseOrderResponse | null>(<any>null);
    }

    listPurchaseOrderItems(request: SearchPurchaseOrderItemsRequest | null | undefined): Observable<PaginatorResponseOfPurchaseOrderItemDto | null> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/ListPurchaseOrderItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListPurchaseOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPurchaseOrderItems(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfPurchaseOrderItemDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfPurchaseOrderItemDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processListPurchaseOrderItems(response: HttpResponseBase): Observable<PaginatorResponseOfPurchaseOrderItemDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfPurchaseOrderItemDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfPurchaseOrderItemDto | null>(<any>null);
    }

    getDetail(id: string): Observable<PurchaseOrderDto | null> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/GetDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<PurchaseOrderDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PurchaseOrderDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<PurchaseOrderDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PurchaseOrderDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderDto | null>(<any>null);
    }

    cancelPurchaseOrder(purchaserOrderId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/CancelPurchaseOrder?";
        if (purchaserOrderId === undefined || purchaserOrderId === null)
            throw new Error("The parameter 'purchaserOrderId' must be defined and cannot be null.");
        else
            url_ += "purchaserOrderId=" + encodeURIComponent("" + purchaserOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelPurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPurchaseOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPurchaseOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    createOrUpdate(request: CreatePurchaseOrderRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getListPaymentHistory(purchaseOrderId: string | null | undefined, orderCustomerId: string | null | undefined): Observable<PaymentHistoryReponse[] | null> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/GetListPaymentHistory?";
        if (purchaseOrderId !== undefined && purchaseOrderId !== null)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (orderCustomerId !== undefined && orderCustomerId !== null)
            url_ += "orderCustomerId=" + encodeURIComponent("" + orderCustomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListPaymentHistory(<any>response_);
                } catch (e) {
                    return <Observable<PaymentHistoryReponse[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentHistoryReponse[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListPaymentHistory(response: HttpResponseBase): Observable<PaymentHistoryReponse[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(PaymentHistoryReponse.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentHistoryReponse[] | null>(<any>null);
    }

    updateNote(request: UpdatePurchaseOrderNoteRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/updateNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    update(request: UpdatePurchaseOrderRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkIsCodeExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PurchaseOrder/CheckIsCodeExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsCodeExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsCodeExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsCodeExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReceiptBookClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listReceiptBookItemPagination(request: ListReceiptBookItemRequest | null | undefined): Observable<PaginatorResponseOfListReceiptBookItemResponse | null> {
        let url_ = this.baseUrl + "/api/ReceiptBook/ListReceiptBookItemPagination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListReceiptBookItemPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListReceiptBookItemPagination(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfListReceiptBookItemResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfListReceiptBookItemResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processListReceiptBookItemPagination(response: HttpResponseBase): Observable<PaginatorResponseOfListReceiptBookItemResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfListReceiptBookItemResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfListReceiptBookItemResponse | null>(<any>null);
    }

    listProductPickupCategory(request: ListReceiptBookCategoryRequest | null | undefined): Observable<PaginatorResponseOfProductPickupResponse | null> {
        let url_ = this.baseUrl + "/api/ReceiptBook/ListProductPickupCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListProductPickupCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListProductPickupCategory(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfProductPickupResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfProductPickupResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processListProductPickupCategory(response: HttpResponseBase): Observable<PaginatorResponseOfProductPickupResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfProductPickupResponse.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfProductPickupResponse | null>(<any>null);
    }

    deletedReceiptCategory(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ReceiptBook/DeletedReceiptCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletedReceiptCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletedReceiptCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletedReceiptCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    updateReceiptBookItem(request: UpdateReceiptBookItemRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReceiptBook/UpdateReceiptBookItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateReceiptBookItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceiptBookItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReceiptBookItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getReceiptBookCategory(keySearch: string | null): Observable<ReceiptBookCategoryDto[] | null> {
        let url_ = this.baseUrl + "/api/ReceiptBook/GetReceiptBookCategory?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReceiptBookCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptBookCategory(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptBookCategoryDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptBookCategoryDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceiptBookCategory(response: HttpResponseBase): Observable<ReceiptBookCategoryDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ReceiptBookCategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptBookCategoryDto[] | null>(<any>null);
    }

    createOrUpdateReceiptBookCreateGory(request: AddOrUpdateReceiptBookCategoryRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReceiptBook/CreateOrUpdateReceiptBookCreateGory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateReceiptBookCreateGory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateReceiptBookCreateGory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateReceiptBookCreateGory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    checkReceiptCategoryNameExists(request: CheckNameExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ReceiptBook/CheckReceiptCategoryNameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckReceiptCategoryNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckReceiptCategoryNameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckReceiptCategoryNameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getDetailReceiptBookCategory(receiptBookCategoryServiceId: string | null): Observable<ReceiptBookCategoryDto | null> {
        let url_ = this.baseUrl + "/api/ReceiptBook/GetDetailReceiptBookCategory?";
        if (receiptBookCategoryServiceId === undefined)
            throw new Error("The parameter 'receiptBookCategoryServiceId' must be defined.");
        else if (receiptBookCategoryServiceId !== null)
            url_ += "receiptBookCategoryServiceId=" + encodeURIComponent("" + receiptBookCategoryServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetailReceiptBookCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailReceiptBookCategory(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptBookCategoryDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptBookCategoryDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetailReceiptBookCategory(response: HttpResponseBase): Observable<ReceiptBookCategoryDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ReceiptBookCategoryDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptBookCategoryDto | null>(<any>null);
    }

    deleteReceiptBookItem(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ReceiptBook/DeleteReceiptBookItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteReceiptBookItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReceiptBookItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteReceiptBookItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    createReceiptBookItem(request: ReceiptBookItemRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReceiptBook/CreateReceiptBookItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateReceiptBookItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReceiptBookItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateReceiptBookItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SupplierClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSupplierByKeySearch(keySearch: string | null, type: number | null | undefined): Observable<SupplierDto[] | null> {
        let url_ = this.baseUrl + "/api/Supplier/GetSupplierByKeySearch?";
        if (keySearch === undefined)
            throw new Error("The parameter 'keySearch' must be defined.");
        else if (keySearch !== null)
            url_ += "keySearch=" + encodeURIComponent("" + keySearch) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSupplierByKeySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierByKeySearch(<any>response_);
                } catch (e) {
                    return <Observable<SupplierDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupplierByKeySearch(response: HttpResponseBase): Observable<SupplierDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SupplierDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierDto[] | null>(<any>null);
    }

    listSupplierPagination(request: GetListCategoryRequest | null | undefined): Observable<PaginatorResponseOfSupplierDto | null> {
        let url_ = this.baseUrl + "/api/Supplier/ListSupplierPagination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListSupplierPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListSupplierPagination(<any>response_);
                } catch (e) {
                    return <Observable<PaginatorResponseOfSupplierDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginatorResponseOfSupplierDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processListSupplierPagination(response: HttpResponseBase): Observable<PaginatorResponseOfSupplierDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaginatorResponseOfSupplierDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginatorResponseOfSupplierDto | null>(<any>null);
    }

    createOrUpdate(request: CreateSupplierRequest | null | undefined): Observable<string | null> {
        let url_ = this.baseUrl + "/api/Supplier/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<string | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<string | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string | null>(<any>null);
    }

    xoaSupplier(request: DeleteModelRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplier/XoaSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processXoaSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processXoaSupplier(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processXoaSupplier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    activeOrDeactive(resquest: ActiveDeactiveModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Supplier/ActiveOrDeactive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resquest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActiveOrDeactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveOrDeactive(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActiveOrDeactive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    get(supplierId: number | null): Observable<SupplierDto | null> {
        let url_ = this.baseUrl + "/api/Supplier/Get?";
        if (supplierId === undefined)
            throw new Error("The parameter 'supplierId' must be defined.");
        else if (supplierId !== null)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SupplierDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SupplierDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SupplierDto.fromJS(resultData200) : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierDto | null>(<any>null);
    }

    checkIsCodeExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Supplier/CheckIsCodeExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsCodeExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsCodeExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsCodeExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    checkIsNameExists(request: CheckIsCodeExistsRequest | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Supplier/CheckIsNameExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsNameExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsNameExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsNameExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ThongBaoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTotal(): Observable<number> {
        let url_ = this.baseUrl + "/api/ThongBao/GetTotal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTotal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotal(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    deleteList(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ThongBao/DeleteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getListThongBao(skip: number): Observable<ThongBaoDto[] | null> {
        let url_ = this.baseUrl + "/api/ThongBao/GetListThongBao?";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListThongBao(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListThongBao(<any>response_);
                } catch (e) {
                    return <Observable<ThongBaoDto[] | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ThongBaoDto[] | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetListThongBao(response: HttpResponseBase): Observable<ThongBaoDto[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ThongBaoDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThongBaoDto[] | null>(<any>null);
    }

    markAsRead(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ThongBao/MarkAsRead/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    testPushNotification(req: TestPushNotificationRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ThongBao/TestPushNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestPushNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestPushNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestPushNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FundHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHistory(request: GetFundHistoryRequest | null | undefined): Observable<FundHistoryDto[]> {
        let url_ = this.baseUrl + "/api/FundHistory/GetHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(<any>response_);
                } catch (e) {
                    return <Observable<FundHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FundHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<FundHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(FundHistoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FundHistoryDto[]>(<any>null);
    }

    getSummary(request: GetFundHistoryRequest | null | undefined): Observable<FundSummaryDto> {
        let url_ = this.baseUrl + "/api/FundHistory/GetSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(<any>response_);
                } catch (e) {
                    return <Observable<FundSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FundSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<FundSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FundSummaryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FundSummaryDto>(<any>null);
    }
}

export class PaginatorResponseOfGetListAccountResponse implements IPaginatorResponseOfGetListAccountResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: GetListAccountResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfGetListAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(GetListAccountResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfGetListAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfGetListAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfGetListAccountResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: GetListAccountResponse[] | undefined;
}

export class GetListAccountResponse implements IGetListAccountResponse {
    id?: string | undefined;
    fullName?: string | undefined;
    avatarId?: string | undefined;
    email?: string | undefined;
    roles?: RoleEnum[] | undefined;
    rolesName?: string | undefined;
    isActive?: boolean | undefined;
    createdTime?: Date | undefined;
    lastLoginTime?: Date | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;

    constructor(data?: IGetListAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.avatarId = _data["AvatarId"];
            this.email = _data["Email"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.rolesName = _data["RolesName"];
            this.isActive = _data["IsActive"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.lastLoginTime = _data["LastLoginTime"] ? new Date(_data["LastLoginTime"].toString()) : <any>undefined;
            this.timeIn = _data["TimeIn"];
            this.timeOut = _data["TimeOut"];
        }
    }

    static fromJS(data: any): GetListAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["AvatarId"] = this.avatarId;
        data["Email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["RolesName"] = this.rolesName;
        data["IsActive"] = this.isActive;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["LastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["TimeIn"] = this.timeIn;
        data["TimeOut"] = this.timeOut;
        return data;
    }
}

export interface IGetListAccountResponse {
    id?: string | undefined;
    fullName?: string | undefined;
    avatarId?: string | undefined;
    email?: string | undefined;
    roles?: RoleEnum[] | undefined;
    rolesName?: string | undefined;
    isActive?: boolean | undefined;
    createdTime?: Date | undefined;
    lastLoginTime?: Date | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
}

export enum RoleEnum {
    Admin = 0,
    Staff = 1,
    Customer = 2,
    SubAdmin = 3,
}

export class GetListAccountRequest implements IGetListAccountRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    role?: RoleEnum | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IGetListAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.role = _data["Role"];
            this.isActive = _data["IsActive"];
        }
    }

    static fromJS(data: any): GetListAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["Role"] = this.role;
        data["IsActive"] = this.isActive;
        return data;
    }
}

export interface IGetListAccountRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    role?: RoleEnum | undefined;
    isActive?: boolean | undefined;
}

export class AccountDto implements IAccountDto {
    id?: string | undefined;
    username?: string | undefined;
    isActive?: boolean | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    hoTen?: string | undefined;
    phoneNumber?: string | undefined;
    gender?: number | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    avatarId?: string | undefined;
    note?: string | undefined;
    wrongTimes?: number | undefined;
    type?: number | undefined;
    parentId?: string | undefined;
    lastLoginTime?: Date | undefined;
    tokenTimeDisabled?: Date | undefined;
    isDeleted?: boolean | undefined;
    createdTime?: Date | undefined;
    updatedTime?: Date | undefined;
    deletedTime?: Date | undefined;
    createdId?: string | undefined;
    updatedId?: string | undefined;
    deletedId?: string | undefined;
    roles?: RoleEnum[] | undefined;
    rolesName?: string | undefined;
    listRoleName?: string[] | undefined;
    resetCode?: string | undefined;
    resetCodeTime?: Date | undefined;
    activeCode?: string | undefined;
    activeCodeTime?: Date | undefined;
    otpCode?: string | undefined;
    otpCodeTime?: Date | undefined;
    laQuanTriVien?: boolean | undefined;
    laQuanLy?: boolean | undefined;
    accountParentId?: string | undefined;
    linkFacebook?: string | undefined;
    soDienThoaiZalo?: string | undefined;
    kichHoatTaiKhoan?: boolean | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.username = _data["Username"];
            this.isActive = _data["IsActive"];
            this.email = _data["Email"];
            this.fullName = _data["FullName"];
            this.hoTen = _data["HoTen"];
            this.phoneNumber = _data["PhoneNumber"];
            this.gender = _data["Gender"];
            this.birthDate = _data["BirthDate"] ? new Date(_data["BirthDate"].toString()) : <any>undefined;
            this.address = _data["Address"];
            this.avatarId = _data["AvatarId"];
            this.note = _data["Note"];
            this.wrongTimes = _data["WrongTimes"];
            this.type = _data["Type"];
            this.parentId = _data["ParentId"];
            this.lastLoginTime = _data["LastLoginTime"] ? new Date(_data["LastLoginTime"].toString()) : <any>undefined;
            this.tokenTimeDisabled = _data["TokenTimeDisabled"] ? new Date(_data["TokenTimeDisabled"].toString()) : <any>undefined;
            this.isDeleted = _data["IsDeleted"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.updatedTime = _data["UpdatedTime"] ? new Date(_data["UpdatedTime"].toString()) : <any>undefined;
            this.deletedTime = _data["DeletedTime"] ? new Date(_data["DeletedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.updatedId = _data["UpdatedId"];
            this.deletedId = _data["DeletedId"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.rolesName = _data["RolesName"];
            if (Array.isArray(_data["ListRoleName"])) {
                this.listRoleName = [] as any;
                for (let item of _data["ListRoleName"])
                    this.listRoleName!.push(item);
            }
            this.resetCode = _data["ResetCode"];
            this.resetCodeTime = _data["ResetCodeTime"] ? new Date(_data["ResetCodeTime"].toString()) : <any>undefined;
            this.activeCode = _data["ActiveCode"];
            this.activeCodeTime = _data["ActiveCodeTime"] ? new Date(_data["ActiveCodeTime"].toString()) : <any>undefined;
            this.otpCode = _data["OtpCode"];
            this.otpCodeTime = _data["OtpCodeTime"] ? new Date(_data["OtpCodeTime"].toString()) : <any>undefined;
            this.laQuanTriVien = _data["LaQuanTriVien"];
            this.laQuanLy = _data["LaQuanLy"];
            this.accountParentId = _data["AccountParentId"];
            this.linkFacebook = _data["LinkFacebook"];
            this.soDienThoaiZalo = _data["SoDienThoaiZalo"];
            this.kichHoatTaiKhoan = _data["KichHoatTaiKhoan"];
            this.timeIn = _data["TimeIn"];
            this.timeOut = _data["TimeOut"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Username"] = this.username;
        data["IsActive"] = this.isActive;
        data["Email"] = this.email;
        data["FullName"] = this.fullName;
        data["HoTen"] = this.hoTen;
        data["PhoneNumber"] = this.phoneNumber;
        data["Gender"] = this.gender;
        data["BirthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["Address"] = this.address;
        data["AvatarId"] = this.avatarId;
        data["Note"] = this.note;
        data["WrongTimes"] = this.wrongTimes;
        data["Type"] = this.type;
        data["ParentId"] = this.parentId;
        data["LastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["TokenTimeDisabled"] = this.tokenTimeDisabled ? this.tokenTimeDisabled.toISOString() : <any>undefined;
        data["IsDeleted"] = this.isDeleted;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["UpdatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
        data["DeletedTime"] = this.deletedTime ? this.deletedTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["UpdatedId"] = this.updatedId;
        data["DeletedId"] = this.deletedId;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["RolesName"] = this.rolesName;
        if (Array.isArray(this.listRoleName)) {
            data["ListRoleName"] = [];
            for (let item of this.listRoleName)
                data["ListRoleName"].push(item);
        }
        data["ResetCode"] = this.resetCode;
        data["ResetCodeTime"] = this.resetCodeTime ? this.resetCodeTime.toISOString() : <any>undefined;
        data["ActiveCode"] = this.activeCode;
        data["ActiveCodeTime"] = this.activeCodeTime ? this.activeCodeTime.toISOString() : <any>undefined;
        data["OtpCode"] = this.otpCode;
        data["OtpCodeTime"] = this.otpCodeTime ? this.otpCodeTime.toISOString() : <any>undefined;
        data["LaQuanTriVien"] = this.laQuanTriVien;
        data["LaQuanLy"] = this.laQuanLy;
        data["AccountParentId"] = this.accountParentId;
        data["LinkFacebook"] = this.linkFacebook;
        data["SoDienThoaiZalo"] = this.soDienThoaiZalo;
        data["KichHoatTaiKhoan"] = this.kichHoatTaiKhoan;
        data["TimeIn"] = this.timeIn;
        data["TimeOut"] = this.timeOut;
        return data;
    }
}

export interface IAccountDto {
    id?: string | undefined;
    username?: string | undefined;
    isActive?: boolean | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    hoTen?: string | undefined;
    phoneNumber?: string | undefined;
    gender?: number | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    avatarId?: string | undefined;
    note?: string | undefined;
    wrongTimes?: number | undefined;
    type?: number | undefined;
    parentId?: string | undefined;
    lastLoginTime?: Date | undefined;
    tokenTimeDisabled?: Date | undefined;
    isDeleted?: boolean | undefined;
    createdTime?: Date | undefined;
    updatedTime?: Date | undefined;
    deletedTime?: Date | undefined;
    createdId?: string | undefined;
    updatedId?: string | undefined;
    deletedId?: string | undefined;
    roles?: RoleEnum[] | undefined;
    rolesName?: string | undefined;
    listRoleName?: string[] | undefined;
    resetCode?: string | undefined;
    resetCodeTime?: Date | undefined;
    activeCode?: string | undefined;
    activeCodeTime?: Date | undefined;
    otpCode?: string | undefined;
    otpCodeTime?: Date | undefined;
    laQuanTriVien?: boolean | undefined;
    laQuanLy?: boolean | undefined;
    accountParentId?: string | undefined;
    linkFacebook?: string | undefined;
    soDienThoaiZalo?: string | undefined;
    kichHoatTaiKhoan?: boolean | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
}

export class CreateAccountRequest implements ICreateAccountRequest {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    gender?: GenderEnum | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    avatarId?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    note?: string | undefined;
    isAcvite?: boolean | undefined;
    rolesEnum?: RoleEnum[] | undefined;
    soDienThoaiZalo?: string | undefined;
    linkFacebook?: string | undefined;
    kichHoatTaiKhoan?: boolean | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;

    constructor(data?: ICreateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.gender = _data["Gender"];
            this.birthDate = _data["BirthDate"] ? new Date(_data["BirthDate"].toString()) : <any>undefined;
            this.address = _data["Address"];
            this.avatarId = _data["AvatarId"];
            this.username = _data["Username"];
            this.password = _data["Password"];
            this.note = _data["Note"];
            this.isAcvite = _data["IsAcvite"];
            if (Array.isArray(_data["RolesEnum"])) {
                this.rolesEnum = [] as any;
                for (let item of _data["RolesEnum"])
                    this.rolesEnum!.push(item);
            }
            this.soDienThoaiZalo = _data["SoDienThoaiZalo"];
            this.linkFacebook = _data["LinkFacebook"];
            this.kichHoatTaiKhoan = _data["KichHoatTaiKhoan"];
            this.timeIn = _data["TimeIn"];
            this.timeOut = _data["TimeOut"];
        }
    }

    static fromJS(data: any): CreateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["Gender"] = this.gender;
        data["BirthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["Address"] = this.address;
        data["AvatarId"] = this.avatarId;
        data["Username"] = this.username;
        data["Password"] = this.password;
        data["Note"] = this.note;
        data["IsAcvite"] = this.isAcvite;
        if (Array.isArray(this.rolesEnum)) {
            data["RolesEnum"] = [];
            for (let item of this.rolesEnum)
                data["RolesEnum"].push(item);
        }
        data["SoDienThoaiZalo"] = this.soDienThoaiZalo;
        data["LinkFacebook"] = this.linkFacebook;
        data["KichHoatTaiKhoan"] = this.kichHoatTaiKhoan;
        data["TimeIn"] = this.timeIn;
        data["TimeOut"] = this.timeOut;
        return data;
    }
}

export interface ICreateAccountRequest {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    gender?: GenderEnum | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    avatarId?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    note?: string | undefined;
    isAcvite?: boolean | undefined;
    rolesEnum?: RoleEnum[] | undefined;
    soDienThoaiZalo?: string | undefined;
    linkFacebook?: string | undefined;
    kichHoatTaiKhoan?: boolean | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
}

export enum GenderEnum {
    Nam = 0,
    Nu = 1,
}

export class UpdatePasswordRequest implements IUpdatePasswordRequest {
    password?: string | undefined;
    isLogoutAll!: boolean;
    accountId?: string | undefined;

    constructor(data?: IUpdatePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["Password"];
            this.isLogoutAll = _data["IsLogoutAll"];
            this.accountId = _data["AccountId"];
        }
    }

    static fromJS(data: any): UpdatePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Password"] = this.password;
        data["IsLogoutAll"] = this.isLogoutAll;
        data["AccountId"] = this.accountId;
        return data;
    }
}

export interface IUpdatePasswordRequest {
    password?: string | undefined;
    isLogoutAll: boolean;
    accountId?: string | undefined;
}

export class UpdateAccountRequest implements IUpdateAccountRequest {
    accountId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    gender?: GenderEnum | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    avatarId?: string | undefined;
    username?: string | undefined;
    note?: string | undefined;
    isAcvite?: boolean | undefined;
    rolesEnum?: RoleEnum[] | undefined;
    soDienThoaiZalo?: string | undefined;
    linkFacebook?: string | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;

    constructor(data?: IUpdateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["AccountId"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phoneNumber = _data["PhoneNumber"];
            this.gender = _data["Gender"];
            this.birthDate = _data["BirthDate"] ? new Date(_data["BirthDate"].toString()) : <any>undefined;
            this.address = _data["Address"];
            this.avatarId = _data["AvatarId"];
            this.username = _data["Username"];
            this.note = _data["Note"];
            this.isAcvite = _data["IsAcvite"];
            if (Array.isArray(_data["RolesEnum"])) {
                this.rolesEnum = [] as any;
                for (let item of _data["RolesEnum"])
                    this.rolesEnum!.push(item);
            }
            this.soDienThoaiZalo = _data["SoDienThoaiZalo"];
            this.linkFacebook = _data["LinkFacebook"];
            this.timeIn = _data["TimeIn"];
            this.timeOut = _data["TimeOut"];
        }
    }

    static fromJS(data: any): UpdateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["PhoneNumber"] = this.phoneNumber;
        data["Gender"] = this.gender;
        data["BirthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["Address"] = this.address;
        data["AvatarId"] = this.avatarId;
        data["Username"] = this.username;
        data["Note"] = this.note;
        data["IsAcvite"] = this.isAcvite;
        if (Array.isArray(this.rolesEnum)) {
            data["RolesEnum"] = [];
            for (let item of this.rolesEnum)
                data["RolesEnum"].push(item);
        }
        data["SoDienThoaiZalo"] = this.soDienThoaiZalo;
        data["LinkFacebook"] = this.linkFacebook;
        data["TimeIn"] = this.timeIn;
        data["TimeOut"] = this.timeOut;
        return data;
    }
}

export interface IUpdateAccountRequest {
    accountId?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    gender?: GenderEnum | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    avatarId?: string | undefined;
    username?: string | undefined;
    note?: string | undefined;
    isAcvite?: boolean | undefined;
    rolesEnum?: RoleEnum[] | undefined;
    soDienThoaiZalo?: string | undefined;
    linkFacebook?: string | undefined;
    timeIn?: string | undefined;
    timeOut?: string | undefined;
}

export class UpdateProfileAccountRequest implements IUpdateProfileAccountRequest {
    fullName?: string | undefined;
    gender?: GenderEnum | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    note?: string | undefined;
    avatarId?: string | undefined;

    constructor(data?: IUpdateProfileAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.gender = _data["Gender"];
            this.birthDate = _data["BirthDate"] ? new Date(_data["BirthDate"].toString()) : <any>undefined;
            this.address = _data["Address"];
            this.note = _data["Note"];
            this.avatarId = _data["AvatarId"];
        }
    }

    static fromJS(data: any): UpdateProfileAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Gender"] = this.gender;
        data["BirthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["Address"] = this.address;
        data["Note"] = this.note;
        data["AvatarId"] = this.avatarId;
        return data;
    }
}

export interface IUpdateProfileAccountRequest {
    fullName?: string | undefined;
    gender?: GenderEnum | undefined;
    birthDate?: Date | undefined;
    address?: string | undefined;
    note?: string | undefined;
    avatarId?: string | undefined;
}

export class ChangePasswordAccountRequest implements IChangePasswordAccountRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    isLogoutAll!: boolean;

    constructor(data?: IChangePasswordAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["OldPassword"];
            this.newPassword = _data["NewPassword"];
            this.isLogoutAll = _data["IsLogoutAll"];
        }
    }

    static fromJS(data: any): ChangePasswordAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OldPassword"] = this.oldPassword;
        data["NewPassword"] = this.newPassword;
        data["IsLogoutAll"] = this.isLogoutAll;
        return data;
    }
}

export interface IChangePasswordAccountRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    isLogoutAll: boolean;
}

export class AccountRoleDto implements IAccountRoleDto {
    role!: RoleEnum;
    roleName?: string | undefined;
    isUsingManager!: boolean;
    checked!: boolean;
    isUsingPermission!: boolean;

    constructor(data?: IAccountRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["Role"];
            this.roleName = _data["RoleName"];
            this.isUsingManager = _data["IsUsingManager"];
            this.checked = _data["Checked"];
            this.isUsingPermission = _data["IsUsingPermission"];
        }
    }

    static fromJS(data: any): AccountRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Role"] = this.role;
        data["RoleName"] = this.roleName;
        data["IsUsingManager"] = this.isUsingManager;
        data["Checked"] = this.checked;
        data["IsUsingPermission"] = this.isUsingPermission;
        return data;
    }
}

export interface IAccountRoleDto {
    role: RoleEnum;
    roleName?: string | undefined;
    isUsingManager: boolean;
    checked: boolean;
    isUsingPermission: boolean;
}

export class CheckIsEmailExistsRequest implements ICheckIsEmailExistsRequest {
    email?: string | undefined;
    oldEmail?: string | undefined;

    constructor(data?: ICheckIsEmailExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.oldEmail = _data["OldEmail"];
        }
    }

    static fromJS(data: any): CheckIsEmailExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIsEmailExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["OldEmail"] = this.oldEmail;
        return data;
    }
}

export interface ICheckIsEmailExistsRequest {
    email?: string | undefined;
    oldEmail?: string | undefined;
}

export class CheckIsUsernameExistsRequest implements ICheckIsUsernameExistsRequest {
    username?: string | undefined;
    oldUsername?: string | undefined;

    constructor(data?: ICheckIsUsernameExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.oldUsername = _data["OldUsername"];
        }
    }

    static fromJS(data: any): CheckIsUsernameExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIsUsernameExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["OldUsername"] = this.oldUsername;
        return data;
    }
}

export interface ICheckIsUsernameExistsRequest {
    username?: string | undefined;
    oldUsername?: string | undefined;
}

export class CheckIsPhoneNumberExistsRequest implements ICheckIsPhoneNumberExistsRequest {
    phoneNumber?: string | undefined;
    oldPhoneNumber?: string | undefined;

    constructor(data?: ICheckIsPhoneNumberExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["PhoneNumber"];
            this.oldPhoneNumber = _data["OldPhoneNumber"];
        }
    }

    static fromJS(data: any): CheckIsPhoneNumberExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIsPhoneNumberExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PhoneNumber"] = this.phoneNumber;
        data["OldPhoneNumber"] = this.oldPhoneNumber;
        return data;
    }
}

export interface ICheckIsPhoneNumberExistsRequest {
    phoneNumber?: string | undefined;
    oldPhoneNumber?: string | undefined;
}

export class FilterWithTagAccountResponse implements IFilterWithTagAccountResponse {
    id!: string;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    username?: string | undefined;

    constructor(data?: IFilterWithTagAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.phoneNumber = _data["PhoneNumber"];
            this.email = _data["Email"];
            this.username = _data["Username"];
        }
    }

    static fromJS(data: any): FilterWithTagAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterWithTagAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["PhoneNumber"] = this.phoneNumber;
        data["Email"] = this.email;
        data["Username"] = this.username;
        return data;
    }
}

export interface IFilterWithTagAccountResponse {
    id: string;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    username?: string | undefined;
}

export class CheckIsPhoneZaloExistsRequest implements ICheckIsPhoneZaloExistsRequest {
    phoneZalo?: string | undefined;
    oldPhoneZalo?: string | undefined;

    constructor(data?: ICheckIsPhoneZaloExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneZalo = _data["PhoneZalo"];
            this.oldPhoneZalo = _data["OldPhoneZalo"];
        }
    }

    static fromJS(data: any): CheckIsPhoneZaloExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIsPhoneZaloExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PhoneZalo"] = this.phoneZalo;
        data["OldPhoneZalo"] = this.oldPhoneZalo;
        return data;
    }
}

export interface ICheckIsPhoneZaloExistsRequest {
    phoneZalo?: string | undefined;
    oldPhoneZalo?: string | undefined;
}

export class CheckIsLinkFacebookExistsRequest implements ICheckIsLinkFacebookExistsRequest {
    linkFacebook?: string | undefined;
    oldLinkFacebook?: string | undefined;

    constructor(data?: ICheckIsLinkFacebookExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkFacebook = _data["LinkFacebook"];
            this.oldLinkFacebook = _data["OldLinkFacebook"];
        }
    }

    static fromJS(data: any): CheckIsLinkFacebookExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIsLinkFacebookExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LinkFacebook"] = this.linkFacebook;
        data["OldLinkFacebook"] = this.oldLinkFacebook;
        return data;
    }
}

export interface ICheckIsLinkFacebookExistsRequest {
    linkFacebook?: string | undefined;
    oldLinkFacebook?: string | undefined;
}

export class CreateTinTucRequest implements ICreateTinTucRequest {
    tieuDe?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    noiDung?: string | undefined;
    trangThai!: boolean;
    mucDoUuTien?: MucDoUuTienTinTucEnum | undefined;
    publishedTime?: Date | undefined;
    isBanner?: boolean | undefined;
    anhBanner?: string | undefined;
    hienThiTextBanner?: boolean | undefined;
    viTriBanner?: number | undefined;
    urlBanner?: string | undefined;

    constructor(data?: ICreateTinTucRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tieuDe = _data["TieuDe"];
            this.moTa = _data["MoTa"];
            this.anhBiaId = _data["AnhBiaId"];
            this.danhMucChuDeTinTucId = _data["DanhMucChuDeTinTucId"];
            this.noiDung = _data["NoiDung"];
            this.trangThai = _data["TrangThai"];
            this.mucDoUuTien = _data["MucDoUuTien"];
            this.publishedTime = _data["PublishedTime"] ? new Date(_data["PublishedTime"].toString()) : <any>undefined;
            this.isBanner = _data["IsBanner"];
            this.anhBanner = _data["AnhBanner"];
            this.hienThiTextBanner = _data["HienThiTextBanner"];
            this.viTriBanner = _data["ViTriBanner"];
            this.urlBanner = _data["UrlBanner"];
        }
    }

    static fromJS(data: any): CreateTinTucRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTinTucRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TieuDe"] = this.tieuDe;
        data["MoTa"] = this.moTa;
        data["AnhBiaId"] = this.anhBiaId;
        data["DanhMucChuDeTinTucId"] = this.danhMucChuDeTinTucId;
        data["NoiDung"] = this.noiDung;
        data["TrangThai"] = this.trangThai;
        data["MucDoUuTien"] = this.mucDoUuTien;
        data["PublishedTime"] = this.publishedTime ? this.publishedTime.toISOString() : <any>undefined;
        data["IsBanner"] = this.isBanner;
        data["AnhBanner"] = this.anhBanner;
        data["HienThiTextBanner"] = this.hienThiTextBanner;
        data["ViTriBanner"] = this.viTriBanner;
        data["UrlBanner"] = this.urlBanner;
        return data;
    }
}

export interface ICreateTinTucRequest {
    tieuDe?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    noiDung?: string | undefined;
    trangThai: boolean;
    mucDoUuTien?: MucDoUuTienTinTucEnum | undefined;
    publishedTime?: Date | undefined;
    isBanner?: boolean | undefined;
    anhBanner?: string | undefined;
    hienThiTextBanner?: boolean | undefined;
    viTriBanner?: number | undefined;
    urlBanner?: string | undefined;
}

export enum MucDoUuTienTinTucEnum {
    RAT_CAO = 0,
    CAO = 1,
    TRUNG_BINH = 2,
    THAP = 3,
    RAT_THAP = 4,
}

export class TinTucDto implements ITinTucDto {
    id?: string | undefined;
    tieuDe?: string | undefined;
    tenChuDe?: string | undefined;
    moTa?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    anhBiaId?: string | undefined;
    noiDung?: string | undefined;
    trangThai!: boolean;
    publishedTime?: Date | undefined;
    mucDoUuTien?: number | undefined;
    isBanner?: boolean | undefined;
    urlImage?: string | undefined;
    anhBanner?: string | undefined;
    positionId!: number;
    tenMucDoUuTien?: string | undefined;
    publishedTimeStr?: string | undefined;
    seName?: string | undefined;
    hienThiTextBanner?: boolean | undefined;
    viTriBanner?: number | undefined;
    viTriBannerStr?: string | undefined;
    backgroundColorBanner?: string | undefined;
    urlBanner?: string | undefined;

    constructor(data?: ITinTucDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tieuDe = _data["TieuDe"];
            this.tenChuDe = _data["TenChuDe"];
            this.moTa = _data["MoTa"];
            this.danhMucChuDeTinTucId = _data["DanhMucChuDeTinTucId"];
            this.anhBiaId = _data["AnhBiaId"];
            this.noiDung = _data["NoiDung"];
            this.trangThai = _data["TrangThai"];
            this.publishedTime = _data["PublishedTime"] ? new Date(_data["PublishedTime"].toString()) : <any>undefined;
            this.mucDoUuTien = _data["MucDoUuTien"];
            this.isBanner = _data["IsBanner"];
            this.urlImage = _data["UrlImage"];
            this.anhBanner = _data["AnhBanner"];
            this.positionId = _data["PositionId"];
            this.tenMucDoUuTien = _data["TenMucDoUuTien"];
            this.publishedTimeStr = _data["PublishedTimeStr"];
            this.seName = _data["SeName"];
            this.hienThiTextBanner = _data["HienThiTextBanner"];
            this.viTriBanner = _data["ViTriBanner"];
            this.viTriBannerStr = _data["ViTriBannerStr"];
            this.backgroundColorBanner = _data["BackgroundColorBanner"];
            this.urlBanner = _data["UrlBanner"];
        }
    }

    static fromJS(data: any): TinTucDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinTucDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TieuDe"] = this.tieuDe;
        data["TenChuDe"] = this.tenChuDe;
        data["MoTa"] = this.moTa;
        data["DanhMucChuDeTinTucId"] = this.danhMucChuDeTinTucId;
        data["AnhBiaId"] = this.anhBiaId;
        data["NoiDung"] = this.noiDung;
        data["TrangThai"] = this.trangThai;
        data["PublishedTime"] = this.publishedTime ? this.publishedTime.toISOString() : <any>undefined;
        data["MucDoUuTien"] = this.mucDoUuTien;
        data["IsBanner"] = this.isBanner;
        data["UrlImage"] = this.urlImage;
        data["AnhBanner"] = this.anhBanner;
        data["PositionId"] = this.positionId;
        data["TenMucDoUuTien"] = this.tenMucDoUuTien;
        data["PublishedTimeStr"] = this.publishedTimeStr;
        data["SeName"] = this.seName;
        data["HienThiTextBanner"] = this.hienThiTextBanner;
        data["ViTriBanner"] = this.viTriBanner;
        data["ViTriBannerStr"] = this.viTriBannerStr;
        data["BackgroundColorBanner"] = this.backgroundColorBanner;
        data["UrlBanner"] = this.urlBanner;
        return data;
    }
}

export interface ITinTucDto {
    id?: string | undefined;
    tieuDe?: string | undefined;
    tenChuDe?: string | undefined;
    moTa?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    anhBiaId?: string | undefined;
    noiDung?: string | undefined;
    trangThai: boolean;
    publishedTime?: Date | undefined;
    mucDoUuTien?: number | undefined;
    isBanner?: boolean | undefined;
    urlImage?: string | undefined;
    anhBanner?: string | undefined;
    positionId: number;
    tenMucDoUuTien?: string | undefined;
    publishedTimeStr?: string | undefined;
    seName?: string | undefined;
    hienThiTextBanner?: boolean | undefined;
    viTriBanner?: number | undefined;
    viTriBannerStr?: string | undefined;
    backgroundColorBanner?: string | undefined;
    urlBanner?: string | undefined;
}

export class UpdateTinTucRequest implements IUpdateTinTucRequest {
    id?: string | undefined;
    tieuDe?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    noiDung?: string | undefined;
    trangThai!: boolean;
    mucDoUuTien?: MucDoUuTienTinTucEnum | undefined;
    publishedTime?: Date | undefined;
    isBanner?: boolean | undefined;
    anhBanner?: string | undefined;
    hienThiTextBanner?: boolean | undefined;
    viTriBanner?: number | undefined;
    urlBanner?: string | undefined;

    constructor(data?: IUpdateTinTucRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tieuDe = _data["TieuDe"];
            this.moTa = _data["MoTa"];
            this.anhBiaId = _data["AnhBiaId"];
            this.danhMucChuDeTinTucId = _data["DanhMucChuDeTinTucId"];
            this.noiDung = _data["NoiDung"];
            this.trangThai = _data["TrangThai"];
            this.mucDoUuTien = _data["MucDoUuTien"];
            this.publishedTime = _data["PublishedTime"] ? new Date(_data["PublishedTime"].toString()) : <any>undefined;
            this.isBanner = _data["IsBanner"];
            this.anhBanner = _data["AnhBanner"];
            this.hienThiTextBanner = _data["HienThiTextBanner"];
            this.viTriBanner = _data["ViTriBanner"];
            this.urlBanner = _data["UrlBanner"];
        }
    }

    static fromJS(data: any): UpdateTinTucRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTinTucRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TieuDe"] = this.tieuDe;
        data["MoTa"] = this.moTa;
        data["AnhBiaId"] = this.anhBiaId;
        data["DanhMucChuDeTinTucId"] = this.danhMucChuDeTinTucId;
        data["NoiDung"] = this.noiDung;
        data["TrangThai"] = this.trangThai;
        data["MucDoUuTien"] = this.mucDoUuTien;
        data["PublishedTime"] = this.publishedTime ? this.publishedTime.toISOString() : <any>undefined;
        data["IsBanner"] = this.isBanner;
        data["AnhBanner"] = this.anhBanner;
        data["HienThiTextBanner"] = this.hienThiTextBanner;
        data["ViTriBanner"] = this.viTriBanner;
        data["UrlBanner"] = this.urlBanner;
        return data;
    }
}

export interface IUpdateTinTucRequest {
    id?: string | undefined;
    tieuDe?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    noiDung?: string | undefined;
    trangThai: boolean;
    mucDoUuTien?: MucDoUuTienTinTucEnum | undefined;
    publishedTime?: Date | undefined;
    isBanner?: boolean | undefined;
    anhBanner?: string | undefined;
    hienThiTextBanner?: boolean | undefined;
    viTriBanner?: number | undefined;
    urlBanner?: string | undefined;
}

export class UpdatePublisedTimeRequest implements IUpdatePublisedTimeRequest {
    id?: string | undefined;
    publishedTime?: Date | undefined;

    constructor(data?: IUpdatePublisedTimeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.publishedTime = _data["PublishedTime"] ? new Date(_data["PublishedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePublisedTimeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePublisedTimeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["PublishedTime"] = this.publishedTime ? this.publishedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdatePublisedTimeRequest {
    id?: string | undefined;
    publishedTime?: Date | undefined;
}

export class PaginatorResponseOfGetListTinTucResponse implements IPaginatorResponseOfGetListTinTucResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: GetListTinTucResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfGetListTinTucResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(GetListTinTucResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfGetListTinTucResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfGetListTinTucResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfGetListTinTucResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: GetListTinTucResponse[] | undefined;
}

export class GetListTinTucResponse implements IGetListTinTucResponse {
    id!: string;
    tenChuDe?: string | undefined;
    tieuDe?: string | undefined;
    moTa?: string | undefined;
    createdTime!: Date;
    createdId!: string;
    trangThai!: boolean;
    createdName?: string | undefined;
    danhMucChuDeTinTucId!: number;
    mucDoUuTien?: number | undefined;
    mucDoUuTienStr?: string | undefined;

    constructor(data?: IGetListTinTucResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tenChuDe = _data["TenChuDe"];
            this.tieuDe = _data["TieuDe"];
            this.moTa = _data["MoTa"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.trangThai = _data["TrangThai"];
            this.createdName = _data["CreatedName"];
            this.danhMucChuDeTinTucId = _data["DanhMucChuDeTinTucId"];
            this.mucDoUuTien = _data["MucDoUuTien"];
            this.mucDoUuTienStr = _data["MucDoUuTienStr"];
        }
    }

    static fromJS(data: any): GetListTinTucResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListTinTucResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TenChuDe"] = this.tenChuDe;
        data["TieuDe"] = this.tieuDe;
        data["MoTa"] = this.moTa;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["TrangThai"] = this.trangThai;
        data["CreatedName"] = this.createdName;
        data["DanhMucChuDeTinTucId"] = this.danhMucChuDeTinTucId;
        data["MucDoUuTien"] = this.mucDoUuTien;
        data["MucDoUuTienStr"] = this.mucDoUuTienStr;
        return data;
    }
}

export interface IGetListTinTucResponse {
    id: string;
    tenChuDe?: string | undefined;
    tieuDe?: string | undefined;
    moTa?: string | undefined;
    createdTime: Date;
    createdId: string;
    trangThai: boolean;
    createdName?: string | undefined;
    danhMucChuDeTinTucId: number;
    mucDoUuTien?: number | undefined;
    mucDoUuTienStr?: string | undefined;
}

export class GetListTinTucRequest implements IGetListTinTucRequest {
    createdTime?: Date | undefined;
    createdId?: string | undefined;
    tieuDe?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;

    constructor(data?: IGetListTinTucRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.tieuDe = _data["TieuDe"];
            this.danhMucChuDeTinTucId = _data["DanhMucChuDeTinTucId"];
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
        }
    }

    static fromJS(data: any): GetListTinTucRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListTinTucRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["TieuDe"] = this.tieuDe;
        data["DanhMucChuDeTinTucId"] = this.danhMucChuDeTinTucId;
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        return data;
    }
}

export interface IGetListTinTucRequest {
    createdTime?: Date | undefined;
    createdId?: string | undefined;
    tieuDe?: string | undefined;
    danhMucChuDeTinTucId?: number | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
}

export class GetTopListTinTucResponse implements IGetTopListTinTucResponse {
    id!: string;
    tenChuDe?: string | undefined;
    tieuDe?: string | undefined;
    danhMucChuDeTinTucId!: number;
    moTa?: string | undefined;
    anhBiaId!: string;

    constructor(data?: IGetTopListTinTucResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tenChuDe = _data["TenChuDe"];
            this.tieuDe = _data["TieuDe"];
            this.danhMucChuDeTinTucId = _data["DanhMucChuDeTinTucId"];
            this.moTa = _data["MoTa"];
            this.anhBiaId = _data["AnhBiaId"];
        }
    }

    static fromJS(data: any): GetTopListTinTucResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopListTinTucResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TenChuDe"] = this.tenChuDe;
        data["TieuDe"] = this.tieuDe;
        data["DanhMucChuDeTinTucId"] = this.danhMucChuDeTinTucId;
        data["MoTa"] = this.moTa;
        data["AnhBiaId"] = this.anhBiaId;
        return data;
    }
}

export interface IGetTopListTinTucResponse {
    id: string;
    tenChuDe?: string | undefined;
    tieuDe?: string | undefined;
    danhMucChuDeTinTucId: number;
    moTa?: string | undefined;
    anhBiaId: string;
}

export class FilterAccountTinTucResponse implements IFilterAccountTinTucResponse {
    id!: string;
    fullName?: string | undefined;

    constructor(data?: IFilterAccountTinTucResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
        }
    }

    static fromJS(data: any): FilterAccountTinTucResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterAccountTinTucResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        return data;
    }
}

export interface IFilterAccountTinTucResponse {
    id: string;
    fullName?: string | undefined;
}

export class PaginatorResponseOfTinTucDto implements IPaginatorResponseOfTinTucDto {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: TinTucDto[] | undefined;

    constructor(data?: IPaginatorResponseOfTinTucDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(TinTucDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfTinTucDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfTinTucDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfTinTucDto {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: TinTucDto[] | undefined;
}

export class LoginResponse implements ILoginResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    tokenPayload?: TokenPayload | undefined;
    isSuccess!: boolean;
    message?: string | undefined;
    typeLogin?: number | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.refreshToken = _data["RefreshToken"];
            this.tokenPayload = _data["TokenPayload"] ? TokenPayload.fromJS(_data["TokenPayload"]) : <any>undefined;
            this.isSuccess = _data["IsSuccess"];
            this.message = _data["Message"];
            this.typeLogin = _data["TypeLogin"];
            this.phoneNumber = _data["PhoneNumber"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["RefreshToken"] = this.refreshToken;
        data["TokenPayload"] = this.tokenPayload ? this.tokenPayload.toJSON() : <any>undefined;
        data["IsSuccess"] = this.isSuccess;
        data["Message"] = this.message;
        data["TypeLogin"] = this.typeLogin;
        data["PhoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ILoginResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    tokenPayload?: TokenPayload | undefined;
    isSuccess: boolean;
    message?: string | undefined;
    typeLogin?: number | undefined;
    phoneNumber?: string | undefined;
}

export class TokenPayload implements ITokenPayload {
    id!: string;
    expiredTime!: number;
    username?: string | undefined;
    createTimeToken!: number;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatarId?: string | undefined;
    laQuanTriVien!: boolean;
    laNhanVien!: boolean;
    laKhachHang!: boolean;
    isSubAdmin!: boolean;

    constructor(data?: ITokenPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.expiredTime = _data["ExpiredTime"];
            this.username = _data["Username"];
            this.createTimeToken = _data["CreateTimeToken"];
            this.phoneNumber = _data["PhoneNumber"];
            this.fullName = _data["FullName"];
            this.avatarId = _data["AvatarId"];
            this.laQuanTriVien = _data["LaQuanTriVien"];
            this.laNhanVien = _data["LaNhanVien"];
            this.laKhachHang = _data["LaKhachHang"];
            this.isSubAdmin = _data["IsSubAdmin"];
        }
    }

    static fromJS(data: any): TokenPayload {
        data = typeof data === 'object' ? data : {};
        let result = new TokenPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ExpiredTime"] = this.expiredTime;
        data["Username"] = this.username;
        data["CreateTimeToken"] = this.createTimeToken;
        data["PhoneNumber"] = this.phoneNumber;
        data["FullName"] = this.fullName;
        data["AvatarId"] = this.avatarId;
        data["LaQuanTriVien"] = this.laQuanTriVien;
        data["LaNhanVien"] = this.laNhanVien;
        data["LaKhachHang"] = this.laKhachHang;
        data["IsSubAdmin"] = this.isSubAdmin;
        return data;
    }
}

export interface ITokenPayload {
    id: string;
    expiredTime: number;
    username?: string | undefined;
    createTimeToken: number;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatarId?: string | undefined;
    laQuanTriVien: boolean;
    laNhanVien: boolean;
    laKhachHang: boolean;
    isSubAdmin: boolean;
}

export class LoginRequest implements ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;
    captchaToken?: string | undefined;
    firebaseToken?: string | undefined;
    deviceId?: string | undefined;
    osPlatform?: string | undefined;
    osVersion?: string | undefined;
    remember?: boolean | undefined;
    userRole?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.password = _data["Password"];
            this.captchaToken = _data["CaptchaToken"];
            this.firebaseToken = _data["FirebaseToken"];
            this.deviceId = _data["DeviceId"];
            this.osPlatform = _data["OsPlatform"];
            this.osVersion = _data["OsVersion"];
            this.remember = _data["Remember"];
            this.userRole = _data["UserRole"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["Password"] = this.password;
        data["CaptchaToken"] = this.captchaToken;
        data["FirebaseToken"] = this.firebaseToken;
        data["DeviceId"] = this.deviceId;
        data["OsPlatform"] = this.osPlatform;
        data["OsVersion"] = this.osVersion;
        data["Remember"] = this.remember;
        data["UserRole"] = this.userRole;
        return data;
    }
}

export interface ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;
    captchaToken?: string | undefined;
    firebaseToken?: string | undefined;
    deviceId?: string | undefined;
    osPlatform?: string | undefined;
    osVersion?: string | undefined;
    remember?: boolean | undefined;
    userRole?: string | undefined;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.refreshToken = _data["RefreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["RefreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class ChangePasswordOfForgotRequest implements IChangePasswordOfForgotRequest {
    accountId?: string | undefined;
    oTPCode?: string | undefined;
    password?: string | undefined;

    constructor(data?: IChangePasswordOfForgotRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["AccountId"];
            this.oTPCode = _data["OTPCode"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): ChangePasswordOfForgotRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordOfForgotRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId;
        data["OTPCode"] = this.oTPCode;
        data["Password"] = this.password;
        return data;
    }
}

export interface IChangePasswordOfForgotRequest {
    accountId?: string | undefined;
    oTPCode?: string | undefined;
    password?: string | undefined;
}

export class BodyUsedDto implements IBodyUsedDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IBodyUsedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): BodyUsedDto {
        data = typeof data === 'object' ? data : {};
        let result = new BodyUsedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IBodyUsedDto {
    id: number;
    name?: string | undefined;
}

export class CheckNameExistsRequest implements ICheckNameExistsRequest {
    name?: string | undefined;
    nameOld?: string | undefined;

    constructor(data?: ICheckNameExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.nameOld = _data["NameOld"];
        }
    }

    static fromJS(data: any): CheckNameExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckNameExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["NameOld"] = this.nameOld;
        return data;
    }
}

export interface ICheckNameExistsRequest {
    name?: string | undefined;
    nameOld?: string | undefined;
}

export class CreateCategoryRequest implements ICreateCategoryRequest {
    parentId!: number;
    ten?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    createId?: string | undefined;

    constructor(data?: ICreateCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["ParentId"];
            this.ten = _data["Ten"];
            this.moTa = _data["MoTa"];
            this.anhBiaId = _data["AnhBiaId"];
            this.createId = _data["CreateId"];
        }
    }

    static fromJS(data: any): CreateCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ParentId"] = this.parentId;
        data["Ten"] = this.ten;
        data["MoTa"] = this.moTa;
        data["AnhBiaId"] = this.anhBiaId;
        data["CreateId"] = this.createId;
        return data;
    }
}

export interface ICreateCategoryRequest {
    parentId: number;
    ten?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    createId?: string | undefined;
}

export class CategoryDto implements ICategoryDto {
    id!: number;
    parentId!: number;
    loaiHinh?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    createdTime!: Date;
    updatedTime?: Date | undefined;
    createdId?: string | undefined;
    updatedId?: string | undefined;
    isDeleted?: boolean | undefined;
    deletedTime?: Date | undefined;
    deletedId?: string | undefined;
    ten?: string | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.parentId = _data["ParentId"];
            this.loaiHinh = _data["LoaiHinh"];
            this.moTa = _data["MoTa"];
            this.anhBiaId = _data["AnhBiaId"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.updatedTime = _data["UpdatedTime"] ? new Date(_data["UpdatedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.updatedId = _data["UpdatedId"];
            this.isDeleted = _data["IsDeleted"];
            this.deletedTime = _data["DeletedTime"] ? new Date(_data["DeletedTime"].toString()) : <any>undefined;
            this.deletedId = _data["DeletedId"];
            this.ten = _data["Ten"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ParentId"] = this.parentId;
        data["LoaiHinh"] = this.loaiHinh;
        data["MoTa"] = this.moTa;
        data["AnhBiaId"] = this.anhBiaId;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["UpdatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["UpdatedId"] = this.updatedId;
        data["IsDeleted"] = this.isDeleted;
        data["DeletedTime"] = this.deletedTime ? this.deletedTime.toISOString() : <any>undefined;
        data["DeletedId"] = this.deletedId;
        data["Ten"] = this.ten;
        return data;
    }
}

export interface ICategoryDto {
    id: number;
    parentId: number;
    loaiHinh?: string | undefined;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    createdTime: Date;
    updatedTime?: Date | undefined;
    createdId?: string | undefined;
    updatedId?: string | undefined;
    isDeleted?: boolean | undefined;
    deletedTime?: Date | undefined;
    deletedId?: string | undefined;
    ten?: string | undefined;
}

export class UpdateCategoryRequest implements IUpdateCategoryRequest {
    id!: number;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    updatedId?: string | undefined;
    ten?: string | undefined;

    constructor(data?: IUpdateCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.moTa = _data["MoTa"];
            this.anhBiaId = _data["AnhBiaId"];
            this.updatedId = _data["UpdatedId"];
            this.ten = _data["Ten"];
        }
    }

    static fromJS(data: any): UpdateCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["MoTa"] = this.moTa;
        data["AnhBiaId"] = this.anhBiaId;
        data["UpdatedId"] = this.updatedId;
        data["Ten"] = this.ten;
        return data;
    }
}

export interface IUpdateCategoryRequest {
    id: number;
    moTa?: string | undefined;
    anhBiaId?: string | undefined;
    updatedId?: string | undefined;
    ten?: string | undefined;
}

export class PaginatorResponseOfCategoryResponse implements IPaginatorResponseOfCategoryResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: CategoryResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(CategoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfCategoryResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: CategoryResponse[] | undefined;
}

export class CategoryResponse implements ICategoryResponse {
    id!: number;
    children?: CategoryResponse[] | undefined;
    name?: string | undefined;
    breadCum?: string | undefined;
    loaiHinh?: string | undefined;
    moTa?: string | undefined;
    isShowSub!: boolean;

    constructor(data?: ICategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            if (Array.isArray(_data["Children"])) {
                this.children = [] as any;
                for (let item of _data["Children"])
                    this.children!.push(CategoryResponse.fromJS(item));
            }
            this.name = _data["Name"];
            this.breadCum = _data["BreadCum"];
            this.loaiHinh = _data["LoaiHinh"];
            this.moTa = _data["MoTa"];
            this.isShowSub = _data["IsShowSub"];
        }
    }

    static fromJS(data: any): CategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        if (Array.isArray(this.children)) {
            data["Children"] = [];
            for (let item of this.children)
                data["Children"].push(item.toJSON());
        }
        data["Name"] = this.name;
        data["BreadCum"] = this.breadCum;
        data["LoaiHinh"] = this.loaiHinh;
        data["MoTa"] = this.moTa;
        data["IsShowSub"] = this.isShowSub;
        return data;
    }
}

export interface ICategoryResponse {
    id: number;
    children?: CategoryResponse[] | undefined;
    name?: string | undefined;
    breadCum?: string | undefined;
    loaiHinh?: string | undefined;
    moTa?: string | undefined;
    isShowSub: boolean;
}

export class GetListCategoryRequest implements IGetListCategoryRequest {
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    keySearch?: string | undefined;
    type?: number | undefined;

    constructor(data?: IGetListCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["PageIndex"];
            this.pageSize = _data["PageSize"];
            this.keySearch = _data["KeySearch"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): GetListCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageIndex"] = this.pageIndex;
        data["PageSize"] = this.pageSize;
        data["KeySearch"] = this.keySearch;
        data["Type"] = this.type;
        return data;
    }
}

export interface IGetListCategoryRequest {
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    keySearch?: string | undefined;
    type?: number | undefined;
}

export class ObjectEnumOfReceiptBookItemEnum implements IObjectEnumOfReceiptBookItemEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: ReceiptBookItemEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfReceiptBookItemEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfReceiptBookItemEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfReceiptBookItemEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfReceiptBookItemEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: ReceiptBookItemEnum;
    checked: boolean;
}

export enum ReceiptBookItemEnum {
    TOTAL_INCOME = 0,
    TOTAL_SPEND = 1,
}

export class ObjectEnumOfOrderTypeEnum implements IObjectEnumOfOrderTypeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: OrderTypeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfOrderTypeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfOrderTypeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfOrderTypeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfOrderTypeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: OrderTypeEnum;
    checked: boolean;
}

export enum OrderTypeEnum {
    BAN_NHANH = 0,
    BAN_THUONG = 1,
}

export class ObjectEnumOfOrderChanelEnum implements IObjectEnumOfOrderChanelEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: OrderChanelEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfOrderChanelEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfOrderChanelEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfOrderChanelEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfOrderChanelEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: OrderChanelEnum;
    checked: boolean;
}

export enum OrderChanelEnum {
    BAN_TRUC_TIEP = 0,
    OTHER = 1,
}

export class ObjectEnumOfOrderCustomerStatusEnum implements IObjectEnumOfOrderCustomerStatusEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: OrderCustomerStatusEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfOrderCustomerStatusEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfOrderCustomerStatusEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfOrderCustomerStatusEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfOrderCustomerStatusEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: OrderCustomerStatusEnum;
    checked: boolean;
}

export enum OrderCustomerStatusEnum {
    DONE = 0,
    CANCEl = 1,
    DRAFT = 2,
    WAITING_ORDER_CONFIRM = 3,
    Paid = 4,
    PARTIAL_PAYMENT = 5,
}

export class ObjectEnumOfPaymentTypeEnum implements IObjectEnumOfPaymentTypeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: PaymentTypeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfPaymentTypeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfPaymentTypeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfPaymentTypeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfPaymentTypeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: PaymentTypeEnum;
    checked: boolean;
}

export enum PaymentTypeEnum {
    TIEN_MAT = 0,
    THE = 1,
    CHUYEN_KHOAN = 2,
    CHUA_THANH_TOAN = 3,
}

export class ObjectEnumOfPurchaseOrderStatusEnum implements IObjectEnumOfPurchaseOrderStatusEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: PurchaseOrderStatusEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfPurchaseOrderStatusEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfPurchaseOrderStatusEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfPurchaseOrderStatusEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfPurchaseOrderStatusEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: PurchaseOrderStatusEnum;
    checked: boolean;
}

export enum PurchaseOrderStatusEnum {
    DRAFT = 0,
    DONE = 1,
    CANCEL = 2,
    PARTIAL_PAYMENT = 3,
    PENDING = 4,
}

export class ObjectEnumOfDiscountTypeEnum implements IObjectEnumOfDiscountTypeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: DiscountTypeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfDiscountTypeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfDiscountTypeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfDiscountTypeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfDiscountTypeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: DiscountTypeEnum;
    checked: boolean;
}

export enum DiscountTypeEnum {
    VND = 0,
    PERCENT = 1,
    NONE = 2,
}

export class ObjectEnumOfProductPickupStatusEnum implements IObjectEnumOfProductPickupStatusEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: ProductPickupStatusEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfProductPickupStatusEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfProductPickupStatusEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfProductPickupStatusEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfProductPickupStatusEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: ProductPickupStatusEnum;
    checked: boolean;
}

export enum ProductPickupStatusEnum {
    UNPAID_DEBT = 0,
    PAID = 1,
    DRAFT = 2,
}

export class ObjectEnumOfCashFlowNegativeEnum implements IObjectEnumOfCashFlowNegativeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: CashFlowNegativeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfCashFlowNegativeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfCashFlowNegativeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfCashFlowNegativeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfCashFlowNegativeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: CashFlowNegativeEnum;
    checked: boolean;
}

export enum CashFlowNegativeEnum {
    Positive = 0,
    Negative = 1,
}

export class ObjectEnumOfOrderCustomerTypeEnum implements IObjectEnumOfOrderCustomerTypeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: OrderCustomerTypeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfOrderCustomerTypeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfOrderCustomerTypeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfOrderCustomerTypeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfOrderCustomerTypeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: OrderCustomerTypeEnum;
    checked: boolean;
}

export enum OrderCustomerTypeEnum {
    BAN_LE = 0,
    DONG_DON = 1,
}

export class ObjectEnumOfSupplierTypeEnum implements IObjectEnumOfSupplierTypeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: SupplierTypeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfSupplierTypeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfSupplierTypeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfSupplierTypeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfSupplierTypeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: SupplierTypeEnum;
    checked: boolean;
}

export enum SupplierTypeEnum {
    NHA_CUNG_CAP = 0,
    QUAY_HANG = 1,
}

export class ObjectEnumOfGenderEnum implements IObjectEnumOfGenderEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: GenderEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfGenderEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfGenderEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfGenderEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfGenderEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: GenderEnum;
    checked: boolean;
}

export class ObjectEnumOfCustomerTypeEnum implements IObjectEnumOfCustomerTypeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: CustomerTypeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfCustomerTypeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfCustomerTypeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfCustomerTypeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfCustomerTypeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: CustomerTypeEnum;
    checked: boolean;
}

export enum CustomerTypeEnum {
    Ca_Nhan = 0,
    Cong_ty = 1,
}

export class ObjectEnumOfFileTypeEnum implements IObjectEnumOfFileTypeEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: FileTypeEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfFileTypeEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfFileTypeEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfFileTypeEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfFileTypeEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: FileTypeEnum;
    checked: boolean;
}

export enum FileTypeEnum {
    AvatarAccount = 0,
    BannerCategoryJob = 2,
    BannerTinTuc = 3,
    LogoDoiTac = 4,
    ImageDoiTac = 5,
    CkEditor = 6,
    AnhBiaDonHang = 7,
    LogoBank = 8,
    FileCvLdMoi = 9,
    FileCvLaoDongDacDinh = 10,
    FilePdf = 11,
    FileVideo = 12,
}

export class ObjectEnumOfMucDoUuTienTinTucEnum implements IObjectEnumOfMucDoUuTienTinTucEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: MucDoUuTienTinTucEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfMucDoUuTienTinTucEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfMucDoUuTienTinTucEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfMucDoUuTienTinTucEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfMucDoUuTienTinTucEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: MucDoUuTienTinTucEnum;
    checked: boolean;
}

export class ObjectEnumOfImageEnum implements IObjectEnumOfImageEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: ImageEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfImageEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfImageEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfImageEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfImageEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: ImageEnum;
    checked: boolean;
}

export enum ImageEnum {
    BannerType = 0,
    AvatarType = 1,
    Thumbnail = 2,
    BannerQC1Type = 3,
    BannerQC2Type = 4,
    BannerQC3Type = 5,
    BannerQC4Type = 6,
    BannerQC5Type = 7,
    BannerQC6Type = 8,
    BannerQC7Type = 9,
    None = -1,
}

export class ObjectEnumOfProductEnum implements IObjectEnumOfProductEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: ProductEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfProductEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfProductEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfProductEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfProductEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: ProductEnum;
    checked: boolean;
}

export enum ProductEnum {
    Thuoc = 0,
    HangHoa = 1,
    DichVu = 2,
    ComBo_DongGoi = 3,
}

export class ObjectEnumOfProductStatusEnum implements IObjectEnumOfProductStatusEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: ProductStatusEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfProductStatusEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfProductStatusEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfProductStatusEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfProductStatusEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: ProductStatusEnum;
    checked: boolean;
}

export enum ProductStatusEnum {
    ACTIVE = 0,
    DEACTIVE = 1,
}

export class ObjectEnumOfStoreEnum implements IObjectEnumOfStoreEnum {
    description?: string | undefined;
    value!: number;
    key?: string | undefined;
    origin!: StoreEnum;
    checked!: boolean;

    constructor(data?: IObjectEnumOfStoreEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["Description"];
            this.value = _data["Value"];
            this.key = _data["Key"];
            this.origin = _data["Origin"];
            this.checked = _data["Checked"];
        }
    }

    static fromJS(data: any): ObjectEnumOfStoreEnum {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectEnumOfStoreEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Value"] = this.value;
        data["Key"] = this.key;
        data["Origin"] = this.origin;
        data["Checked"] = this.checked;
        return data;
    }
}

export interface IObjectEnumOfStoreEnum {
    description?: string | undefined;
    value: number;
    key?: string | undefined;
    origin: StoreEnum;
    checked: boolean;
}

export enum StoreEnum {
    DuongPham = 1,
    Branch1 = 2,
    Branch2 = 3,
    DongDa = 4,
    CauGiấy = 5,
}

export class CRM_PhuongXaDto implements ICRM_PhuongXaDto {
    maPhuongXa?: string | undefined;
    tenPhuongXa?: string | undefined;
    maQuanHuyen?: string | undefined;
    tenQuanHuyen?: string | undefined;
    maTinhThanh?: string | undefined;
    tenTinhThanh?: string | undefined;
    lstSearchTag?: SearchTag[] | undefined;
    tenDayDuKhongDau?: string | undefined;
    abbr?: string | undefined;
    point!: number;

    constructor(data?: ICRM_PhuongXaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maPhuongXa = _data["MaPhuongXa"];
            this.tenPhuongXa = _data["TenPhuongXa"];
            this.maQuanHuyen = _data["MaQuanHuyen"];
            this.tenQuanHuyen = _data["TenQuanHuyen"];
            this.maTinhThanh = _data["MaTinhThanh"];
            this.tenTinhThanh = _data["TenTinhThanh"];
            if (Array.isArray(_data["LstSearchTag"])) {
                this.lstSearchTag = [] as any;
                for (let item of _data["LstSearchTag"])
                    this.lstSearchTag!.push(SearchTag.fromJS(item));
            }
            this.tenDayDuKhongDau = _data["TenDayDuKhongDau"];
            this.abbr = _data["Abbr"];
            this.point = _data["Point"];
        }
    }

    static fromJS(data: any): CRM_PhuongXaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CRM_PhuongXaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaPhuongXa"] = this.maPhuongXa;
        data["TenPhuongXa"] = this.tenPhuongXa;
        data["MaQuanHuyen"] = this.maQuanHuyen;
        data["TenQuanHuyen"] = this.tenQuanHuyen;
        data["MaTinhThanh"] = this.maTinhThanh;
        data["TenTinhThanh"] = this.tenTinhThanh;
        if (Array.isArray(this.lstSearchTag)) {
            data["LstSearchTag"] = [];
            for (let item of this.lstSearchTag)
                data["LstSearchTag"].push(item.toJSON());
        }
        data["TenDayDuKhongDau"] = this.tenDayDuKhongDau;
        data["Abbr"] = this.abbr;
        data["Point"] = this.point;
        return data;
    }
}

export interface ICRM_PhuongXaDto {
    maPhuongXa?: string | undefined;
    tenPhuongXa?: string | undefined;
    maQuanHuyen?: string | undefined;
    tenQuanHuyen?: string | undefined;
    maTinhThanh?: string | undefined;
    tenTinhThanh?: string | undefined;
    lstSearchTag?: SearchTag[] | undefined;
    tenDayDuKhongDau?: string | undefined;
    abbr?: string | undefined;
    point: number;
}

export class SearchTag implements ISearchTag {
    key?: string | undefined;
    point!: number;

    constructor(data?: ISearchTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["Key"];
            this.point = _data["Point"];
        }
    }

    static fromJS(data: any): SearchTag {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key;
        data["Point"] = this.point;
        return data;
    }
}

export interface ISearchTag {
    key?: string | undefined;
    point: number;
}

export class FilterCrmPhuongXaWithTagRequest implements IFilterCrmPhuongXaWithTagRequest {
    keySearch?: string | undefined;
    maTinhThanh?: string | undefined;
    maQuanHuyen?: string | undefined;

    constructor(data?: IFilterCrmPhuongXaWithTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keySearch = _data["KeySearch"];
            this.maTinhThanh = _data["MaTinhThanh"];
            this.maQuanHuyen = _data["MaQuanHuyen"];
        }
    }

    static fromJS(data: any): FilterCrmPhuongXaWithTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCrmPhuongXaWithTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["KeySearch"] = this.keySearch;
        data["MaTinhThanh"] = this.maTinhThanh;
        data["MaQuanHuyen"] = this.maQuanHuyen;
        return data;
    }
}

export interface IFilterCrmPhuongXaWithTagRequest {
    keySearch?: string | undefined;
    maTinhThanh?: string | undefined;
    maQuanHuyen?: string | undefined;
}

export class CRM_QuanHuyenDto implements ICRM_QuanHuyenDto {
    maQuanHuyen?: string | undefined;
    tenQuanHuyen?: string | undefined;
    maTinhThanh?: string | undefined;
    tenTinhThanh?: string | undefined;
    lstSearchTag?: SearchTag[] | undefined;
    tenDayDuKhongDau?: string | undefined;
    point!: number;

    constructor(data?: ICRM_QuanHuyenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maQuanHuyen = _data["MaQuanHuyen"];
            this.tenQuanHuyen = _data["TenQuanHuyen"];
            this.maTinhThanh = _data["MaTinhThanh"];
            this.tenTinhThanh = _data["TenTinhThanh"];
            if (Array.isArray(_data["LstSearchTag"])) {
                this.lstSearchTag = [] as any;
                for (let item of _data["LstSearchTag"])
                    this.lstSearchTag!.push(SearchTag.fromJS(item));
            }
            this.tenDayDuKhongDau = _data["TenDayDuKhongDau"];
            this.point = _data["Point"];
        }
    }

    static fromJS(data: any): CRM_QuanHuyenDto {
        data = typeof data === 'object' ? data : {};
        let result = new CRM_QuanHuyenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaQuanHuyen"] = this.maQuanHuyen;
        data["TenQuanHuyen"] = this.tenQuanHuyen;
        data["MaTinhThanh"] = this.maTinhThanh;
        data["TenTinhThanh"] = this.tenTinhThanh;
        if (Array.isArray(this.lstSearchTag)) {
            data["LstSearchTag"] = [];
            for (let item of this.lstSearchTag)
                data["LstSearchTag"].push(item.toJSON());
        }
        data["TenDayDuKhongDau"] = this.tenDayDuKhongDau;
        data["Point"] = this.point;
        return data;
    }
}

export interface ICRM_QuanHuyenDto {
    maQuanHuyen?: string | undefined;
    tenQuanHuyen?: string | undefined;
    maTinhThanh?: string | undefined;
    tenTinhThanh?: string | undefined;
    lstSearchTag?: SearchTag[] | undefined;
    tenDayDuKhongDau?: string | undefined;
    point: number;
}

export class FilterCrmQuanHuyenWithTagRequest implements IFilterCrmQuanHuyenWithTagRequest {
    keySearch?: string | undefined;
    maTinhThanh?: string | undefined;

    constructor(data?: IFilterCrmQuanHuyenWithTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keySearch = _data["KeySearch"];
            this.maTinhThanh = _data["MaTinhThanh"];
        }
    }

    static fromJS(data: any): FilterCrmQuanHuyenWithTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCrmQuanHuyenWithTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["KeySearch"] = this.keySearch;
        data["MaTinhThanh"] = this.maTinhThanh;
        return data;
    }
}

export interface IFilterCrmQuanHuyenWithTagRequest {
    keySearch?: string | undefined;
    maTinhThanh?: string | undefined;
}

export class CRM_TinhThanhDto implements ICRM_TinhThanhDto {
    maTinhThanh?: string | undefined;
    tenTinhThanh?: string | undefined;
    lstSearchTag?: SearchTag[] | undefined;
    tenDayDuKhongDau?: string | undefined;
    point!: number;

    constructor(data?: ICRM_TinhThanhDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maTinhThanh = _data["MaTinhThanh"];
            this.tenTinhThanh = _data["TenTinhThanh"];
            if (Array.isArray(_data["LstSearchTag"])) {
                this.lstSearchTag = [] as any;
                for (let item of _data["LstSearchTag"])
                    this.lstSearchTag!.push(SearchTag.fromJS(item));
            }
            this.tenDayDuKhongDau = _data["TenDayDuKhongDau"];
            this.point = _data["Point"];
        }
    }

    static fromJS(data: any): CRM_TinhThanhDto {
        data = typeof data === 'object' ? data : {};
        let result = new CRM_TinhThanhDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaTinhThanh"] = this.maTinhThanh;
        data["TenTinhThanh"] = this.tenTinhThanh;
        if (Array.isArray(this.lstSearchTag)) {
            data["LstSearchTag"] = [];
            for (let item of this.lstSearchTag)
                data["LstSearchTag"].push(item.toJSON());
        }
        data["TenDayDuKhongDau"] = this.tenDayDuKhongDau;
        data["Point"] = this.point;
        return data;
    }
}

export interface ICRM_TinhThanhDto {
    maTinhThanh?: string | undefined;
    tenTinhThanh?: string | undefined;
    lstSearchTag?: SearchTag[] | undefined;
    tenDayDuKhongDau?: string | undefined;
    point: number;
}

export class PaginatorResponseOfCustomerDto implements IPaginatorResponseOfCustomerDto {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: CustomerDto[] | undefined;

    constructor(data?: IPaginatorResponseOfCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(CustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfCustomerDto {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: CustomerDto[] | undefined;
}

export class CustomerDto implements ICustomerDto {
    id!: number;
    name?: string | undefined;
    debt!: number;
    phone?: string | undefined;
    phoneSub?: string | undefined;
    address?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    fullAddress?: string | undefined;
    phuongXaCode?: string | undefined;
    dateOfBirth?: Date | undefined;
    maSoThue?: string | undefined;
    email?: string | undefined;
    facebook?: string | undefined;
    note?: string | undefined;
    avartaId?: string | undefined;
    type!: number;
    isDeleted!: boolean;
    deleteTime?: Date | undefined;
    createdTime!: Date;
    createdId!: string;
    deletedId?: string | undefined;
    code?: string | undefined;
    gender!: boolean;
    isActive!: boolean;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.debt = _data["Debt"];
            this.phone = _data["Phone"];
            this.phoneSub = _data["PhoneSub"];
            this.address = _data["Address"];
            this.tinhThanhCode = _data["TinhThanhCode"];
            this.quanHuyenCode = _data["QuanHuyenCode"];
            this.fullAddress = _data["FullAddress"];
            this.phuongXaCode = _data["PhuongXaCode"];
            this.dateOfBirth = _data["DateOfBirth"] ? new Date(_data["DateOfBirth"].toString()) : <any>undefined;
            this.maSoThue = _data["MaSoThue"];
            this.email = _data["Email"];
            this.facebook = _data["Facebook"];
            this.note = _data["Note"];
            this.avartaId = _data["AvartaId"];
            this.type = _data["Type"];
            this.isDeleted = _data["IsDeleted"];
            this.deleteTime = _data["DeleteTime"] ? new Date(_data["DeleteTime"].toString()) : <any>undefined;
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.deletedId = _data["DeletedId"];
            this.code = _data["Code"];
            this.gender = _data["Gender"];
            this.isActive = _data["IsActive"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Debt"] = this.debt;
        data["Phone"] = this.phone;
        data["PhoneSub"] = this.phoneSub;
        data["Address"] = this.address;
        data["TinhThanhCode"] = this.tinhThanhCode;
        data["QuanHuyenCode"] = this.quanHuyenCode;
        data["FullAddress"] = this.fullAddress;
        data["PhuongXaCode"] = this.phuongXaCode;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["MaSoThue"] = this.maSoThue;
        data["Email"] = this.email;
        data["Facebook"] = this.facebook;
        data["Note"] = this.note;
        data["AvartaId"] = this.avartaId;
        data["Type"] = this.type;
        data["IsDeleted"] = this.isDeleted;
        data["DeleteTime"] = this.deleteTime ? this.deleteTime.toISOString() : <any>undefined;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["DeletedId"] = this.deletedId;
        data["Code"] = this.code;
        data["Gender"] = this.gender;
        data["IsActive"] = this.isActive;
        return data;
    }
}

export interface ICustomerDto {
    id: number;
    name?: string | undefined;
    debt: number;
    phone?: string | undefined;
    phoneSub?: string | undefined;
    address?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    fullAddress?: string | undefined;
    phuongXaCode?: string | undefined;
    dateOfBirth?: Date | undefined;
    maSoThue?: string | undefined;
    email?: string | undefined;
    facebook?: string | undefined;
    note?: string | undefined;
    avartaId?: string | undefined;
    type: number;
    isDeleted: boolean;
    deleteTime?: Date | undefined;
    createdTime: Date;
    createdId: string;
    deletedId?: string | undefined;
    code?: string | undefined;
    gender: boolean;
    isActive: boolean;
}

export class DeleteModelRequest implements IDeleteModelRequest {
    idInt?: number | undefined;
    idGuid?: string | undefined;

    constructor(data?: IDeleteModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idInt = _data["IdInt"];
            this.idGuid = _data["IdGuid"];
        }
    }

    static fromJS(data: any): DeleteModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IdInt"] = this.idInt;
        data["IdGuid"] = this.idGuid;
        return data;
    }
}

export interface IDeleteModelRequest {
    idInt?: number | undefined;
    idGuid?: string | undefined;
}

export class ActiveDeactiveModel implements IActiveDeactiveModel {
    id!: number;
    status!: boolean;

    constructor(data?: IActiveDeactiveModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): ActiveDeactiveModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDeactiveModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Status"] = this.status;
        return data;
    }
}

export interface IActiveDeactiveModel {
    id: number;
    status: boolean;
}

export class CreateCustomerRequest implements ICreateCustomerRequest {
    id!: number;
    name?: string | undefined;
    phone?: string | undefined;
    phoneSub?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    phuongXaCode?: string | undefined;
    dateOfBirth?: Date | undefined;
    maSoThue?: string | undefined;
    email?: string | undefined;
    facebook?: string | undefined;
    note?: string | undefined;
    avartaId?: string | undefined;
    type!: number;
    address?: string | undefined;
    gender?: GenderEnum | undefined;
    code?: string | undefined;

    constructor(data?: ICreateCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.phone = _data["Phone"];
            this.phoneSub = _data["PhoneSub"];
            this.tinhThanhCode = _data["TinhThanhCode"];
            this.quanHuyenCode = _data["QuanHuyenCode"];
            this.phuongXaCode = _data["PhuongXaCode"];
            this.dateOfBirth = _data["DateOfBirth"] ? new Date(_data["DateOfBirth"].toString()) : <any>undefined;
            this.maSoThue = _data["MaSoThue"];
            this.email = _data["Email"];
            this.facebook = _data["Facebook"];
            this.note = _data["Note"];
            this.avartaId = _data["AvartaId"];
            this.type = _data["Type"];
            this.address = _data["Address"];
            this.gender = _data["Gender"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): CreateCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Phone"] = this.phone;
        data["PhoneSub"] = this.phoneSub;
        data["TinhThanhCode"] = this.tinhThanhCode;
        data["QuanHuyenCode"] = this.quanHuyenCode;
        data["PhuongXaCode"] = this.phuongXaCode;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["MaSoThue"] = this.maSoThue;
        data["Email"] = this.email;
        data["Facebook"] = this.facebook;
        data["Note"] = this.note;
        data["AvartaId"] = this.avartaId;
        data["Type"] = this.type;
        data["Address"] = this.address;
        data["Gender"] = this.gender;
        data["Code"] = this.code;
        return data;
    }
}

export interface ICreateCustomerRequest {
    id: number;
    name?: string | undefined;
    phone?: string | undefined;
    phoneSub?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    phuongXaCode?: string | undefined;
    dateOfBirth?: Date | undefined;
    maSoThue?: string | undefined;
    email?: string | undefined;
    facebook?: string | undefined;
    note?: string | undefined;
    avartaId?: string | undefined;
    type: number;
    address?: string | undefined;
    gender?: GenderEnum | undefined;
    code?: string | undefined;
}

export class CheckIsCodeExistsRequest implements ICheckIsCodeExistsRequest {
    code?: string | undefined;
    oldCode?: string | undefined;
    supplierType?: SupplierTypeEnum | undefined;

    constructor(data?: ICheckIsCodeExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.oldCode = _data["OldCode"];
            this.supplierType = _data["SupplierType"];
        }
    }

    static fromJS(data: any): CheckIsCodeExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckIsCodeExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["OldCode"] = this.oldCode;
        data["SupplierType"] = this.supplierType;
        return data;
    }
}

export interface ICheckIsCodeExistsRequest {
    code?: string | undefined;
    oldCode?: string | undefined;
    supplierType?: SupplierTypeEnum | undefined;
}

export class CreateDailyExpenseReportRequest implements ICreateDailyExpenseReportRequest {
    reportDate!: Date;
    storeId!: number;
    employeeId?: string | undefined;
    totalBudget?: number | undefined;
    note?: string | undefined;
    createId?: string | undefined;
    details?: CreateExpenseDetailRequest[] | undefined;

    constructor(data?: ICreateDailyExpenseReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportDate = _data["ReportDate"] ? new Date(_data["ReportDate"].toString()) : <any>undefined;
            this.storeId = _data["StoreId"];
            this.employeeId = _data["EmployeeId"];
            this.totalBudget = _data["TotalBudget"];
            this.note = _data["Note"];
            this.createId = _data["CreateId"];
            if (Array.isArray(_data["Details"])) {
                this.details = [] as any;
                for (let item of _data["Details"])
                    this.details!.push(CreateExpenseDetailRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDailyExpenseReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDailyExpenseReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportDate"] = this.reportDate ? this.reportDate.toISOString() : <any>undefined;
        data["StoreId"] = this.storeId;
        data["EmployeeId"] = this.employeeId;
        data["TotalBudget"] = this.totalBudget;
        data["Note"] = this.note;
        data["CreateId"] = this.createId;
        if (Array.isArray(this.details)) {
            data["Details"] = [];
            for (let item of this.details)
                data["Details"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateDailyExpenseReportRequest {
    reportDate: Date;
    storeId: number;
    employeeId?: string | undefined;
    totalBudget?: number | undefined;
    note?: string | undefined;
    createId?: string | undefined;
    details?: CreateExpenseDetailRequest[] | undefined;
}

export class CreateExpenseDetailRequest implements ICreateExpenseDetailRequest {
    reportId?: number | undefined;
    categoryId!: number;
    paymentMethodId?: number | undefined;
    expenseDate!: Date;
    amount!: number;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    description?: string | undefined;
    vendor?: string | undefined;
    invoiceNumber?: string | undefined;
    reference?: string | undefined;
    attachmentUrl?: string | undefined;
    attachmentType?: string | undefined;
    transactionType?: string | undefined;
    isLoggedToSystem!: boolean;
    refundAmount?: number | undefined;
    refundCategoryId?: number | undefined;
    createId?: string | undefined;

    constructor(data?: ICreateExpenseDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["ReportId"];
            this.categoryId = _data["CategoryId"];
            this.paymentMethodId = _data["PaymentMethodId"];
            this.expenseDate = _data["ExpenseDate"] ? new Date(_data["ExpenseDate"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.description = _data["Description"];
            this.vendor = _data["Vendor"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.reference = _data["Reference"];
            this.attachmentUrl = _data["AttachmentUrl"];
            this.attachmentType = _data["AttachmentType"];
            this.transactionType = _data["TransactionType"];
            this.isLoggedToSystem = _data["IsLoggedToSystem"];
            this.refundAmount = _data["RefundAmount"];
            this.refundCategoryId = _data["RefundCategoryId"];
            this.createId = _data["CreateId"];
        }
    }

    static fromJS(data: any): CreateExpenseDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpenseDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportId"] = this.reportId;
        data["CategoryId"] = this.categoryId;
        data["PaymentMethodId"] = this.paymentMethodId;
        data["ExpenseDate"] = this.expenseDate ? this.expenseDate.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["Description"] = this.description;
        data["Vendor"] = this.vendor;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["Reference"] = this.reference;
        data["AttachmentUrl"] = this.attachmentUrl;
        data["AttachmentType"] = this.attachmentType;
        data["TransactionType"] = this.transactionType;
        data["IsLoggedToSystem"] = this.isLoggedToSystem;
        data["RefundAmount"] = this.refundAmount;
        data["RefundCategoryId"] = this.refundCategoryId;
        data["CreateId"] = this.createId;
        return data;
    }
}

export interface ICreateExpenseDetailRequest {
    reportId?: number | undefined;
    categoryId: number;
    paymentMethodId?: number | undefined;
    expenseDate: Date;
    amount: number;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    description?: string | undefined;
    vendor?: string | undefined;
    invoiceNumber?: string | undefined;
    reference?: string | undefined;
    attachmentUrl?: string | undefined;
    attachmentType?: string | undefined;
    transactionType?: string | undefined;
    isLoggedToSystem: boolean;
    refundAmount?: number | undefined;
    refundCategoryId?: number | undefined;
    createId?: string | undefined;
}

export class DailyExpenseReportDto implements IDailyExpenseReportDto {
    id!: number;
    reportCode?: string | undefined;
    reportDate!: Date;
    storeId!: number;
    employeeId?: string | undefined;
    totalExpense!: number;
    totalRevenue!: number;
    totalRefund!: number;
    totalBudget?: number | undefined;
    actualCash?: number | undefined;
    budgetVariance?: number | undefined;
    balanceForNextDay?: number | undefined;
    status?: string | undefined;
    submittedAt?: Date | undefined;
    submittedBy?: string | undefined;
    approvedAt?: Date | undefined;
    approvedBy?: string | undefined;
    rejectedAt?: Date | undefined;
    rejectedBy?: string | undefined;
    rejectionReason?: string | undefined;
    note?: string | undefined;
    createdBy?: string | undefined;
    createdAt!: Date;
    updatedAt?: Date | undefined;
    isDeleted!: boolean;
    employeeName?: string | undefined;
    storeName?: string | undefined;
    submittedByName?: string | undefined;
    approvedByName?: string | undefined;
    rejectedByName?: string | undefined;
    createdByName?: string | undefined;
    isOverBudget!: boolean;
    detailCount!: number;
    totalOrderCount!: number;
    totalCustomerCount!: number;
    details?: ExpenseDetailDto[] | undefined;

    constructor(data?: IDailyExpenseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.reportCode = _data["ReportCode"];
            this.reportDate = _data["ReportDate"] ? new Date(_data["ReportDate"].toString()) : <any>undefined;
            this.storeId = _data["StoreId"];
            this.employeeId = _data["EmployeeId"];
            this.totalExpense = _data["TotalExpense"];
            this.totalRevenue = _data["TotalRevenue"];
            this.totalRefund = _data["TotalRefund"];
            this.totalBudget = _data["TotalBudget"];
            this.actualCash = _data["ActualCash"];
            this.budgetVariance = _data["BudgetVariance"];
            this.balanceForNextDay = _data["BalanceForNextDay"];
            this.status = _data["Status"];
            this.submittedAt = _data["SubmittedAt"] ? new Date(_data["SubmittedAt"].toString()) : <any>undefined;
            this.submittedBy = _data["SubmittedBy"];
            this.approvedAt = _data["ApprovedAt"] ? new Date(_data["ApprovedAt"].toString()) : <any>undefined;
            this.approvedBy = _data["ApprovedBy"];
            this.rejectedAt = _data["RejectedAt"] ? new Date(_data["RejectedAt"].toString()) : <any>undefined;
            this.rejectedBy = _data["RejectedBy"];
            this.rejectionReason = _data["RejectionReason"];
            this.note = _data["Note"];
            this.createdBy = _data["CreatedBy"];
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? new Date(_data["UpdatedAt"].toString()) : <any>undefined;
            this.isDeleted = _data["IsDeleted"];
            this.employeeName = _data["EmployeeName"];
            this.storeName = _data["StoreName"];
            this.submittedByName = _data["SubmittedByName"];
            this.approvedByName = _data["ApprovedByName"];
            this.rejectedByName = _data["RejectedByName"];
            this.createdByName = _data["CreatedByName"];
            this.isOverBudget = _data["IsOverBudget"];
            this.detailCount = _data["DetailCount"];
            this.totalOrderCount = _data["TotalOrderCount"];
            this.totalCustomerCount = _data["TotalCustomerCount"];
            if (Array.isArray(_data["Details"])) {
                this.details = [] as any;
                for (let item of _data["Details"])
                    this.details!.push(ExpenseDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyExpenseReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyExpenseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ReportCode"] = this.reportCode;
        data["ReportDate"] = this.reportDate ? this.reportDate.toISOString() : <any>undefined;
        data["StoreId"] = this.storeId;
        data["EmployeeId"] = this.employeeId;
        data["TotalExpense"] = this.totalExpense;
        data["TotalRevenue"] = this.totalRevenue;
        data["TotalRefund"] = this.totalRefund;
        data["TotalBudget"] = this.totalBudget;
        data["ActualCash"] = this.actualCash;
        data["BudgetVariance"] = this.budgetVariance;
        data["BalanceForNextDay"] = this.balanceForNextDay;
        data["Status"] = this.status;
        data["SubmittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : <any>undefined;
        data["SubmittedBy"] = this.submittedBy;
        data["ApprovedAt"] = this.approvedAt ? this.approvedAt.toISOString() : <any>undefined;
        data["ApprovedBy"] = this.approvedBy;
        data["RejectedAt"] = this.rejectedAt ? this.rejectedAt.toISOString() : <any>undefined;
        data["RejectedBy"] = this.rejectedBy;
        data["RejectionReason"] = this.rejectionReason;
        data["Note"] = this.note;
        data["CreatedBy"] = this.createdBy;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["IsDeleted"] = this.isDeleted;
        data["EmployeeName"] = this.employeeName;
        data["StoreName"] = this.storeName;
        data["SubmittedByName"] = this.submittedByName;
        data["ApprovedByName"] = this.approvedByName;
        data["RejectedByName"] = this.rejectedByName;
        data["CreatedByName"] = this.createdByName;
        data["IsOverBudget"] = this.isOverBudget;
        data["DetailCount"] = this.detailCount;
        data["TotalOrderCount"] = this.totalOrderCount;
        data["TotalCustomerCount"] = this.totalCustomerCount;
        if (Array.isArray(this.details)) {
            data["Details"] = [];
            for (let item of this.details)
                data["Details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailyExpenseReportDto {
    id: number;
    reportCode?: string | undefined;
    reportDate: Date;
    storeId: number;
    employeeId?: string | undefined;
    totalExpense: number;
    totalRevenue: number;
    totalRefund: number;
    totalBudget?: number | undefined;
    actualCash?: number | undefined;
    budgetVariance?: number | undefined;
    balanceForNextDay?: number | undefined;
    status?: string | undefined;
    submittedAt?: Date | undefined;
    submittedBy?: string | undefined;
    approvedAt?: Date | undefined;
    approvedBy?: string | undefined;
    rejectedAt?: Date | undefined;
    rejectedBy?: string | undefined;
    rejectionReason?: string | undefined;
    note?: string | undefined;
    createdBy?: string | undefined;
    createdAt: Date;
    updatedAt?: Date | undefined;
    isDeleted: boolean;
    employeeName?: string | undefined;
    storeName?: string | undefined;
    submittedByName?: string | undefined;
    approvedByName?: string | undefined;
    rejectedByName?: string | undefined;
    createdByName?: string | undefined;
    isOverBudget: boolean;
    detailCount: number;
    totalOrderCount: number;
    totalCustomerCount: number;
    details?: ExpenseDetailDto[] | undefined;
}

export class ExpenseDetailDto implements IExpenseDetailDto {
    id!: number;
    reportId!: number;
    categoryId!: number;
    paymentMethodId?: number | undefined;
    expenseDate!: Date;
    amount!: number;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    description?: string | undefined;
    vendor?: string | undefined;
    supplierName?: string | undefined;
    customerName?: string | undefined;
    invoiceNumber?: string | undefined;
    reference?: string | undefined;
    attachmentUrl?: string | undefined;
    attachmentType?: string | undefined;
    isApproved!: boolean;
    approvedBy?: string | undefined;
    approvedAt?: Date | undefined;
    createdBy?: string | undefined;
    createdAt!: Date;
    updatedAt?: Date | undefined;
    isDeleted!: boolean;
    transactionType?: string | undefined;
    isLoggedToSystem!: boolean;
    refundAmount?: number | undefined;
    categoryName?: string | undefined;
    categoryCode?: string | undefined;
    categoryColor?: string | undefined;
    paymentMethodName?: string | undefined;
    refundCategoryId?: number | undefined;
    refundCategoryName?: string | undefined;
    calculatedTotal!: number;
    hasAttachment!: boolean;

    constructor(data?: IExpenseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.reportId = _data["ReportId"];
            this.categoryId = _data["CategoryId"];
            this.paymentMethodId = _data["PaymentMethodId"];
            this.expenseDate = _data["ExpenseDate"] ? new Date(_data["ExpenseDate"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.description = _data["Description"];
            this.vendor = _data["Vendor"];
            this.supplierName = _data["SupplierName"];
            this.customerName = _data["CustomerName"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.reference = _data["Reference"];
            this.attachmentUrl = _data["AttachmentUrl"];
            this.attachmentType = _data["AttachmentType"];
            this.isApproved = _data["IsApproved"];
            this.approvedBy = _data["ApprovedBy"];
            this.approvedAt = _data["ApprovedAt"] ? new Date(_data["ApprovedAt"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? new Date(_data["UpdatedAt"].toString()) : <any>undefined;
            this.isDeleted = _data["IsDeleted"];
            this.transactionType = _data["TransactionType"];
            this.isLoggedToSystem = _data["IsLoggedToSystem"];
            this.refundAmount = _data["RefundAmount"];
            this.categoryName = _data["CategoryName"];
            this.categoryCode = _data["CategoryCode"];
            this.categoryColor = _data["CategoryColor"];
            this.paymentMethodName = _data["PaymentMethodName"];
            this.refundCategoryId = _data["RefundCategoryId"];
            this.refundCategoryName = _data["RefundCategoryName"];
            this.calculatedTotal = _data["CalculatedTotal"];
            this.hasAttachment = _data["HasAttachment"];
        }
    }

    static fromJS(data: any): ExpenseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ReportId"] = this.reportId;
        data["CategoryId"] = this.categoryId;
        data["PaymentMethodId"] = this.paymentMethodId;
        data["ExpenseDate"] = this.expenseDate ? this.expenseDate.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["Description"] = this.description;
        data["Vendor"] = this.vendor;
        data["SupplierName"] = this.supplierName;
        data["CustomerName"] = this.customerName;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["Reference"] = this.reference;
        data["AttachmentUrl"] = this.attachmentUrl;
        data["AttachmentType"] = this.attachmentType;
        data["IsApproved"] = this.isApproved;
        data["ApprovedBy"] = this.approvedBy;
        data["ApprovedAt"] = this.approvedAt ? this.approvedAt.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["IsDeleted"] = this.isDeleted;
        data["TransactionType"] = this.transactionType;
        data["IsLoggedToSystem"] = this.isLoggedToSystem;
        data["RefundAmount"] = this.refundAmount;
        data["CategoryName"] = this.categoryName;
        data["CategoryCode"] = this.categoryCode;
        data["CategoryColor"] = this.categoryColor;
        data["PaymentMethodName"] = this.paymentMethodName;
        data["RefundCategoryId"] = this.refundCategoryId;
        data["RefundCategoryName"] = this.refundCategoryName;
        data["CalculatedTotal"] = this.calculatedTotal;
        data["HasAttachment"] = this.hasAttachment;
        return data;
    }
}

export interface IExpenseDetailDto {
    id: number;
    reportId: number;
    categoryId: number;
    paymentMethodId?: number | undefined;
    expenseDate: Date;
    amount: number;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    description?: string | undefined;
    vendor?: string | undefined;
    supplierName?: string | undefined;
    customerName?: string | undefined;
    invoiceNumber?: string | undefined;
    reference?: string | undefined;
    attachmentUrl?: string | undefined;
    attachmentType?: string | undefined;
    isApproved: boolean;
    approvedBy?: string | undefined;
    approvedAt?: Date | undefined;
    createdBy?: string | undefined;
    createdAt: Date;
    updatedAt?: Date | undefined;
    isDeleted: boolean;
    transactionType?: string | undefined;
    isLoggedToSystem: boolean;
    refundAmount?: number | undefined;
    categoryName?: string | undefined;
    categoryCode?: string | undefined;
    categoryColor?: string | undefined;
    paymentMethodName?: string | undefined;
    refundCategoryId?: number | undefined;
    refundCategoryName?: string | undefined;
    calculatedTotal: number;
    hasAttachment: boolean;
}

export class UpdateDailyExpenseReportRequest implements IUpdateDailyExpenseReportRequest {
    id!: number;
    reportDate!: Date;
    totalBudget?: number | undefined;
    note?: string | undefined;
    updatedId?: string | undefined;

    constructor(data?: IUpdateDailyExpenseReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.reportDate = _data["ReportDate"] ? new Date(_data["ReportDate"].toString()) : <any>undefined;
            this.totalBudget = _data["TotalBudget"];
            this.note = _data["Note"];
            this.updatedId = _data["UpdatedId"];
        }
    }

    static fromJS(data: any): UpdateDailyExpenseReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDailyExpenseReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ReportDate"] = this.reportDate ? this.reportDate.toISOString() : <any>undefined;
        data["TotalBudget"] = this.totalBudget;
        data["Note"] = this.note;
        data["UpdatedId"] = this.updatedId;
        return data;
    }
}

export interface IUpdateDailyExpenseReportRequest {
    id: number;
    reportDate: Date;
    totalBudget?: number | undefined;
    note?: string | undefined;
    updatedId?: string | undefined;
}

export class PaginatorResponseOfDailyExpenseReportDto implements IPaginatorResponseOfDailyExpenseReportDto {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    // Row sum - tổng toàn bộ theo filter (bỏ qua phân trang)
    sumTotalRevenue!: number;
    sumTotalExpense!: number;
    sumTotalRefund!: number;
    sumBudgetVariance!: number;
    items?: DailyExpenseReportDto[] | undefined;

    constructor(data?: IPaginatorResponseOfDailyExpenseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            this.sumTotalRevenue = _data["SumTotalRevenue"] || 0;
            this.sumTotalExpense = _data["SumTotalExpense"] || 0;
            this.sumTotalRefund = _data["SumTotalRefund"] || 0;
            this.sumBudgetVariance = _data["SumBudgetVariance"] || 0;
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(DailyExpenseReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfDailyExpenseReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfDailyExpenseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        data["SumTotalRevenue"] = this.sumTotalRevenue;
        data["SumTotalExpense"] = this.sumTotalExpense;
        data["SumTotalRefund"] = this.sumTotalRefund;
        data["SumBudgetVariance"] = this.sumBudgetVariance;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfDailyExpenseReportDto {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    // Row sum - tổng toàn bộ theo filter (bỏ qua phân trang)
    sumTotalRevenue: number;
    sumTotalExpense: number;
    sumTotalRefund: number;
    sumBudgetVariance: number;
    items?: DailyExpenseReportDto[] | undefined;
}

export class GetExpenseReportListRequest implements IGetExpenseReportListRequest {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    storeId?: number | undefined;
    employeeId?: string | undefined;
    status?: string | undefined;
    keySearch?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;

    constructor(data?: IGetExpenseReportListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : <any>undefined;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : <any>undefined;
            this.storeId = _data["StoreId"];
            this.employeeId = _data["EmployeeId"];
            this.status = _data["Status"];
            this.keySearch = _data["KeySearch"];
            this.pageIndex = _data["PageIndex"];
            this.pageSize = _data["PageSize"];
        }
    }

    static fromJS(data: any): GetExpenseReportListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseReportListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["StoreId"] = this.storeId;
        data["EmployeeId"] = this.employeeId;
        data["Status"] = this.status;
        data["KeySearch"] = this.keySearch;
        data["PageIndex"] = this.pageIndex;
        data["PageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetExpenseReportListRequest {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    storeId?: number | undefined;
    employeeId?: string | undefined;
    status?: string | undefined;
    keySearch?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
}

export class UpdateExpenseDetailRequest implements IUpdateExpenseDetailRequest {
    id!: number;
    categoryId!: number;
    paymentMethodId?: number | undefined;
    expenseDate!: Date;
    amount!: number;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    description?: string | undefined;
    vendor?: string | undefined;
    invoiceNumber?: string | undefined;
    reference?: string | undefined;
    attachmentUrl?: string | undefined;
    attachmentType?: string | undefined;
    transactionType?: string | undefined;
    isLoggedToSystem!: boolean;
    refundAmount?: number | undefined;
    refundCategoryId?: number | undefined;
    updatedId?: string | undefined;

    constructor(data?: IUpdateExpenseDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.categoryId = _data["CategoryId"];
            this.paymentMethodId = _data["PaymentMethodId"];
            this.expenseDate = _data["ExpenseDate"] ? new Date(_data["ExpenseDate"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.description = _data["Description"];
            this.vendor = _data["Vendor"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.reference = _data["Reference"];
            this.attachmentUrl = _data["AttachmentUrl"];
            this.attachmentType = _data["AttachmentType"];
            this.transactionType = _data["TransactionType"];
            this.isLoggedToSystem = _data["IsLoggedToSystem"];
            this.refundAmount = _data["RefundAmount"];
            this.refundCategoryId = _data["RefundCategoryId"];
            this.updatedId = _data["UpdatedId"];
        }
    }

    static fromJS(data: any): UpdateExpenseDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenseDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CategoryId"] = this.categoryId;
        data["PaymentMethodId"] = this.paymentMethodId;
        data["ExpenseDate"] = this.expenseDate ? this.expenseDate.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["Description"] = this.description;
        data["Vendor"] = this.vendor;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["Reference"] = this.reference;
        data["AttachmentUrl"] = this.attachmentUrl;
        data["AttachmentType"] = this.attachmentType;
        data["TransactionType"] = this.transactionType;
        data["IsLoggedToSystem"] = this.isLoggedToSystem;
        data["RefundAmount"] = this.refundAmount;
        data["RefundCategoryId"] = this.refundCategoryId;
        data["UpdatedId"] = this.updatedId;
        return data;
    }
}

export interface IUpdateExpenseDetailRequest {
    id: number;
    categoryId: number;
    paymentMethodId?: number | undefined;
    expenseDate: Date;
    amount: number;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    description?: string | undefined;
    vendor?: string | undefined;
    invoiceNumber?: string | undefined;
    reference?: string | undefined;
    attachmentUrl?: string | undefined;
    attachmentType?: string | undefined;
    transactionType?: string | undefined;
    isLoggedToSystem: boolean;
    refundAmount?: number | undefined;
    refundCategoryId?: number | undefined;
    updatedId?: string | undefined;
}

export class SubmitExpenseReportRequest implements ISubmitExpenseReportRequest {
    reportId!: number;
    submittedById?: string | undefined;

    constructor(data?: ISubmitExpenseReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["ReportId"];
            this.submittedById = _data["SubmittedById"];
        }
    }

    static fromJS(data: any): SubmitExpenseReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitExpenseReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportId"] = this.reportId;
        data["SubmittedById"] = this.submittedById;
        return data;
    }
}

export interface ISubmitExpenseReportRequest {
    reportId: number;
    submittedById?: string | undefined;
}

export class ApproveExpenseReportRequest implements IApproveExpenseReportRequest {
    reportId!: number;
    approvedById?: string | undefined;

    constructor(data?: IApproveExpenseReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["ReportId"];
            this.approvedById = _data["ApprovedById"];
        }
    }

    static fromJS(data: any): ApproveExpenseReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveExpenseReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportId"] = this.reportId;
        data["ApprovedById"] = this.approvedById;
        return data;
    }
}

export interface IApproveExpenseReportRequest {
    reportId: number;
    approvedById?: string | undefined;
}

export class RejectExpenseReportRequest implements IRejectExpenseReportRequest {
    reportId!: number;
    rejectionReason?: string | undefined;
    rejectedById?: string | undefined;

    constructor(data?: IRejectExpenseReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["ReportId"];
            this.rejectionReason = _data["RejectionReason"];
            this.rejectedById = _data["RejectedById"];
        }
    }

    static fromJS(data: any): RejectExpenseReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectExpenseReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportId"] = this.reportId;
        data["RejectionReason"] = this.rejectionReason;
        data["RejectedById"] = this.rejectedById;
        return data;
    }
}

export interface IRejectExpenseReportRequest {
    reportId: number;
    rejectionReason?: string | undefined;
    rejectedById?: string | undefined;
}

export class ExpenseSummaryResponse implements IExpenseSummaryResponse {
    fromDate!: Date;
    toDate!: Date;
    storeId?: number | undefined;
    totalExpense!: number;
    totalBudget!: number;
    budgetVariance!: number;
    reportCount!: number;
    pendingApprovalCount!: number;
    approvedCount!: number;
    rejectedCount!: number;
    overBudgetCount!: number;
    categorySummaries?: CategoryExpenseSummary[] | undefined;

    constructor(data?: IExpenseSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : <any>undefined;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : <any>undefined;
            this.storeId = _data["StoreId"];
            this.totalExpense = _data["TotalExpense"];
            this.totalBudget = _data["TotalBudget"];
            this.budgetVariance = _data["BudgetVariance"];
            this.reportCount = _data["ReportCount"];
            this.pendingApprovalCount = _data["PendingApprovalCount"];
            this.approvedCount = _data["ApprovedCount"];
            this.rejectedCount = _data["RejectedCount"];
            this.overBudgetCount = _data["OverBudgetCount"];
            if (Array.isArray(_data["CategorySummaries"])) {
                this.categorySummaries = [] as any;
                for (let item of _data["CategorySummaries"])
                    this.categorySummaries!.push(CategoryExpenseSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpenseSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["StoreId"] = this.storeId;
        data["TotalExpense"] = this.totalExpense;
        data["TotalBudget"] = this.totalBudget;
        data["BudgetVariance"] = this.budgetVariance;
        data["ReportCount"] = this.reportCount;
        data["PendingApprovalCount"] = this.pendingApprovalCount;
        data["ApprovedCount"] = this.approvedCount;
        data["RejectedCount"] = this.rejectedCount;
        data["OverBudgetCount"] = this.overBudgetCount;
        if (Array.isArray(this.categorySummaries)) {
            data["CategorySummaries"] = [];
            for (let item of this.categorySummaries)
                data["CategorySummaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExpenseSummaryResponse {
    fromDate: Date;
    toDate: Date;
    storeId?: number | undefined;
    totalExpense: number;
    totalBudget: number;
    budgetVariance: number;
    reportCount: number;
    pendingApprovalCount: number;
    approvedCount: number;
    rejectedCount: number;
    overBudgetCount: number;
    categorySummaries?: CategoryExpenseSummary[] | undefined;
}

export class CategoryExpenseSummary implements ICategoryExpenseSummary {
    categoryId!: number;
    categoryName?: string | undefined;
    categoryCode?: string | undefined;
    colorCode?: string | undefined;
    transactionCount!: number;
    totalAmount!: number;
    percentage!: number;

    constructor(data?: ICategoryExpenseSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.categoryName = _data["CategoryName"];
            this.categoryCode = _data["CategoryCode"];
            this.colorCode = _data["ColorCode"];
            this.transactionCount = _data["TransactionCount"];
            this.totalAmount = _data["TotalAmount"];
            this.percentage = _data["Percentage"];
        }
    }

    static fromJS(data: any): CategoryExpenseSummary {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryExpenseSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["CategoryName"] = this.categoryName;
        data["CategoryCode"] = this.categoryCode;
        data["ColorCode"] = this.colorCode;
        data["TransactionCount"] = this.transactionCount;
        data["TotalAmount"] = this.totalAmount;
        data["Percentage"] = this.percentage;
        return data;
    }
}

export interface ICategoryExpenseSummary {
    categoryId: number;
    categoryName?: string | undefined;
    categoryCode?: string | undefined;
    colorCode?: string | undefined;
    transactionCount: number;
    totalAmount: number;
    percentage: number;
}

export class PaginatorResponseOfDanhMucQuocGiaDto implements IPaginatorResponseOfDanhMucQuocGiaDto {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: DanhMucQuocGiaDto[] | undefined;

    constructor(data?: IPaginatorResponseOfDanhMucQuocGiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(DanhMucQuocGiaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfDanhMucQuocGiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfDanhMucQuocGiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfDanhMucQuocGiaDto {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: DanhMucQuocGiaDto[] | undefined;
}

export class DanhMucQuocGiaDto implements IDanhMucQuocGiaDto {
    id?: number | undefined;
    tenQuocGia?: string | undefined;
    moTa?: string | undefined;
    isShowSub!: boolean;
    lstDanhMucThanhPhoQuanHuyenDto?: DanhMucThanhPhoQuanHuyenDto[] | undefined;

    constructor(data?: IDanhMucQuocGiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tenQuocGia = _data["TenQuocGia"];
            this.moTa = _data["MoTa"];
            this.isShowSub = _data["IsShowSub"];
            if (Array.isArray(_data["LstDanhMucThanhPhoQuanHuyenDto"])) {
                this.lstDanhMucThanhPhoQuanHuyenDto = [] as any;
                for (let item of _data["LstDanhMucThanhPhoQuanHuyenDto"])
                    this.lstDanhMucThanhPhoQuanHuyenDto!.push(DanhMucThanhPhoQuanHuyenDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DanhMucQuocGiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DanhMucQuocGiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TenQuocGia"] = this.tenQuocGia;
        data["MoTa"] = this.moTa;
        data["IsShowSub"] = this.isShowSub;
        if (Array.isArray(this.lstDanhMucThanhPhoQuanHuyenDto)) {
            data["LstDanhMucThanhPhoQuanHuyenDto"] = [];
            for (let item of this.lstDanhMucThanhPhoQuanHuyenDto)
                data["LstDanhMucThanhPhoQuanHuyenDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDanhMucQuocGiaDto {
    id?: number | undefined;
    tenQuocGia?: string | undefined;
    moTa?: string | undefined;
    isShowSub: boolean;
    lstDanhMucThanhPhoQuanHuyenDto?: DanhMucThanhPhoQuanHuyenDto[] | undefined;
}

export class DanhMucThanhPhoQuanHuyenDto implements IDanhMucThanhPhoQuanHuyenDto {
    id?: number | undefined;
    danhMucQuocGiaId?: number | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;
    moTa?: string | undefined;

    constructor(data?: IDanhMucThanhPhoQuanHuyenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.danhMucQuocGiaId = _data["DanhMucQuocGiaId"];
            this.tenThanhPhoQuanHuyen = _data["TenThanhPhoQuanHuyen"];
            this.moTa = _data["MoTa"];
        }
    }

    static fromJS(data: any): DanhMucThanhPhoQuanHuyenDto {
        data = typeof data === 'object' ? data : {};
        let result = new DanhMucThanhPhoQuanHuyenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DanhMucQuocGiaId"] = this.danhMucQuocGiaId;
        data["TenThanhPhoQuanHuyen"] = this.tenThanhPhoQuanHuyen;
        data["MoTa"] = this.moTa;
        return data;
    }
}

export interface IDanhMucThanhPhoQuanHuyenDto {
    id?: number | undefined;
    danhMucQuocGiaId?: number | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;
    moTa?: string | undefined;
}

export class GetListDanhMucQuocGiaRequest implements IGetListDanhMucQuocGiaRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    tenQuocGia?: string | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;

    constructor(data?: IGetListDanhMucQuocGiaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.tenQuocGia = _data["TenQuocGia"];
            this.tenThanhPhoQuanHuyen = _data["TenThanhPhoQuanHuyen"];
        }
    }

    static fromJS(data: any): GetListDanhMucQuocGiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListDanhMucQuocGiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["TenQuocGia"] = this.tenQuocGia;
        data["TenThanhPhoQuanHuyen"] = this.tenThanhPhoQuanHuyen;
        return data;
    }
}

export interface IGetListDanhMucQuocGiaRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    tenQuocGia?: string | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;
}

export class CreateDanhMucQuocGiaRequest implements ICreateDanhMucQuocGiaRequest {
    tenQuocGia?: string | undefined;
    moTa?: string | undefined;

    constructor(data?: ICreateDanhMucQuocGiaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenQuocGia = _data["TenQuocGia"];
            this.moTa = _data["MoTa"];
        }
    }

    static fromJS(data: any): CreateDanhMucQuocGiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDanhMucQuocGiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TenQuocGia"] = this.tenQuocGia;
        data["MoTa"] = this.moTa;
        return data;
    }
}

export interface ICreateDanhMucQuocGiaRequest {
    tenQuocGia?: string | undefined;
    moTa?: string | undefined;
}

export class UpdateDanhMucQuocGiaRequest implements IUpdateDanhMucQuocGiaRequest {
    id?: number | undefined;
    tenQuocGia?: string | undefined;
    moTa?: string | undefined;

    constructor(data?: IUpdateDanhMucQuocGiaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tenQuocGia = _data["TenQuocGia"];
            this.moTa = _data["MoTa"];
        }
    }

    static fromJS(data: any): UpdateDanhMucQuocGiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDanhMucQuocGiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TenQuocGia"] = this.tenQuocGia;
        data["MoTa"] = this.moTa;
        return data;
    }
}

export interface IUpdateDanhMucQuocGiaRequest {
    id?: number | undefined;
    tenQuocGia?: string | undefined;
    moTa?: string | undefined;
}

export class CheckTenQuocGiaExistsRequest implements ICheckTenQuocGiaExistsRequest {
    tenQuocGia?: string | undefined;
    tenQuocGiaCu?: string | undefined;

    constructor(data?: ICheckTenQuocGiaExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenQuocGia = _data["TenQuocGia"];
            this.tenQuocGiaCu = _data["TenQuocGiaCu"];
        }
    }

    static fromJS(data: any): CheckTenQuocGiaExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTenQuocGiaExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TenQuocGia"] = this.tenQuocGia;
        data["TenQuocGiaCu"] = this.tenQuocGiaCu;
        return data;
    }
}

export interface ICheckTenQuocGiaExistsRequest {
    tenQuocGia?: string | undefined;
    tenQuocGiaCu?: string | undefined;
}

export class CreateDanhMucThanhPhoQuanHuyenRequest implements ICreateDanhMucThanhPhoQuanHuyenRequest {
    danhMucQuocGiaId?: number | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;
    moTa?: string | undefined;

    constructor(data?: ICreateDanhMucThanhPhoQuanHuyenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.danhMucQuocGiaId = _data["DanhMucQuocGiaId"];
            this.tenThanhPhoQuanHuyen = _data["TenThanhPhoQuanHuyen"];
            this.moTa = _data["MoTa"];
        }
    }

    static fromJS(data: any): CreateDanhMucThanhPhoQuanHuyenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDanhMucThanhPhoQuanHuyenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DanhMucQuocGiaId"] = this.danhMucQuocGiaId;
        data["TenThanhPhoQuanHuyen"] = this.tenThanhPhoQuanHuyen;
        data["MoTa"] = this.moTa;
        return data;
    }
}

export interface ICreateDanhMucThanhPhoQuanHuyenRequest {
    danhMucQuocGiaId?: number | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;
    moTa?: string | undefined;
}

export class UpdateDanhMucThanhPhoQuanHuyenRequest implements IUpdateDanhMucThanhPhoQuanHuyenRequest {
    id?: number | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;
    moTa?: string | undefined;

    constructor(data?: IUpdateDanhMucThanhPhoQuanHuyenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.tenThanhPhoQuanHuyen = _data["TenThanhPhoQuanHuyen"];
            this.moTa = _data["MoTa"];
        }
    }

    static fromJS(data: any): UpdateDanhMucThanhPhoQuanHuyenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDanhMucThanhPhoQuanHuyenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TenThanhPhoQuanHuyen"] = this.tenThanhPhoQuanHuyen;
        data["MoTa"] = this.moTa;
        return data;
    }
}

export interface IUpdateDanhMucThanhPhoQuanHuyenRequest {
    id?: number | undefined;
    tenThanhPhoQuanHuyen?: string | undefined;
    moTa?: string | undefined;
}

export class CheckTenThanhPhoQuanHuyenExistsRequest implements ICheckTenThanhPhoQuanHuyenExistsRequest {
    tenThanhPhoQuanHuyen?: string | undefined;
    tenThanhPhoQuanHuyenCu?: string | undefined;
    danhMucQuocGiaId?: number | undefined;

    constructor(data?: ICheckTenThanhPhoQuanHuyenExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenThanhPhoQuanHuyen = _data["TenThanhPhoQuanHuyen"];
            this.tenThanhPhoQuanHuyenCu = _data["TenThanhPhoQuanHuyenCu"];
            this.danhMucQuocGiaId = _data["DanhMucQuocGiaId"];
        }
    }

    static fromJS(data: any): CheckTenThanhPhoQuanHuyenExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTenThanhPhoQuanHuyenExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TenThanhPhoQuanHuyen"] = this.tenThanhPhoQuanHuyen;
        data["TenThanhPhoQuanHuyenCu"] = this.tenThanhPhoQuanHuyenCu;
        data["DanhMucQuocGiaId"] = this.danhMucQuocGiaId;
        return data;
    }
}

export interface ICheckTenThanhPhoQuanHuyenExistsRequest {
    tenThanhPhoQuanHuyen?: string | undefined;
    tenThanhPhoQuanHuyenCu?: string | undefined;
    danhMucQuocGiaId?: number | undefined;
}

export class FilterWithTagDanhMucThanhPhoQuanHuyenRequest implements IFilterWithTagDanhMucThanhPhoQuanHuyenRequest {
    keySearch?: string | undefined;
    danhMucQuocGiaId?: number | undefined;

    constructor(data?: IFilterWithTagDanhMucThanhPhoQuanHuyenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keySearch = _data["KeySearch"];
            this.danhMucQuocGiaId = _data["DanhMucQuocGiaId"];
        }
    }

    static fromJS(data: any): FilterWithTagDanhMucThanhPhoQuanHuyenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterWithTagDanhMucThanhPhoQuanHuyenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["KeySearch"] = this.keySearch;
        data["DanhMucQuocGiaId"] = this.danhMucQuocGiaId;
        return data;
    }
}

export interface IFilterWithTagDanhMucThanhPhoQuanHuyenRequest {
    keySearch?: string | undefined;
    danhMucQuocGiaId?: number | undefined;
}

export class ChartResponseModel implements IChartResponseModel {
    labels?: string[] | undefined;
    chartDataModel?: ChartDataModel | undefined;
    chartDataModels?: ChartDataModel[] | undefined;
    totalPrice?: number[] | undefined;
    totalPriceCost!: number;
    totalQuantity?: number[] | undefined;

    constructor(data?: IChartResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(item);
            }
            this.chartDataModel = _data["ChartDataModel"] ? ChartDataModel.fromJS(_data["ChartDataModel"]) : <any>undefined;
            if (Array.isArray(_data["ChartDataModels"])) {
                this.chartDataModels = [] as any;
                for (let item of _data["ChartDataModels"])
                    this.chartDataModels!.push(ChartDataModel.fromJS(item));
            }
            if (Array.isArray(_data["TotalPrice"])) {
                this.totalPrice = [] as any;
                for (let item of _data["TotalPrice"])
                    this.totalPrice!.push(item);
            }
            this.totalPriceCost = _data["TotalPriceCost"];
            if (Array.isArray(_data["TotalQuantity"])) {
                this.totalQuantity = [] as any;
                for (let item of _data["TotalQuantity"])
                    this.totalQuantity!.push(item);
            }
        }
    }

    static fromJS(data: any): ChartResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChartResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item);
        }
        data["ChartDataModel"] = this.chartDataModel ? this.chartDataModel.toJSON() : <any>undefined;
        if (Array.isArray(this.chartDataModels)) {
            data["ChartDataModels"] = [];
            for (let item of this.chartDataModels)
                data["ChartDataModels"].push(item.toJSON());
        }
        if (Array.isArray(this.totalPrice)) {
            data["TotalPrice"] = [];
            for (let item of this.totalPrice)
                data["TotalPrice"].push(item);
        }
        data["TotalPriceCost"] = this.totalPriceCost;
        if (Array.isArray(this.totalQuantity)) {
            data["TotalQuantity"] = [];
            for (let item of this.totalQuantity)
                data["TotalQuantity"].push(item);
        }
        return data;
    }
}

export interface IChartResponseModel {
    labels?: string[] | undefined;
    chartDataModel?: ChartDataModel | undefined;
    chartDataModels?: ChartDataModel[] | undefined;
    totalPrice?: number[] | undefined;
    totalPriceCost: number;
    totalQuantity?: number[] | undefined;
}

export class ChartDataModel implements IChartDataModel {
    data?: number[] | undefined;
    label?: string | undefined;

    constructor(data?: IChartDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Data"])) {
                this.data = [] as any;
                for (let item of _data["Data"])
                    this.data!.push(item);
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): ChartDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["Data"] = [];
            for (let item of this.data)
                data["Data"].push(item);
        }
        data["Label"] = this.label;
        return data;
    }
}

export interface IChartDataModel {
    data?: number[] | undefined;
    label?: string | undefined;
}

export class ChartRequestModel implements IChartRequestModel {
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    accountId?: string | undefined;
    customerId?: number | undefined;
    orderType?: number | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    keySearch?: string | undefined;

    constructor(data?: IChartRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["DateFrom"] ? new Date(_data["DateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["DateTo"] ? new Date(_data["DateTo"].toString()) : <any>undefined;
            this.accountId = _data["AccountId"];
            this.customerId = _data["CustomerId"];
            this.orderType = _data["OrderType"];
            this.pageIndex = _data["PageIndex"];
            this.pageSize = _data["PageSize"];
            this.keySearch = _data["KeySearch"];
        }
    }

    static fromJS(data: any): ChartRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChartRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["DateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["AccountId"] = this.accountId;
        data["CustomerId"] = this.customerId;
        data["OrderType"] = this.orderType;
        data["PageIndex"] = this.pageIndex;
        data["PageSize"] = this.pageSize;
        data["KeySearch"] = this.keySearch;
        return data;
    }
}

export interface IChartRequestModel {
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    accountId?: string | undefined;
    customerId?: number | undefined;
    orderType?: number | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    keySearch?: string | undefined;
}

export class NegativeSaleItemResponse implements INegativeSaleItemResponse {
    orderCode?: string | undefined;
    orderId?: string | undefined;
    orderTime?: Date | undefined;
    productName?: string | undefined;
    adjustedPrice!: number;
    priceCost!: number;
    quantity!: number;
    negativeAmount!: number;

    constructor(data?: INegativeSaleItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["OrderCode"];
            this.orderId = _data["OrderId"];
            this.orderTime = _data["OrderTime"] ? new Date(_data["OrderTime"].toString()) : <any>undefined;
            this.productName = _data["ProductName"];
            this.adjustedPrice = _data["AdjustedPrice"];
            this.priceCost = _data["PriceCost"];
            this.quantity = _data["Quantity"];
            this.negativeAmount = _data["NegativeAmount"];
        }
    }

    static fromJS(data: any): NegativeSaleItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NegativeSaleItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderCode"] = this.orderCode;
        data["OrderId"] = this.orderId;
        data["OrderTime"] = this.orderTime ? this.orderTime.toISOString() : <any>undefined;
        data["ProductName"] = this.productName;
        data["AdjustedPrice"] = this.adjustedPrice;
        data["PriceCost"] = this.priceCost;
        data["Quantity"] = this.quantity;
        data["NegativeAmount"] = this.negativeAmount;
        return data;
    }
}

export interface INegativeSaleItemResponse {
    orderCode?: string | undefined;
    orderId?: string | undefined;
    orderTime?: Date | undefined;
    productName?: string | undefined;
    adjustedPrice: number;
    priceCost: number;
    quantity: number;
    negativeAmount: number;
}

export class EmailSettingsResponse implements IEmailSettingsResponse {
    id!: number;
    smtpHost?: string | undefined;
    smtpPort!: number;
    smtpUsername?: string | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    enableSsl!: boolean;
    isActive!: boolean;
    createdAt!: Date;
    updatedAt?: Date | undefined;

    constructor(data?: IEmailSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.smtpHost = _data["SmtpHost"];
            this.smtpPort = _data["SmtpPort"];
            this.smtpUsername = _data["SmtpUsername"];
            this.fromEmail = _data["FromEmail"];
            this.fromName = _data["FromName"];
            this.enableSsl = _data["EnableSsl"];
            this.isActive = _data["IsActive"];
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? new Date(_data["UpdatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SmtpHost"] = this.smtpHost;
        data["SmtpPort"] = this.smtpPort;
        data["SmtpUsername"] = this.smtpUsername;
        data["FromEmail"] = this.fromEmail;
        data["FromName"] = this.fromName;
        data["EnableSsl"] = this.enableSsl;
        data["IsActive"] = this.isActive;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmailSettingsResponse {
    id: number;
    smtpHost?: string | undefined;
    smtpPort: number;
    smtpUsername?: string | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    enableSsl: boolean;
    isActive: boolean;
    createdAt: Date;
    updatedAt?: Date | undefined;
}

export class EmailSettingsDto implements IEmailSettingsDto {
    id!: number;
    smtpHost?: string | undefined;
    smtpPort!: number;
    smtpUsername?: string | undefined;
    smtpPassword?: string | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    enableSsl!: boolean;
    isActive!: boolean;

    constructor(data?: IEmailSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.smtpHost = _data["SmtpHost"];
            this.smtpPort = _data["SmtpPort"];
            this.smtpUsername = _data["SmtpUsername"];
            this.smtpPassword = _data["SmtpPassword"];
            this.fromEmail = _data["FromEmail"];
            this.fromName = _data["FromName"];
            this.enableSsl = _data["EnableSsl"];
            this.isActive = _data["IsActive"];
        }
    }

    static fromJS(data: any): EmailSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SmtpHost"] = this.smtpHost;
        data["SmtpPort"] = this.smtpPort;
        data["SmtpUsername"] = this.smtpUsername;
        data["SmtpPassword"] = this.smtpPassword;
        data["FromEmail"] = this.fromEmail;
        data["FromName"] = this.fromName;
        data["EnableSsl"] = this.enableSsl;
        data["IsActive"] = this.isActive;
        return data;
    }
}

export interface IEmailSettingsDto {
    id: number;
    smtpHost?: string | undefined;
    smtpPort: number;
    smtpUsername?: string | undefined;
    smtpPassword?: string | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    enableSsl: boolean;
    isActive: boolean;
}

export class TestEmailRequest implements ITestEmailRequest {
    toEmail?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: ITestEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toEmail = _data["ToEmail"];
            this.subject = _data["Subject"];
            this.body = _data["Body"];
        }
    }

    static fromJS(data: any): TestEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ToEmail"] = this.toEmail;
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        return data;
    }
}

export interface ITestEmailRequest {
    toEmail?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class CreateExpenseCategoryRequest implements ICreateExpenseCategoryRequest {
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder!: number;
    isActive!: boolean;
    categoryType?: string | undefined;
    createId?: string | undefined;

    constructor(data?: ICreateExpenseCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryCode = _data["CategoryCode"];
            this.categoryName = _data["CategoryName"];
            this.parentId = _data["ParentId"];
            this.description = _data["Description"];
            this.iconName = _data["IconName"];
            this.colorCode = _data["ColorCode"];
            this.displayOrder = _data["DisplayOrder"];
            this.isActive = _data["IsActive"];
            this.categoryType = _data["CategoryType"];
            this.createId = _data["CreateId"];
        }
    }

    static fromJS(data: any): CreateExpenseCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpenseCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryCode"] = this.categoryCode;
        data["CategoryName"] = this.categoryName;
        data["ParentId"] = this.parentId;
        data["Description"] = this.description;
        data["IconName"] = this.iconName;
        data["ColorCode"] = this.colorCode;
        data["DisplayOrder"] = this.displayOrder;
        data["IsActive"] = this.isActive;
        data["CategoryType"] = this.categoryType;
        data["CreateId"] = this.createId;
        return data;
    }
}

export interface ICreateExpenseCategoryRequest {
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder: number;
    isActive: boolean;
    categoryType?: string | undefined;
    createId?: string | undefined;
}

export class UpdateExpenseCategoryRequest implements IUpdateExpenseCategoryRequest {
    id!: number;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder!: number;
    isActive!: boolean;
    categoryType?: string | undefined;
    updatedId?: string | undefined;

    constructor(data?: IUpdateExpenseCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.categoryCode = _data["CategoryCode"];
            this.categoryName = _data["CategoryName"];
            this.parentId = _data["ParentId"];
            this.description = _data["Description"];
            this.iconName = _data["IconName"];
            this.colorCode = _data["ColorCode"];
            this.displayOrder = _data["DisplayOrder"];
            this.isActive = _data["IsActive"];
            this.categoryType = _data["CategoryType"];
            this.updatedId = _data["UpdatedId"];
        }
    }

    static fromJS(data: any): UpdateExpenseCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenseCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CategoryCode"] = this.categoryCode;
        data["CategoryName"] = this.categoryName;
        data["ParentId"] = this.parentId;
        data["Description"] = this.description;
        data["IconName"] = this.iconName;
        data["ColorCode"] = this.colorCode;
        data["DisplayOrder"] = this.displayOrder;
        data["IsActive"] = this.isActive;
        data["CategoryType"] = this.categoryType;
        data["UpdatedId"] = this.updatedId;
        return data;
    }
}

export interface IUpdateExpenseCategoryRequest {
    id: number;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder: number;
    isActive: boolean;
    categoryType?: string | undefined;
    updatedId?: string | undefined;
}

export class ExpenseCategoryDto implements IExpenseCategoryDto {
    id!: number;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder!: number;
    isActive!: boolean;
    createdBy?: string | undefined;
    createdAt!: Date;
    updatedAt?: Date | undefined;
    isDeleted!: boolean;
    categoryType?: string | undefined;
    parentCategoryName?: string | undefined;
    childCount?: number | undefined;

    constructor(data?: IExpenseCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.categoryCode = _data["CategoryCode"];
            this.categoryName = _data["CategoryName"];
            this.parentId = _data["ParentId"];
            this.description = _data["Description"];
            this.iconName = _data["IconName"];
            this.colorCode = _data["ColorCode"];
            this.displayOrder = _data["DisplayOrder"];
            this.isActive = _data["IsActive"];
            this.createdBy = _data["CreatedBy"];
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? new Date(_data["UpdatedAt"].toString()) : <any>undefined;
            this.isDeleted = _data["IsDeleted"];
            this.categoryType = _data["CategoryType"];
            this.parentCategoryName = _data["ParentCategoryName"];
            this.childCount = _data["ChildCount"];
        }
    }

    static fromJS(data: any): ExpenseCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CategoryCode"] = this.categoryCode;
        data["CategoryName"] = this.categoryName;
        data["ParentId"] = this.parentId;
        data["Description"] = this.description;
        data["IconName"] = this.iconName;
        data["ColorCode"] = this.colorCode;
        data["DisplayOrder"] = this.displayOrder;
        data["IsActive"] = this.isActive;
        data["CreatedBy"] = this.createdBy;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["IsDeleted"] = this.isDeleted;
        data["CategoryType"] = this.categoryType;
        data["ParentCategoryName"] = this.parentCategoryName;
        data["ChildCount"] = this.childCount;
        return data;
    }
}

export interface IExpenseCategoryDto {
    id: number;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder: number;
    isActive: boolean;
    createdBy?: string | undefined;
    createdAt: Date;
    updatedAt?: Date | undefined;
    isDeleted: boolean;
    categoryType?: string | undefined;
    parentCategoryName?: string | undefined;
    childCount?: number | undefined;
}

export class ExpenseCategoryTreeResponse implements IExpenseCategoryTreeResponse {
    id!: number;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder!: number;
    isActive!: boolean;
    children?: ExpenseCategoryTreeResponse[] | undefined;

    constructor(data?: IExpenseCategoryTreeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.categoryCode = _data["CategoryCode"];
            this.categoryName = _data["CategoryName"];
            this.parentId = _data["ParentId"];
            this.description = _data["Description"];
            this.iconName = _data["IconName"];
            this.colorCode = _data["ColorCode"];
            this.displayOrder = _data["DisplayOrder"];
            this.isActive = _data["IsActive"];
            if (Array.isArray(_data["Children"])) {
                this.children = [] as any;
                for (let item of _data["Children"])
                    this.children!.push(ExpenseCategoryTreeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpenseCategoryTreeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseCategoryTreeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CategoryCode"] = this.categoryCode;
        data["CategoryName"] = this.categoryName;
        data["ParentId"] = this.parentId;
        data["Description"] = this.description;
        data["IconName"] = this.iconName;
        data["ColorCode"] = this.colorCode;
        data["DisplayOrder"] = this.displayOrder;
        data["IsActive"] = this.isActive;
        if (Array.isArray(this.children)) {
            data["Children"] = [];
            for (let item of this.children)
                data["Children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExpenseCategoryTreeResponse {
    id: number;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    parentId?: number | undefined;
    description?: string | undefined;
    iconName?: string | undefined;
    colorCode?: string | undefined;
    displayOrder: number;
    isActive: boolean;
    children?: ExpenseCategoryTreeResponse[] | undefined;
}

export class UploadImageResponse implements IUploadImageResponse {
    id!: string;
    fileName?: string | undefined;
    url?: string | undefined;
    isSuccess!: boolean;
    message?: string | undefined;

    constructor(data?: IUploadImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fileName = _data["FileName"];
            this.url = _data["Url"];
            this.isSuccess = _data["IsSuccess"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): UploadImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FileName"] = this.fileName;
        data["Url"] = this.url;
        data["IsSuccess"] = this.isSuccess;
        data["Message"] = this.message;
        return data;
    }
}

export interface IUploadImageResponse {
    id: string;
    fileName?: string | undefined;
    url?: string | undefined;
    isSuccess: boolean;
    message?: string | undefined;
}

export class CkEditorUploadFileResponse implements ICkEditorUploadFileResponse {
    error?: CkEditorEror | undefined;
    uploaded?: number | undefined;
    fileName?: string | undefined;
    url?: string | undefined;

    constructor(data?: ICkEditorUploadFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? CkEditorEror.fromJS(_data["error"]) : <any>undefined;
            this.uploaded = _data["uploaded"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CkEditorUploadFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CkEditorUploadFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["uploaded"] = this.uploaded;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        return data;
    }
}

export interface ICkEditorUploadFileResponse {
    error?: CkEditorEror | undefined;
    uploaded?: number | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
}

export class CkEditorEror implements ICkEditorEror {
    message?: string | undefined;

    constructor(data?: ICkEditorEror) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CkEditorEror {
        data = typeof data === 'object' ? data : {};
        let result = new CkEditorEror();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ICkEditorEror {
    message?: string | undefined;
}

export class FileUploadResponse implements IFileUploadResponse {
    id!: string;
    fileName?: string | undefined;
    urlFile?: string | undefined;
    createdTime!: Date;
    createdId!: string;

    constructor(data?: IFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fileName = _data["FileName"];
            this.urlFile = _data["UrlFile"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
        }
    }

    static fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FileName"] = this.fileName;
        data["UrlFile"] = this.urlFile;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        return data;
    }
}

export interface IFileUploadResponse {
    id: string;
    fileName?: string | undefined;
    urlFile?: string | undefined;
    createdTime: Date;
    createdId: string;
}

export class ManufacturerDto implements IManufacturerDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IManufacturerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): ManufacturerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IManufacturerDto {
    id: number;
    name?: string | undefined;
}

export class MonitoringLogFilter implements IMonitoringLogFilter {
    page!: number;
    pageSize!: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    logType?: string | undefined;
    userId?: string | undefined;
    controller?: string | undefined;
    minResponseTime?: number | undefined;
    statusCode?: number | undefined;

    constructor(data?: IMonitoringLogFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["Page"];
            this.pageSize = _data["PageSize"];
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : <any>undefined;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : <any>undefined;
            this.logType = _data["LogType"];
            this.userId = _data["UserId"];
            this.controller = _data["Controller"];
            this.minResponseTime = _data["MinResponseTime"];
            this.statusCode = _data["StatusCode"];
        }
    }

    static fromJS(data: any): MonitoringLogFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringLogFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Page"] = this.page;
        data["PageSize"] = this.pageSize;
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["LogType"] = this.logType;
        data["UserId"] = this.userId;
        data["Controller"] = this.controller;
        data["MinResponseTime"] = this.minResponseTime;
        data["StatusCode"] = this.statusCode;
        return data;
    }
}

export interface IMonitoringLogFilter {
    page: number;
    pageSize: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    logType?: string | undefined;
    userId?: string | undefined;
    controller?: string | undefined;
    minResponseTime?: number | undefined;
    statusCode?: number | undefined;
}

export class MarkAsReadRequest implements IMarkAsReadRequest {
    notificationId?: number | undefined;

    constructor(data?: IMarkAsReadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["NotificationId"];
        }
    }

    static fromJS(data: any): MarkAsReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsReadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationId"] = this.notificationId;
        return data;
    }
}

export interface IMarkAsReadRequest {
    notificationId?: number | undefined;
}

export class DeleteNotificationRequest implements IDeleteNotificationRequest {
    notificationId!: number;

    constructor(data?: IDeleteNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["NotificationId"];
        }
    }

    static fromJS(data: any): DeleteNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationId"] = this.notificationId;
        return data;
    }
}

export interface IDeleteNotificationRequest {
    notificationId: number;
}

export class DeleteBulkNotificationRequest implements IDeleteBulkNotificationRequest {
    notificationIds?: number[] | undefined;

    constructor(data?: IDeleteBulkNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["NotificationIds"])) {
                this.notificationIds = [] as any;
                for (let item of _data["NotificationIds"])
                    this.notificationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteBulkNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBulkNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationIds)) {
            data["NotificationIds"] = [];
            for (let item of this.notificationIds)
                data["NotificationIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteBulkNotificationRequest {
    notificationIds?: number[] | undefined;
}

export class RegisterTokenRequest implements IRegisterTokenRequest {
    firebaseToken?: string | undefined;
    deviceId?: string | undefined;
    osPlatform?: string | undefined;
    osVersion?: string | undefined;

    constructor(data?: IRegisterTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firebaseToken = _data["FirebaseToken"];
            this.deviceId = _data["DeviceId"];
            this.osPlatform = _data["OsPlatform"];
            this.osVersion = _data["OsVersion"];
        }
    }

    static fromJS(data: any): RegisterTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirebaseToken"] = this.firebaseToken;
        data["DeviceId"] = this.deviceId;
        data["OsPlatform"] = this.osPlatform;
        data["OsVersion"] = this.osVersion;
        return data;
    }
}

export interface IRegisterTokenRequest {
    firebaseToken?: string | undefined;
    deviceId?: string | undefined;
    osPlatform?: string | undefined;
    osVersion?: string | undefined;
}

export class ListOrderCustomerResponseModel implements IListOrderCustomerResponseModel {
    id!: string;
    code?: string | undefined;
    orderTotal!: number;
    quantity!: number;
    createdTime!: Date;
    createTimeStr?: string | undefined;
    createdId!: string;
    customerId?: number | undefined;
    customerName?: string | undefined;
    paymentMethod!: number;
    orderTime!: Date;
    orderType!: number;
    type!: number;
    orderChannel!: number;
    discount!: number;
    note?: string | undefined;
    price!: number;
    isUsingPrescription!: boolean;
    payingAmtInvoice!: number;
    remainingDebt!: number;
    importedId!: string;
    statusId!: OrderCustomerStatusEnum;
    isDeleted!: boolean;
    totalPriceCost!: number;
    status?: string | undefined;
    orderItemCustomers?: OrderItemCustomer[] | undefined;
    listOrderItemResponseModels?: ListOrderItemResponseModel[] | undefined;

    constructor(data?: IListOrderCustomerResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.code = _data["Code"];
            this.orderTotal = _data["OrderTotal"];
            this.quantity = _data["Quantity"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.createTimeStr = _data["CreateTimeStr"];
            this.createdId = _data["CreatedId"];
            this.customerId = _data["CustomerId"];
            this.customerName = _data["CustomerName"];
            this.paymentMethod = _data["PaymentMethod"];
            this.orderTime = _data["OrderTime"] ? new Date(_data["OrderTime"].toString()) : <any>undefined;
            this.orderType = _data["OrderType"];
            this.type = _data["Type"];
            this.orderChannel = _data["OrderChannel"];
            this.discount = _data["Discount"];
            this.note = _data["Note"];
            this.price = _data["Price"];
            this.isUsingPrescription = _data["IsUsingPrescription"];
            this.payingAmtInvoice = _data["PayingAmtInvoice"];
            this.remainingDebt = _data["RemainingDebt"];
            this.importedId = _data["ImportedId"];
            this.statusId = _data["StatusId"];
            this.isDeleted = _data["IsDeleted"];
            this.totalPriceCost = _data["TotalPriceCost"];
            this.status = _data["Status"];
            if (Array.isArray(_data["OrderItemCustomers"])) {
                this.orderItemCustomers = [] as any;
                for (let item of _data["OrderItemCustomers"])
                    this.orderItemCustomers!.push(OrderItemCustomer.fromJS(item));
            }
            if (Array.isArray(_data["ListOrderItemResponseModels"])) {
                this.listOrderItemResponseModels = [] as any;
                for (let item of _data["ListOrderItemResponseModels"])
                    this.listOrderItemResponseModels!.push(ListOrderItemResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListOrderCustomerResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListOrderCustomerResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Code"] = this.code;
        data["OrderTotal"] = this.orderTotal;
        data["Quantity"] = this.quantity;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["CreateTimeStr"] = this.createTimeStr;
        data["CreatedId"] = this.createdId;
        data["CustomerId"] = this.customerId;
        data["CustomerName"] = this.customerName;
        data["PaymentMethod"] = this.paymentMethod;
        data["OrderTime"] = this.orderTime ? this.orderTime.toISOString() : <any>undefined;
        data["OrderType"] = this.orderType;
        data["Type"] = this.type;
        data["OrderChannel"] = this.orderChannel;
        data["Discount"] = this.discount;
        data["Note"] = this.note;
        data["Price"] = this.price;
        data["IsUsingPrescription"] = this.isUsingPrescription;
        data["PayingAmtInvoice"] = this.payingAmtInvoice;
        data["RemainingDebt"] = this.remainingDebt;
        data["ImportedId"] = this.importedId;
        data["StatusId"] = this.statusId;
        data["IsDeleted"] = this.isDeleted;
        data["TotalPriceCost"] = this.totalPriceCost;
        data["Status"] = this.status;
        if (Array.isArray(this.orderItemCustomers)) {
            data["OrderItemCustomers"] = [];
            for (let item of this.orderItemCustomers)
                data["OrderItemCustomers"].push(item.toJSON());
        }
        if (Array.isArray(this.listOrderItemResponseModels)) {
            data["ListOrderItemResponseModels"] = [];
            for (let item of this.listOrderItemResponseModels)
                data["ListOrderItemResponseModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListOrderCustomerResponseModel {
    id: string;
    code?: string | undefined;
    orderTotal: number;
    quantity: number;
    createdTime: Date;
    createTimeStr?: string | undefined;
    createdId: string;
    customerId?: number | undefined;
    customerName?: string | undefined;
    paymentMethod: number;
    orderTime: Date;
    orderType: number;
    type: number;
    orderChannel: number;
    discount: number;
    note?: string | undefined;
    price: number;
    isUsingPrescription: boolean;
    payingAmtInvoice: number;
    remainingDebt: number;
    importedId: string;
    statusId: OrderCustomerStatusEnum;
    isDeleted: boolean;
    totalPriceCost: number;
    status?: string | undefined;
    orderItemCustomers?: OrderItemCustomer[] | undefined;
    listOrderItemResponseModels?: ListOrderItemResponseModel[] | undefined;
}

export class OrderItemCustomer implements IOrderItemCustomer {
    id!: number;
    productId!: string;
    unitPrice!: number;
    quantity!: number;
    price!: number;
    orderId!: string;
    note?: string | undefined;
    productUnitName?: string | undefined;
    discount!: number;
    discountType!: number;
    adjustedPrice!: number;
    priceCost!: number;
    inventoryId!: number;
    productPriceMappingId?: number | undefined;

    constructor(data?: IOrderItemCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.productId = _data["ProductId"];
            this.unitPrice = _data["UnitPrice"];
            this.quantity = _data["Quantity"];
            this.price = _data["Price"];
            this.orderId = _data["OrderId"];
            this.note = _data["Note"];
            this.productUnitName = _data["ProductUnitName"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.adjustedPrice = _data["AdjustedPrice"];
            this.priceCost = _data["PriceCost"];
            this.inventoryId = _data["InventoryId"];
            this.productPriceMappingId = _data["ProductPriceMappingId"];
        }
    }

    static fromJS(data: any): OrderItemCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ProductId"] = this.productId;
        data["UnitPrice"] = this.unitPrice;
        data["Quantity"] = this.quantity;
        data["Price"] = this.price;
        data["OrderId"] = this.orderId;
        data["Note"] = this.note;
        data["ProductUnitName"] = this.productUnitName;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["AdjustedPrice"] = this.adjustedPrice;
        data["PriceCost"] = this.priceCost;
        data["InventoryId"] = this.inventoryId;
        data["ProductPriceMappingId"] = this.productPriceMappingId;
        return data;
    }
}

export interface IOrderItemCustomer {
    id: number;
    productId: string;
    unitPrice: number;
    quantity: number;
    price: number;
    orderId: string;
    note?: string | undefined;
    productUnitName?: string | undefined;
    discount: number;
    discountType: number;
    adjustedPrice: number;
    priceCost: number;
    inventoryId: number;
    productPriceMappingId?: number | undefined;
}

export class ListOrderItemResponseModel implements IListOrderItemResponseModel {
    id!: number;
    productId!: string;
    unitPrice!: number;
    adjustedPrice!: number;
    unitPriceFromProduct!: number;
    quantity!: number;
    price!: number;
    orderId!: string;
    note?: string | undefined;
    productUnitName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    discount!: number;
    priceCost!: number;
    lstPrice?: ProductPriceMappingResponse[] | undefined;
    isInventoryAvailble!: boolean;
    inventoryAvaibleCount!: number;

    constructor(data?: IListOrderItemResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.productId = _data["ProductId"];
            this.unitPrice = _data["UnitPrice"];
            this.adjustedPrice = _data["AdjustedPrice"];
            this.unitPriceFromProduct = _data["UnitPriceFromProduct"];
            this.quantity = _data["Quantity"];
            this.price = _data["Price"];
            this.orderId = _data["OrderId"];
            this.note = _data["Note"];
            this.productUnitName = _data["ProductUnitName"];
            this.productCode = _data["ProductCode"];
            this.productName = _data["ProductName"];
            this.discount = _data["Discount"];
            this.priceCost = _data["PriceCost"];
            if (Array.isArray(_data["LstPrice"])) {
                this.lstPrice = [] as any;
                for (let item of _data["LstPrice"])
                    this.lstPrice!.push(ProductPriceMappingResponse.fromJS(item));
            }
            this.isInventoryAvailble = _data["IsInventoryAvailble"];
            this.inventoryAvaibleCount = _data["InventoryAvaibleCount"];
        }
    }

    static fromJS(data: any): ListOrderItemResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListOrderItemResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ProductId"] = this.productId;
        data["UnitPrice"] = this.unitPrice;
        data["AdjustedPrice"] = this.adjustedPrice;
        data["UnitPriceFromProduct"] = this.unitPriceFromProduct;
        data["Quantity"] = this.quantity;
        data["Price"] = this.price;
        data["OrderId"] = this.orderId;
        data["Note"] = this.note;
        data["ProductUnitName"] = this.productUnitName;
        data["ProductCode"] = this.productCode;
        data["ProductName"] = this.productName;
        data["Discount"] = this.discount;
        data["PriceCost"] = this.priceCost;
        if (Array.isArray(this.lstPrice)) {
            data["LstPrice"] = [];
            for (let item of this.lstPrice)
                data["LstPrice"].push(item.toJSON());
        }
        data["IsInventoryAvailble"] = this.isInventoryAvailble;
        data["InventoryAvaibleCount"] = this.inventoryAvaibleCount;
        return data;
    }
}

export interface IListOrderItemResponseModel {
    id: number;
    productId: string;
    unitPrice: number;
    adjustedPrice: number;
    unitPriceFromProduct: number;
    quantity: number;
    price: number;
    orderId: string;
    note?: string | undefined;
    productUnitName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    discount: number;
    priceCost: number;
    lstPrice?: ProductPriceMappingResponse[] | undefined;
    isInventoryAvailble: boolean;
    inventoryAvaibleCount: number;
}

export class ProductPriceMappingResponse implements IProductPriceMappingResponse {
    price!: number;
    id!: number;
    type!: number;
    productId!: string;
    quantity!: number;
    quantityOrigin!: number;
    date!: Date;
    supplierId!: number;
    purchaseOrderId!: string;

    constructor(data?: IProductPriceMappingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["Price"];
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.productId = _data["ProductId"];
            this.quantity = _data["Quantity"];
            this.quantityOrigin = _data["QuantityOrigin"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.supplierId = _data["SupplierId"];
            this.purchaseOrderId = _data["PurchaseOrderId"];
        }
    }

    static fromJS(data: any): ProductPriceMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Price"] = this.price;
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["ProductId"] = this.productId;
        data["Quantity"] = this.quantity;
        data["QuantityOrigin"] = this.quantityOrigin;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["SupplierId"] = this.supplierId;
        data["PurchaseOrderId"] = this.purchaseOrderId;
        return data;
    }
}

export interface IProductPriceMappingResponse {
    price: number;
    id: number;
    type: number;
    productId: string;
    quantity: number;
    quantityOrigin: number;
    date: Date;
    supplierId: number;
    purchaseOrderId: string;
}

export class OrderCustomerSearchModel implements IOrderCustomerSearchModel {
    keySearch?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    status?: number | undefined;
    isUsingPrescription?: boolean | undefined;
    createdId?: string | undefined;
    customerId?: number | undefined;
    importedId?: string | undefined;
    orderChannel?: number | undefined;
    paymentMethod?: number | undefined;
    paymentPartialMethod?: number | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    productId?: string | undefined;
    isOrdered!: boolean;
    orderCustomerTypeEnum?: number | undefined;
    hasItemWithPriceBelowCost?: boolean | undefined;

    constructor(data?: IOrderCustomerSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keySearch = _data["KeySearch"];
            this.from = _data["From"] ? new Date(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? new Date(_data["To"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.isUsingPrescription = _data["IsUsingPrescription"];
            this.createdId = _data["CreatedId"];
            this.customerId = _data["CustomerId"];
            this.importedId = _data["ImportedId"];
            this.orderChannel = _data["OrderChannel"];
            this.paymentMethod = _data["PaymentMethod"];
            this.paymentPartialMethod = _data["PaymentPartialMethod"];
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.productId = _data["ProductId"];
            this.isOrdered = _data["IsOrdered"];
            this.orderCustomerTypeEnum = _data["OrderCustomerTypeEnum"];
            this.hasItemWithPriceBelowCost = _data["HasItemWithPriceBelowCost"];
        }
    }

    static fromJS(data: any): OrderCustomerSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["KeySearch"] = this.keySearch;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["IsUsingPrescription"] = this.isUsingPrescription;
        data["CreatedId"] = this.createdId;
        data["CustomerId"] = this.customerId;
        data["ImportedId"] = this.importedId;
        data["OrderChannel"] = this.orderChannel;
        data["PaymentMethod"] = this.paymentMethod;
        data["PaymentPartialMethod"] = this.paymentPartialMethod;
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["ProductId"] = this.productId;
        data["IsOrdered"] = this.isOrdered;
        data["OrderCustomerTypeEnum"] = this.orderCustomerTypeEnum;
        data["HasItemWithPriceBelowCost"] = this.hasItemWithPriceBelowCost;
        return data;
    }
}

export interface IOrderCustomerSearchModel {
    keySearch?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    status?: number | undefined;
    isUsingPrescription?: boolean | undefined;
    createdId?: string | undefined;
    customerId?: number | undefined;
    importedId?: string | undefined;
    orderChannel?: number | undefined;
    paymentMethod?: number | undefined;
    paymentPartialMethod?: number | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    productId?: string | undefined;
    isOrdered: boolean;
    orderCustomerTypeEnum?: number | undefined;
    hasItemWithPriceBelowCost?: boolean | undefined;
}

export class PaginatorResponseOfListOrderCustomerResponseModel implements IPaginatorResponseOfListOrderCustomerResponseModel {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: ListOrderCustomerResponseModel[] | undefined;

    constructor(data?: IPaginatorResponseOfListOrderCustomerResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ListOrderCustomerResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfListOrderCustomerResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfListOrderCustomerResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfListOrderCustomerResponseModel {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: ListOrderCustomerResponseModel[] | undefined;
}

export class PaginatorResponseOfListOrderItemResponseModel implements IPaginatorResponseOfListOrderItemResponseModel {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: ListOrderItemResponseModel[] | undefined;

    constructor(data?: IPaginatorResponseOfListOrderItemResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ListOrderItemResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfListOrderItemResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfListOrderItemResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfListOrderItemResponseModel {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: ListOrderItemResponseModel[] | undefined;
}

export class OrderItemRequestSearchModel implements IOrderItemRequestSearchModel {
    orderCustomerId!: string;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    keySearch?: string | undefined;

    constructor(data?: IOrderItemRequestSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCustomerId = _data["OrderCustomerId"];
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.keySearch = _data["KeySearch"];
        }
    }

    static fromJS(data: any): OrderItemRequestSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemRequestSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderCustomerId"] = this.orderCustomerId;
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["KeySearch"] = this.keySearch;
        return data;
    }
}

export interface IOrderItemRequestSearchModel {
    orderCustomerId: string;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    keySearch?: string | undefined;
}

export class OrderCustomerDto implements IOrderCustomerDto {
    id!: string;
    code?: string | undefined;
    orderTotal!: number;
    quantity!: number;
    createdTime!: Date;
    createdId!: string;
    customerId?: number | undefined;
    paymentMethod!: number;
    orderTime!: Date;
    orderType!: number;
    orderChannel!: number;
    discount!: number;
    note?: string | undefined;
    price!: number;
    isUsingPrescription!: boolean;
    payingAmtInvoice!: number;
    remainingDebt!: number;
    importedId!: string;
    statusId!: number;
    isDeleted!: boolean;
    createdName?: string | undefined;
    customerName?: string | undefined;

    constructor(data?: IOrderCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.code = _data["Code"];
            this.orderTotal = _data["OrderTotal"];
            this.quantity = _data["Quantity"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.customerId = _data["CustomerId"];
            this.paymentMethod = _data["PaymentMethod"];
            this.orderTime = _data["OrderTime"] ? new Date(_data["OrderTime"].toString()) : <any>undefined;
            this.orderType = _data["OrderType"];
            this.orderChannel = _data["OrderChannel"];
            this.discount = _data["Discount"];
            this.note = _data["Note"];
            this.price = _data["Price"];
            this.isUsingPrescription = _data["IsUsingPrescription"];
            this.payingAmtInvoice = _data["PayingAmtInvoice"];
            this.remainingDebt = _data["RemainingDebt"];
            this.importedId = _data["ImportedId"];
            this.statusId = _data["StatusId"];
            this.isDeleted = _data["IsDeleted"];
            this.createdName = _data["CreatedName"];
            this.customerName = _data["CustomerName"];
        }
    }

    static fromJS(data: any): OrderCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Code"] = this.code;
        data["OrderTotal"] = this.orderTotal;
        data["Quantity"] = this.quantity;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["CustomerId"] = this.customerId;
        data["PaymentMethod"] = this.paymentMethod;
        data["OrderTime"] = this.orderTime ? this.orderTime.toISOString() : <any>undefined;
        data["OrderType"] = this.orderType;
        data["OrderChannel"] = this.orderChannel;
        data["Discount"] = this.discount;
        data["Note"] = this.note;
        data["Price"] = this.price;
        data["IsUsingPrescription"] = this.isUsingPrescription;
        data["PayingAmtInvoice"] = this.payingAmtInvoice;
        data["RemainingDebt"] = this.remainingDebt;
        data["ImportedId"] = this.importedId;
        data["StatusId"] = this.statusId;
        data["IsDeleted"] = this.isDeleted;
        data["CreatedName"] = this.createdName;
        data["CustomerName"] = this.customerName;
        return data;
    }
}

export interface IOrderCustomerDto {
    id: string;
    code?: string | undefined;
    orderTotal: number;
    quantity: number;
    createdTime: Date;
    createdId: string;
    customerId?: number | undefined;
    paymentMethod: number;
    orderTime: Date;
    orderType: number;
    orderChannel: number;
    discount: number;
    note?: string | undefined;
    price: number;
    isUsingPrescription: boolean;
    payingAmtInvoice: number;
    remainingDebt: number;
    importedId: string;
    statusId: number;
    isDeleted: boolean;
    createdName?: string | undefined;
    customerName?: string | undefined;
}

export class OrderInfoModel implements IOrderInfoModel {
    id!: string;
    importerId!: string;
    orderChanel!: number;
    note?: string | undefined;
    createdTime!: Date;
    status?: OrderCustomerStatusEnum | undefined;

    constructor(data?: IOrderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.importerId = _data["ImporterId"];
            this.orderChanel = _data["OrderChanel"];
            this.note = _data["Note"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): OrderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ImporterId"] = this.importerId;
        data["OrderChanel"] = this.orderChanel;
        data["Note"] = this.note;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["Status"] = this.status;
        return data;
    }
}

export interface IOrderInfoModel {
    id: string;
    importerId: string;
    orderChanel: number;
    note?: string | undefined;
    createdTime: Date;
    status?: OrderCustomerStatusEnum | undefined;
}

export class AddOrUpdateOrderItemCustomerModel implements IAddOrUpdateOrderItemCustomerModel {
    id?: number | undefined;
    unitPrice!: number;
    adjustedPrice!: number;
    quantity!: number;
    productId?: string | undefined;
    orderId!: string;
    note?: string | undefined;
    isCreate!: boolean;

    constructor(data?: IAddOrUpdateOrderItemCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.unitPrice = _data["UnitPrice"];
            this.adjustedPrice = _data["AdjustedPrice"];
            this.quantity = _data["Quantity"];
            this.productId = _data["ProductId"];
            this.orderId = _data["OrderId"];
            this.note = _data["Note"];
            this.isCreate = _data["IsCreate"];
        }
    }

    static fromJS(data: any): AddOrUpdateOrderItemCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateOrderItemCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UnitPrice"] = this.unitPrice;
        data["AdjustedPrice"] = this.adjustedPrice;
        data["Quantity"] = this.quantity;
        data["ProductId"] = this.productId;
        data["OrderId"] = this.orderId;
        data["Note"] = this.note;
        data["IsCreate"] = this.isCreate;
        return data;
    }
}

export interface IAddOrUpdateOrderItemCustomerModel {
    id?: number | undefined;
    unitPrice: number;
    adjustedPrice: number;
    quantity: number;
    productId?: string | undefined;
    orderId: string;
    note?: string | undefined;
    isCreate: boolean;
}

export class OrderCustomerModel implements IOrderCustomerModel {
    isInvoiceByTime!: boolean;
    code?: string | undefined;
    payingAmtInvoice!: number;
    price!: number;
    orderTotal!: number;
    quantity!: number;
    orderTime!: Date;
    paymentTypeEnum!: PaymentTypeEnum;
    orderType!: OrderTypeEnum;
    discount!: number;
    discountType!: DiscountTypeEnum;
    orderChannel!: number;
    note?: string | undefined;
    customerId!: number;
    createdId!: string;
    isUsingPrescription!: boolean;
    status!: OrderCustomerStatusEnum;
    deliveryTime?: Date | undefined;
    orderItemCustomers?: OrderItemCustomerModel[] | undefined;
    orderCustomerTypeEnum!: OrderCustomerTypeEnum;

    constructor(data?: IOrderCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInvoiceByTime = _data["IsInvoiceByTime"];
            this.code = _data["Code"];
            this.payingAmtInvoice = _data["PayingAmtInvoice"];
            this.price = _data["Price"];
            this.orderTotal = _data["OrderTotal"];
            this.quantity = _data["Quantity"];
            this.orderTime = _data["OrderTime"] ? new Date(_data["OrderTime"].toString()) : <any>undefined;
            this.paymentTypeEnum = _data["PaymentTypeEnum"];
            this.orderType = _data["OrderType"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.orderChannel = _data["OrderChannel"];
            this.note = _data["Note"];
            this.customerId = _data["CustomerId"];
            this.createdId = _data["CreatedId"];
            this.isUsingPrescription = _data["IsUsingPrescription"];
            this.status = _data["Status"];
            this.deliveryTime = _data["DeliveryTime"] ? new Date(_data["DeliveryTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["OrderItemCustomers"])) {
                this.orderItemCustomers = [] as any;
                for (let item of _data["OrderItemCustomers"])
                    this.orderItemCustomers!.push(OrderItemCustomerModel.fromJS(item));
            }
            this.orderCustomerTypeEnum = _data["OrderCustomerTypeEnum"];
        }
    }

    static fromJS(data: any): OrderCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsInvoiceByTime"] = this.isInvoiceByTime;
        data["Code"] = this.code;
        data["PayingAmtInvoice"] = this.payingAmtInvoice;
        data["Price"] = this.price;
        data["OrderTotal"] = this.orderTotal;
        data["Quantity"] = this.quantity;
        data["OrderTime"] = this.orderTime ? this.orderTime.toISOString() : <any>undefined;
        data["PaymentTypeEnum"] = this.paymentTypeEnum;
        data["OrderType"] = this.orderType;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["OrderChannel"] = this.orderChannel;
        data["Note"] = this.note;
        data["CustomerId"] = this.customerId;
        data["CreatedId"] = this.createdId;
        data["IsUsingPrescription"] = this.isUsingPrescription;
        data["Status"] = this.status;
        data["DeliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        if (Array.isArray(this.orderItemCustomers)) {
            data["OrderItemCustomers"] = [];
            for (let item of this.orderItemCustomers)
                data["OrderItemCustomers"].push(item.toJSON());
        }
        data["OrderCustomerTypeEnum"] = this.orderCustomerTypeEnum;
        return data;
    }
}

export interface IOrderCustomerModel {
    isInvoiceByTime: boolean;
    code?: string | undefined;
    payingAmtInvoice: number;
    price: number;
    orderTotal: number;
    quantity: number;
    orderTime: Date;
    paymentTypeEnum: PaymentTypeEnum;
    orderType: OrderTypeEnum;
    discount: number;
    discountType: DiscountTypeEnum;
    orderChannel: number;
    note?: string | undefined;
    customerId: number;
    createdId: string;
    isUsingPrescription: boolean;
    status: OrderCustomerStatusEnum;
    deliveryTime?: Date | undefined;
    orderItemCustomers?: OrderItemCustomerModel[] | undefined;
    orderCustomerTypeEnum: OrderCustomerTypeEnum;
}

export class OrderItemCustomerModel implements IOrderItemCustomerModel {
    productDto?: ProductDto | undefined;
    productName?: string | undefined;
    productCode?: string | undefined;
    productId?: string | undefined;
    note?: string | undefined;
    unitPrice!: number;
    price?: number | undefined;
    orderId?: string | undefined;
    productUnitName?: string | undefined;
    quantity!: number;
    isShowNoteItem!: boolean;
    discount!: number;
    discountType!: DiscountTypeEnum;
    adjustedPrice!: number;
    priceCost!: number;
    inventory!: number;

    constructor(data?: IOrderItemCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDto = _data["ProductDto"] ? ProductDto.fromJS(_data["ProductDto"]) : <any>undefined;
            this.productName = _data["ProductName"];
            this.productCode = _data["ProductCode"];
            this.productId = _data["ProductId"];
            this.note = _data["Note"];
            this.unitPrice = _data["UnitPrice"];
            this.price = _data["Price"];
            this.orderId = _data["OrderId"];
            this.productUnitName = _data["ProductUnitName"];
            this.quantity = _data["Quantity"];
            this.isShowNoteItem = _data["IsShowNoteItem"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.adjustedPrice = _data["AdjustedPrice"];
            this.priceCost = _data["PriceCost"];
            this.inventory = _data["Inventory"];
        }
    }

    static fromJS(data: any): OrderItemCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductDto"] = this.productDto ? this.productDto.toJSON() : <any>undefined;
        data["ProductName"] = this.productName;
        data["ProductCode"] = this.productCode;
        data["ProductId"] = this.productId;
        data["Note"] = this.note;
        data["UnitPrice"] = this.unitPrice;
        data["Price"] = this.price;
        data["OrderId"] = this.orderId;
        data["ProductUnitName"] = this.productUnitName;
        data["Quantity"] = this.quantity;
        data["IsShowNoteItem"] = this.isShowNoteItem;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["AdjustedPrice"] = this.adjustedPrice;
        data["PriceCost"] = this.priceCost;
        data["Inventory"] = this.inventory;
        return data;
    }
}

export interface IOrderItemCustomerModel {
    productDto?: ProductDto | undefined;
    productName?: string | undefined;
    productCode?: string | undefined;
    productId?: string | undefined;
    note?: string | undefined;
    unitPrice: number;
    price?: number | undefined;
    orderId?: string | undefined;
    productUnitName?: string | undefined;
    quantity: number;
    isShowNoteItem: boolean;
    discount: number;
    discountType: DiscountTypeEnum;
    adjustedPrice: number;
    priceCost: number;
    inventory: number;
}

export class ProductDto implements IProductDto {
    id!: string;
    color?: string | undefined;
    abbreviations?: string | undefined;
    barcode?: string | undefined;
    bodyUsedId!: number;
    bodyUsedString?: string | undefined;
    categoryId!: number;
    categoryString?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hamLuong?: string | undefined;
    hoatChat?: string | undefined;
    inventoryMax!: number;
    inventoryMin!: number;
    inventory!: number;
    qtyPurchaseOrder!: number;
    qtyOrder!: number;
    isHomepage!: boolean;
    productUnitId!: number;
    productUnitName?: string | undefined;
    manufacturerId?: number | undefined;
    manufacturerString?: string | undefined;
    noteOrder?: string | undefined;
    packing?: string | undefined;
    positionId!: number;
    positionString?: string | undefined;
    priceCost!: number;
    price!: number;
    quocGiaId!: number;
    quocGiaString?: string | undefined;
    registrationNumber?: string | undefined;
    title?: string | undefined;
    weight!: number;
    type!: ProductEnum;
    typeString?: string | undefined;
    inventoryQuantity!: number;
    orderQuantity!: number;
    outOfStockDays!: number;
    status!: ProductStatusEnum;
    statusString?: string | undefined;
    lstPrice?: ProductPriceMappingResponse[] | undefined;
    isOverInventory!: boolean;
    fileId!: string;
    note?: string | undefined;
    quantity!: number;
    discount!: number;
    discountType!: number;
    orderTotal!: number;
    discountTypeActive!: boolean;
    productPriceMappings?: ProductPriceMapping[] | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    isPaidSupplier?: boolean | undefined;
    paidSupplierDate?: Date | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.color = _data["Color"];
            this.abbreviations = _data["Abbreviations"];
            this.barcode = _data["Barcode"];
            this.bodyUsedId = _data["BodyUsedId"];
            this.bodyUsedString = _data["BodyUsedString"];
            this.categoryId = _data["CategoryId"];
            this.categoryString = _data["CategoryString"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.hamLuong = _data["HamLuong"];
            this.hoatChat = _data["HoatChat"];
            this.inventoryMax = _data["InventoryMax"];
            this.inventoryMin = _data["InventoryMin"];
            this.inventory = _data["Inventory"];
            this.qtyPurchaseOrder = _data["QtyPurchaseOrder"];
            this.qtyOrder = _data["QtyOrder"];
            this.isHomepage = _data["IsHomepage"];
            this.productUnitId = _data["ProductUnitId"];
            this.productUnitName = _data["ProductUnitName"];
            this.manufacturerId = _data["ManufacturerId"];
            this.manufacturerString = _data["ManufacturerString"];
            this.noteOrder = _data["NoteOrder"];
            this.packing = _data["Packing"];
            this.positionId = _data["PositionId"];
            this.positionString = _data["PositionString"];
            this.priceCost = _data["PriceCost"];
            this.price = _data["Price"];
            this.quocGiaId = _data["QuocGiaId"];
            this.quocGiaString = _data["QuocGiaString"];
            this.registrationNumber = _data["RegistrationNumber"];
            this.title = _data["Title"];
            this.weight = _data["Weight"];
            this.type = _data["Type"];
            this.typeString = _data["TypeString"];
            this.inventoryQuantity = _data["InventoryQuantity"];
            this.orderQuantity = _data["OrderQuantity"];
            this.outOfStockDays = _data["OutOfStockDays"];
            this.status = _data["Status"];
            this.statusString = _data["StatusString"];
            if (Array.isArray(_data["LstPrice"])) {
                this.lstPrice = [] as any;
                for (let item of _data["LstPrice"])
                    this.lstPrice!.push(ProductPriceMappingResponse.fromJS(item));
            }
            this.isOverInventory = _data["IsOverInventory"];
            this.fileId = _data["FileId"];
            this.note = _data["Note"];
            this.quantity = _data["Quantity"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.orderTotal = _data["OrderTotal"];
            this.discountTypeActive = _data["DiscountTypeActive"];
            if (Array.isArray(_data["ProductPriceMappings"])) {
                this.productPriceMappings = [] as any;
                for (let item of _data["ProductPriceMappings"])
                    this.productPriceMappings!.push(ProductPriceMapping.fromJS(item));
            }
            this.supplierId = _data["SupplierId"];
            this.supplierName = _data["SupplierName"];
            this.isPaidSupplier = _data["IsPaidSupplier"];
            this.paidSupplierDate = _data["PaidSupplierDate"] ? new Date(_data["PaidSupplierDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Color"] = this.color;
        data["Abbreviations"] = this.abbreviations;
        data["Barcode"] = this.barcode;
        data["BodyUsedId"] = this.bodyUsedId;
        data["BodyUsedString"] = this.bodyUsedString;
        data["CategoryId"] = this.categoryId;
        data["CategoryString"] = this.categoryString;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["HamLuong"] = this.hamLuong;
        data["HoatChat"] = this.hoatChat;
        data["InventoryMax"] = this.inventoryMax;
        data["InventoryMin"] = this.inventoryMin;
        data["Inventory"] = this.inventory;
        data["QtyPurchaseOrder"] = this.qtyPurchaseOrder;
        data["QtyOrder"] = this.qtyOrder;
        data["IsHomepage"] = this.isHomepage;
        data["ProductUnitId"] = this.productUnitId;
        data["ProductUnitName"] = this.productUnitName;
        data["ManufacturerId"] = this.manufacturerId;
        data["ManufacturerString"] = this.manufacturerString;
        data["NoteOrder"] = this.noteOrder;
        data["Packing"] = this.packing;
        data["PositionId"] = this.positionId;
        data["PositionString"] = this.positionString;
        data["PriceCost"] = this.priceCost;
        data["Price"] = this.price;
        data["QuocGiaId"] = this.quocGiaId;
        data["QuocGiaString"] = this.quocGiaString;
        data["RegistrationNumber"] = this.registrationNumber;
        data["Title"] = this.title;
        data["Weight"] = this.weight;
        data["Type"] = this.type;
        data["TypeString"] = this.typeString;
        data["InventoryQuantity"] = this.inventoryQuantity;
        data["OrderQuantity"] = this.orderQuantity;
        data["OutOfStockDays"] = this.outOfStockDays;
        data["Status"] = this.status;
        data["StatusString"] = this.statusString;
        if (Array.isArray(this.lstPrice)) {
            data["LstPrice"] = [];
            for (let item of this.lstPrice)
                data["LstPrice"].push(item.toJSON());
        }
        data["IsOverInventory"] = this.isOverInventory;
        data["FileId"] = this.fileId;
        data["Note"] = this.note;
        data["Quantity"] = this.quantity;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["OrderTotal"] = this.orderTotal;
        data["DiscountTypeActive"] = this.discountTypeActive;
        if (Array.isArray(this.productPriceMappings)) {
            data["ProductPriceMappings"] = [];
            for (let item of this.productPriceMappings)
                data["ProductPriceMappings"].push(item.toJSON());
        }
        data["SupplierId"] = this.supplierId;
        data["SupplierName"] = this.supplierName;
        data["IsPaidSupplier"] = this.isPaidSupplier;
        data["PaidSupplierDate"] = this.paidSupplierDate ? this.paidSupplierDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductDto {
    id: string;
    color?: string | undefined;
    abbreviations?: string | undefined;
    barcode?: string | undefined;
    bodyUsedId: number;
    bodyUsedString?: string | undefined;
    categoryId: number;
    categoryString?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hamLuong?: string | undefined;
    hoatChat?: string | undefined;
    inventoryMax: number;
    inventoryMin: number;
    inventory: number;
    qtyPurchaseOrder: number;
    qtyOrder: number;
    isHomepage: boolean;
    productUnitId: number;
    productUnitName?: string | undefined;
    manufacturerId?: number | undefined;
    manufacturerString?: string | undefined;
    noteOrder?: string | undefined;
    packing?: string | undefined;
    positionId: number;
    positionString?: string | undefined;
    priceCost: number;
    price: number;
    quocGiaId: number;
    quocGiaString?: string | undefined;
    registrationNumber?: string | undefined;
    title?: string | undefined;
    weight: number;
    type: ProductEnum;
    typeString?: string | undefined;
    inventoryQuantity: number;
    orderQuantity: number;
    outOfStockDays: number;
    status: ProductStatusEnum;
    statusString?: string | undefined;
    lstPrice?: ProductPriceMappingResponse[] | undefined;
    isOverInventory: boolean;
    fileId: string;
    note?: string | undefined;
    quantity: number;
    discount: number;
    discountType: number;
    orderTotal: number;
    discountTypeActive: boolean;
    productPriceMappings?: ProductPriceMapping[] | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    isPaidSupplier?: boolean | undefined;
    paidSupplierDate?: Date | undefined;
}

export class ProductPriceMapping implements IProductPriceMapping {
    price!: number;
    id!: number;
    type!: number;
    productId!: string;
    quantity!: number;
    date?: Date | undefined;
    supplierId!: number;
    purchaseOrderId?: string | undefined;
    quantityOrigin?: number | undefined;

    constructor(data?: IProductPriceMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["Price"];
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.productId = _data["ProductId"];
            this.quantity = _data["Quantity"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.supplierId = _data["SupplierId"];
            this.purchaseOrderId = _data["PurchaseOrderId"];
            this.quantityOrigin = _data["QuantityOrigin"];
        }
    }

    static fromJS(data: any): ProductPriceMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Price"] = this.price;
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["ProductId"] = this.productId;
        data["Quantity"] = this.quantity;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["SupplierId"] = this.supplierId;
        data["PurchaseOrderId"] = this.purchaseOrderId;
        data["QuantityOrigin"] = this.quantityOrigin;
        return data;
    }
}

export interface IProductPriceMapping {
    price: number;
    id: number;
    type: number;
    productId: string;
    quantity: number;
    date?: Date | undefined;
    supplierId: number;
    purchaseOrderId?: string | undefined;
    quantityOrigin?: number | undefined;
}

export class PartialPaymentRequest implements IPartialPaymentRequest {
    orderCustomerId!: string;
    amount!: number;
    paymentTime!: Date;
    paymentMethod!: number;
    paymentNote?: string | undefined;

    constructor(data?: IPartialPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCustomerId = _data["OrderCustomerId"];
            this.amount = _data["Amount"];
            this.paymentTime = _data["PaymentTime"] ? new Date(_data["PaymentTime"].toString()) : <any>undefined;
            this.paymentMethod = _data["PaymentMethod"];
            this.paymentNote = _data["PaymentNote"];
        }
    }

    static fromJS(data: any): PartialPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartialPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderCustomerId"] = this.orderCustomerId;
        data["Amount"] = this.amount;
        data["PaymentTime"] = this.paymentTime ? this.paymentTime.toISOString() : <any>undefined;
        data["PaymentMethod"] = this.paymentMethod;
        data["PaymentNote"] = this.paymentNote;
        return data;
    }
}

export interface IPartialPaymentRequest {
    orderCustomerId: string;
    amount: number;
    paymentTime: Date;
    paymentMethod: number;
    paymentNote?: string | undefined;
}

export class PaymentMethodDto implements IPaymentMethodDto {
    id!: number;
    methodCode?: string | undefined;
    methodName?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;
    displayOrder!: number;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.methodCode = _data["MethodCode"];
            this.methodName = _data["MethodName"];
            this.description = _data["Description"];
            this.isActive = _data["IsActive"];
            this.displayOrder = _data["DisplayOrder"];
        }
    }

    static fromJS(data: any): PaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["MethodCode"] = this.methodCode;
        data["MethodName"] = this.methodName;
        data["Description"] = this.description;
        data["IsActive"] = this.isActive;
        data["DisplayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IPaymentMethodDto {
    id: number;
    methodCode?: string | undefined;
    methodName?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    displayOrder: number;
}

export class CreatePaymentMethodRequest implements ICreatePaymentMethodRequest {
    methodCode?: string | undefined;
    methodName?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;
    displayOrder!: number;
    createId?: string | undefined;

    constructor(data?: ICreatePaymentMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.methodCode = _data["MethodCode"];
            this.methodName = _data["MethodName"];
            this.description = _data["Description"];
            this.isActive = _data["IsActive"];
            this.displayOrder = _data["DisplayOrder"];
            this.createId = _data["CreateId"];
        }
    }

    static fromJS(data: any): CreatePaymentMethodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentMethodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MethodCode"] = this.methodCode;
        data["MethodName"] = this.methodName;
        data["Description"] = this.description;
        data["IsActive"] = this.isActive;
        data["DisplayOrder"] = this.displayOrder;
        data["CreateId"] = this.createId;
        return data;
    }
}

export interface ICreatePaymentMethodRequest {
    methodCode?: string | undefined;
    methodName?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    displayOrder: number;
    createId?: string | undefined;
}

export class UpdatePaymentMethodRequest implements IUpdatePaymentMethodRequest {
    id!: number;
    methodCode?: string | undefined;
    methodName?: string | undefined;
    description?: string | undefined;
    isActive!: boolean;
    displayOrder!: number;
    updatedId?: string | undefined;

    constructor(data?: IUpdatePaymentMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.methodCode = _data["MethodCode"];
            this.methodName = _data["MethodName"];
            this.description = _data["Description"];
            this.isActive = _data["IsActive"];
            this.displayOrder = _data["DisplayOrder"];
            this.updatedId = _data["UpdatedId"];
        }
    }

    static fromJS(data: any): UpdatePaymentMethodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentMethodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["MethodCode"] = this.methodCode;
        data["MethodName"] = this.methodName;
        data["Description"] = this.description;
        data["IsActive"] = this.isActive;
        data["DisplayOrder"] = this.displayOrder;
        data["UpdatedId"] = this.updatedId;
        return data;
    }
}

export interface IUpdatePaymentMethodRequest {
    id: number;
    methodCode?: string | undefined;
    methodName?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    displayOrder: number;
    updatedId?: string | undefined;
}

export class CmsMenu implements ICmsMenu {
    path?: string | undefined;
    title?: string | undefined;
    icon?: string | undefined;
    type?: string | undefined;
    badgeType?: string | undefined;
    badgeValue?: string | undefined;
    active?: boolean | undefined;
    bookmark?: boolean | undefined;
    roles?: RoleEnum[] | undefined;
    key?: string | undefined;
    children?: CmsMenu[] | undefined;
    functions?: FunctionMenu[] | undefined;
    isAllow!: boolean;

    constructor(data?: ICmsMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["Path"];
            this.title = _data["Title"];
            this.icon = _data["Icon"];
            this.type = _data["Type"];
            this.badgeType = _data["BadgeType"];
            this.badgeValue = _data["BadgeValue"];
            this.active = _data["Active"];
            this.bookmark = _data["Bookmark"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.key = _data["Key"];
            if (Array.isArray(_data["Children"])) {
                this.children = [] as any;
                for (let item of _data["Children"])
                    this.children!.push(CmsMenu.fromJS(item));
            }
            if (Array.isArray(_data["Functions"])) {
                this.functions = [] as any;
                for (let item of _data["Functions"])
                    this.functions!.push(FunctionMenu.fromJS(item));
            }
            this.isAllow = _data["IsAllow"];
        }
    }

    static fromJS(data: any): CmsMenu {
        data = typeof data === 'object' ? data : {};
        let result = new CmsMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Path"] = this.path;
        data["Title"] = this.title;
        data["Icon"] = this.icon;
        data["Type"] = this.type;
        data["BadgeType"] = this.badgeType;
        data["BadgeValue"] = this.badgeValue;
        data["Active"] = this.active;
        data["Bookmark"] = this.bookmark;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["Key"] = this.key;
        if (Array.isArray(this.children)) {
            data["Children"] = [];
            for (let item of this.children)
                data["Children"].push(item.toJSON());
        }
        if (Array.isArray(this.functions)) {
            data["Functions"] = [];
            for (let item of this.functions)
                data["Functions"].push(item.toJSON());
        }
        data["IsAllow"] = this.isAllow;
        return data;
    }
}

export interface ICmsMenu {
    path?: string | undefined;
    title?: string | undefined;
    icon?: string | undefined;
    type?: string | undefined;
    badgeType?: string | undefined;
    badgeValue?: string | undefined;
    active?: boolean | undefined;
    bookmark?: boolean | undefined;
    roles?: RoleEnum[] | undefined;
    key?: string | undefined;
    children?: CmsMenu[] | undefined;
    functions?: FunctionMenu[] | undefined;
    isAllow: boolean;
}

export class FunctionMenu implements IFunctionMenu {
    title?: string | undefined;
    key?: string | undefined;
    roles?: RoleEnum[] | undefined;
    isAllow!: boolean;

    constructor(data?: IFunctionMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.key = _data["Key"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.isAllow = _data["IsAllow"];
        }
    }

    static fromJS(data: any): FunctionMenu {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Key"] = this.key;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["IsAllow"] = this.isAllow;
        return data;
    }
}

export interface IFunctionMenu {
    title?: string | undefined;
    key?: string | undefined;
    roles?: RoleEnum[] | undefined;
    isAllow: boolean;
}

export class SetPermissionRoleRequest implements ISetPermissionRoleRequest {
    lstKeyName?: string[] | undefined;
    role!: RoleEnum;

    constructor(data?: ISetPermissionRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["LstKeyName"])) {
                this.lstKeyName = [] as any;
                for (let item of _data["LstKeyName"])
                    this.lstKeyName!.push(item);
            }
            this.role = _data["Role"];
        }
    }

    static fromJS(data: any): SetPermissionRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPermissionRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lstKeyName)) {
            data["LstKeyName"] = [];
            for (let item of this.lstKeyName)
                data["LstKeyName"].push(item);
        }
        data["Role"] = this.role;
        return data;
    }
}

export interface ISetPermissionRoleRequest {
    lstKeyName?: string[] | undefined;
    role: RoleEnum;
}

export class SetPermissionAccountRequest implements ISetPermissionAccountRequest {
    accountId?: string | undefined;
    lstKeyName?: string[] | undefined;

    constructor(data?: ISetPermissionAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["AccountId"];
            if (Array.isArray(_data["LstKeyName"])) {
                this.lstKeyName = [] as any;
                for (let item of _data["LstKeyName"])
                    this.lstKeyName!.push(item);
            }
        }
    }

    static fromJS(data: any): SetPermissionAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPermissionAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId;
        if (Array.isArray(this.lstKeyName)) {
            data["LstKeyName"] = [];
            for (let item of this.lstKeyName)
                data["LstKeyName"].push(item);
        }
        return data;
    }
}

export interface ISetPermissionAccountRequest {
    accountId?: string | undefined;
    lstKeyName?: string[] | undefined;
}

export class PositionDto implements IPositionDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): PositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IPositionDto {
    id: number;
    name?: string | undefined;
}

export class PaginatorResponseOfGetListProductResponse implements IPaginatorResponseOfGetListProductResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: GetListProductResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfGetListProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(GetListProductResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfGetListProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfGetListProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfGetListProductResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: GetListProductResponse[] | undefined;
}

export class GetListProductResponse implements IGetListProductResponse {
    id!: string;
    color?: string | undefined;
    abbreviations?: string | undefined;
    barcode?: string | undefined;
    bodyUsedId!: number;
    bodyUsedString?: string | undefined;
    categoryId!: number;
    categoryString?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hamLuong?: string | undefined;
    hoatChat?: string | undefined;
    inventoryMax!: number;
    inventoryMin!: number;
    inventory!: number;
    qtyPurchaseOrder!: number;
    qtyOrder!: number;
    isHomepage!: boolean;
    productUnitId!: number;
    productUnitName?: string | undefined;
    manufacturerId?: number | undefined;
    manufacturerString?: string | undefined;
    noteOrder?: string | undefined;
    packing?: string | undefined;
    positionId!: number;
    positionString?: string | undefined;
    priceCost!: number;
    price!: number;
    quocGiaId!: number;
    quocGiaString?: string | undefined;
    registrationNumber?: string | undefined;
    title?: string | undefined;
    weight!: number;
    type!: ProductEnum;
    typeString?: string | undefined;
    inventoryQuantity!: number;
    orderQuantity!: number;
    outOfStockDays!: number;
    status!: ProductStatusEnum;
    statusString?: string | undefined;
    files?: string[] | undefined;
    note?: string | undefined;
    quantity!: number;
    discount!: number;
    discountType!: number;
    orderTotal!: number;
    discountTypeActive!: boolean;
    lstPrice?: ProductPriceMapping[] | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    isPaidSupplier?: boolean | undefined;
    paidSupplierDate?: Date | undefined;

    constructor(data?: IGetListProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.color = _data["Color"];
            this.abbreviations = _data["Abbreviations"];
            this.barcode = _data["Barcode"];
            this.bodyUsedId = _data["BodyUsedId"];
            this.bodyUsedString = _data["BodyUsedString"];
            this.categoryId = _data["CategoryId"];
            this.categoryString = _data["CategoryString"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.hamLuong = _data["HamLuong"];
            this.hoatChat = _data["HoatChat"];
            this.inventoryMax = _data["InventoryMax"];
            this.inventoryMin = _data["InventoryMin"];
            this.inventory = _data["Inventory"];
            this.qtyPurchaseOrder = _data["QtyPurchaseOrder"];
            this.qtyOrder = _data["QtyOrder"];
            this.isHomepage = _data["IsHomepage"];
            this.productUnitId = _data["ProductUnitId"];
            this.productUnitName = _data["ProductUnitName"];
            this.manufacturerId = _data["ManufacturerId"];
            this.manufacturerString = _data["ManufacturerString"];
            this.noteOrder = _data["NoteOrder"];
            this.packing = _data["Packing"];
            this.positionId = _data["PositionId"];
            this.positionString = _data["PositionString"];
            this.priceCost = _data["PriceCost"];
            this.price = _data["Price"];
            this.quocGiaId = _data["QuocGiaId"];
            this.quocGiaString = _data["QuocGiaString"];
            this.registrationNumber = _data["RegistrationNumber"];
            this.title = _data["Title"];
            this.weight = _data["Weight"];
            this.type = _data["Type"];
            this.typeString = _data["TypeString"];
            this.inventoryQuantity = _data["InventoryQuantity"];
            this.orderQuantity = _data["OrderQuantity"];
            this.outOfStockDays = _data["OutOfStockDays"];
            this.status = _data["Status"];
            this.statusString = _data["StatusString"];
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(item);
            }
            this.note = _data["Note"];
            this.quantity = _data["Quantity"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.orderTotal = _data["OrderTotal"];
            this.discountTypeActive = _data["DiscountTypeActive"];
            if (Array.isArray(_data["LstPrice"])) {
                this.lstPrice = [] as any;
                for (let item of _data["LstPrice"])
                    this.lstPrice!.push(ProductPriceMapping.fromJS(item));
            }
            this.supplierId = _data["SupplierId"];
            this.supplierName = _data["SupplierName"];
            this.isPaidSupplier = _data["IsPaidSupplier"];
            this.paidSupplierDate = _data["PaidSupplierDate"] ? new Date(_data["PaidSupplierDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Color"] = this.color;
        data["Abbreviations"] = this.abbreviations;
        data["Barcode"] = this.barcode;
        data["BodyUsedId"] = this.bodyUsedId;
        data["BodyUsedString"] = this.bodyUsedString;
        data["CategoryId"] = this.categoryId;
        data["CategoryString"] = this.categoryString;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["HamLuong"] = this.hamLuong;
        data["HoatChat"] = this.hoatChat;
        data["InventoryMax"] = this.inventoryMax;
        data["InventoryMin"] = this.inventoryMin;
        data["Inventory"] = this.inventory;
        data["QtyPurchaseOrder"] = this.qtyPurchaseOrder;
        data["QtyOrder"] = this.qtyOrder;
        data["IsHomepage"] = this.isHomepage;
        data["ProductUnitId"] = this.productUnitId;
        data["ProductUnitName"] = this.productUnitName;
        data["ManufacturerId"] = this.manufacturerId;
        data["ManufacturerString"] = this.manufacturerString;
        data["NoteOrder"] = this.noteOrder;
        data["Packing"] = this.packing;
        data["PositionId"] = this.positionId;
        data["PositionString"] = this.positionString;
        data["PriceCost"] = this.priceCost;
        data["Price"] = this.price;
        data["QuocGiaId"] = this.quocGiaId;
        data["QuocGiaString"] = this.quocGiaString;
        data["RegistrationNumber"] = this.registrationNumber;
        data["Title"] = this.title;
        data["Weight"] = this.weight;
        data["Type"] = this.type;
        data["TypeString"] = this.typeString;
        data["InventoryQuantity"] = this.inventoryQuantity;
        data["OrderQuantity"] = this.orderQuantity;
        data["OutOfStockDays"] = this.outOfStockDays;
        data["Status"] = this.status;
        data["StatusString"] = this.statusString;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item);
        }
        data["Note"] = this.note;
        data["Quantity"] = this.quantity;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["OrderTotal"] = this.orderTotal;
        data["DiscountTypeActive"] = this.discountTypeActive;
        if (Array.isArray(this.lstPrice)) {
            data["LstPrice"] = [];
            for (let item of this.lstPrice)
                data["LstPrice"].push(item.toJSON());
        }
        data["SupplierId"] = this.supplierId;
        data["SupplierName"] = this.supplierName;
        data["IsPaidSupplier"] = this.isPaidSupplier;
        data["PaidSupplierDate"] = this.paidSupplierDate ? this.paidSupplierDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetListProductResponse {
    id: string;
    color?: string | undefined;
    abbreviations?: string | undefined;
    barcode?: string | undefined;
    bodyUsedId: number;
    bodyUsedString?: string | undefined;
    categoryId: number;
    categoryString?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    hamLuong?: string | undefined;
    hoatChat?: string | undefined;
    inventoryMax: number;
    inventoryMin: number;
    inventory: number;
    qtyPurchaseOrder: number;
    qtyOrder: number;
    isHomepage: boolean;
    productUnitId: number;
    productUnitName?: string | undefined;
    manufacturerId?: number | undefined;
    manufacturerString?: string | undefined;
    noteOrder?: string | undefined;
    packing?: string | undefined;
    positionId: number;
    positionString?: string | undefined;
    priceCost: number;
    price: number;
    quocGiaId: number;
    quocGiaString?: string | undefined;
    registrationNumber?: string | undefined;
    title?: string | undefined;
    weight: number;
    type: ProductEnum;
    typeString?: string | undefined;
    inventoryQuantity: number;
    orderQuantity: number;
    outOfStockDays: number;
    status: ProductStatusEnum;
    statusString?: string | undefined;
    files?: string[] | undefined;
    note?: string | undefined;
    quantity: number;
    discount: number;
    discountType: number;
    orderTotal: number;
    discountTypeActive: boolean;
    lstPrice?: ProductPriceMapping[] | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    isPaidSupplier?: boolean | undefined;
    paidSupplierDate?: Date | undefined;
}

export class GetListProductRequest implements IGetListProductRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    type?: number | undefined;
    categoryId?: number | undefined;
    keySearch?: string | undefined;
    manufacturerId?: number | undefined;
    hasInventory?: boolean | null | undefined;

    constructor(data?: IGetListProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.type = _data["Type"];
            this.categoryId = _data["CategoryId"];
            this.keySearch = _data["KeySearch"];
            this.manufacturerId = _data["ManufacturerId"];
            this.hasInventory = _data["HasInventory"];
        }
    }

    static fromJS(data: any): GetListProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["Type"] = this.type;
        data["CategoryId"] = this.categoryId;
        data["KeySearch"] = this.keySearch;
        data["ManufacturerId"] = this.manufacturerId;
        data["HasInventory"] = this.hasInventory;
        return data;
    }
}

export interface IGetListProductRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    type?: number | undefined;
    categoryId?: number | undefined;
    keySearch?: string | undefined;
    manufacturerId?: number | undefined;
    hasInventory?: boolean | null | undefined;
}

export class ProductsInfoCountResponse implements IProductsInfoCountResponse {
    priceTotal!: number;
    priceCostTotal!: number;
    inventoryTotal!: number;
    importedQuantityTotal!: number;
    soldQuantityTotal!: number;

    constructor(data?: IProductsInfoCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceTotal = _data["PriceTotal"];
            this.priceCostTotal = _data["PriceCostTotal"];
            this.inventoryTotal = _data["InventoryTotal"];
            this.importedQuantityTotal = _data["ImportedQuantityTotal"];
            this.soldQuantityTotal = _data["SoldQuantityTotal"];
        }
    }

    static fromJS(data: any): ProductsInfoCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductsInfoCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PriceTotal"] = this.priceTotal;
        data["PriceCostTotal"] = this.priceCostTotal;
        data["InventoryTotal"] = this.inventoryTotal;
        data["ImportedQuantityTotal"] = this.importedQuantityTotal;
        data["SoldQuantityTotal"] = this.soldQuantityTotal;
        return data;
    }
}

export interface IProductsInfoCountResponse {
    priceTotal: number;
    priceCostTotal: number;
    inventoryTotal: number;
    importedQuantityTotal: number;
    soldQuantityTotal: number;
}

export class PaginatorResponseOfListPurchaseOrderHistory implements IPaginatorResponseOfListPurchaseOrderHistory {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: ListPurchaseOrderHistory[] | undefined;

    constructor(data?: IPaginatorResponseOfListPurchaseOrderHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ListPurchaseOrderHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfListPurchaseOrderHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfListPurchaseOrderHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfListPurchaseOrderHistory {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: ListPurchaseOrderHistory[] | undefined;
}

export class ListPurchaseOrderHistory implements IListPurchaseOrderHistory {
    supplierName?: string | undefined;
    purchaseOrderCode?: string | undefined;
    purchaseOrderDate!: Date;
    price!: number;
    quantity!: number;
    importerName?: string | undefined;
    saleDates?: string | undefined;
    constructor(data?: IListPurchaseOrderHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierName = _data["SupplierName"];
            this.purchaseOrderCode = _data["PurchaseOrderCode"];
            this.purchaseOrderDate = _data["PurchaseOrderDate"] ? new Date(_data["PurchaseOrderDate"].toString()) : <any>undefined;
            this.price = _data["Price"];
            this.quantity = _data["Quantity"];
            this.importerName = _data["ImporterName"];
            this.saleDates = _data["SaleDates"];
        }
    }

    static fromJS(data: any): ListPurchaseOrderHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ListPurchaseOrderHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SupplierName"] = this.supplierName;
        data["PurchaseOrderCode"] = this.purchaseOrderCode;
        data["PurchaseOrderDate"] = this.purchaseOrderDate ? this.purchaseOrderDate.toISOString() : <any>undefined;
        data["Price"] = this.price;
        data["Quantity"] = this.quantity;
        data["ImporterName"] = this.importerName;
        data["SaleDates"] = this.saleDates;
        return data;
    }
}

export interface IListPurchaseOrderHistory {
    supplierName?: string | undefined;
    purchaseOrderCode?: string | undefined;
    purchaseOrderDate: Date;
    price: number;
    quantity: number;
    importerName?: string | undefined;
    saleDates?: string | undefined;
}

export class ListPurchaseOrderHistoryRequest implements IListPurchaseOrderHistoryRequest {
    productId!: string;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;

    constructor(data?: IListPurchaseOrderHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
        }
    }

    static fromJS(data: any): ListPurchaseOrderHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListPurchaseOrderHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        return data;
    }
}

export interface IListPurchaseOrderHistoryRequest {
    productId: string;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
}

// ---- ListSaleDateHistory ----

export class ListSaleDateHistoryRequest implements IListSaleDateHistoryRequest {
    productId!: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;

    constructor(data?: IListSaleDateHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : <any>undefined;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
        }
    }

    static fromJS(data: any): ListSaleDateHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListSaleDateHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        return data;
    }
}

export interface IListSaleDateHistoryRequest {
    productId: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
}

export class ListSaleDateHistoryResponse implements IListSaleDateHistoryResponse {
    orderCode?: string | undefined;
    orderTime!: Date;
    customerName?: string | undefined;
    sellerName?: string | undefined;
    quantity!: number;
    unitPrice!: number;
    totalAmount!: number;

    constructor(data?: IListSaleDateHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["OrderCode"];
            this.orderTime = _data["OrderTime"] ? new Date(_data["OrderTime"].toString()) : <any>undefined;
            this.customerName = _data["CustomerName"];
            this.sellerName = _data["SellerName"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.totalAmount = _data["TotalAmount"];
        }
    }

    static fromJS(data: any): ListSaleDateHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListSaleDateHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderCode"] = this.orderCode;
        data["OrderTime"] = this.orderTime ? this.orderTime.toISOString() : <any>undefined;
        data["CustomerName"] = this.customerName;
        data["SellerName"] = this.sellerName;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["TotalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IListSaleDateHistoryResponse {
    orderCode?: string | undefined;
    orderTime: Date;
    customerName?: string | undefined;
    sellerName?: string | undefined;
    quantity: number;
    unitPrice: number;
    totalAmount: number;
}

export class PaginatorResponseOfListSaleDateHistoryResponse implements IPaginatorResponseOfListSaleDateHistoryResponse {
    count!: number;
    items?: ListSaleDateHistoryResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfListSaleDateHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ListSaleDateHistoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfListSaleDateHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfListSaleDateHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfListSaleDateHistoryResponse {
    count: number;
    items?: ListSaleDateHistoryResponse[] | undefined;
}

export class ListProductByCategoryRequest implements IListProductByCategoryRequest {
    categoryId?: number | undefined;
    lstProductId?: string[] | undefined;
    purchaserOrderId?: string | undefined;
    isDeleted?: boolean | undefined;

    constructor(data?: IListProductByCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            if (Array.isArray(_data["lstProductId"])) {
                this.lstProductId = [] as any;
                for (let item of _data["lstProductId"])
                    this.lstProductId!.push(item);
            }
            this.purchaserOrderId = _data["PurchaserOrderId"];
            this.isDeleted = _data["IsDeleted"];
        }
    }

    static fromJS(data: any): ListProductByCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductByCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        if (Array.isArray(this.lstProductId)) {
            data["lstProductId"] = [];
            for (let item of this.lstProductId)
                data["lstProductId"].push(item);
        }
        data["PurchaserOrderId"] = this.purchaserOrderId;
        data["IsDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IListProductByCategoryRequest {
    categoryId?: number | undefined;
    lstProductId?: string[] | undefined;
    purchaserOrderId?: string | undefined;
    isDeleted?: boolean | undefined;
}

export class ProductRequest implements IProductRequest {
    id?: string | undefined;
    abbreviations?: string | undefined;
    barcode?: string | undefined;
    bodyUsedId!: number;
    categoryId!: number;
    code?: string | undefined;
    description?: string | undefined;
    hamLuong?: string | undefined;
    hoatChat?: string | undefined;
    inventoryMax!: number;
    inventoryMin!: number;
    inventory!: number;
    isHomepage!: boolean;
    manufacturerId?: number | undefined;
    noteOrder?: string | undefined;
    packing?: string | undefined;
    positionId!: number;
    priceCost!: number;
    price!: number;
    quocGiaId!: number;
    registrationNumber?: string | undefined;
    title?: string | undefined;
    weight!: number;
    lstImage?: string[] | undefined;
    type!: number;
    productUnitId!: number;
    lstPrice?: ProductPriceMapping[] | undefined;

    constructor(data?: IProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.abbreviations = _data["Abbreviations"];
            this.barcode = _data["Barcode"];
            this.bodyUsedId = _data["BodyUsedId"];
            this.categoryId = _data["CategoryId"];
            this.code = _data["Code"];
            this.description = _data["Description"];
            this.hamLuong = _data["HamLuong"];
            this.hoatChat = _data["HoatChat"];
            this.inventoryMax = _data["InventoryMax"];
            this.inventoryMin = _data["InventoryMin"];
            this.inventory = _data["Inventory"];
            this.isHomepage = _data["IsHomepage"];
            this.manufacturerId = _data["ManufacturerId"];
            this.noteOrder = _data["NoteOrder"];
            this.packing = _data["Packing"];
            this.positionId = _data["PositionId"];
            this.priceCost = _data["PriceCost"];
            this.price = _data["Price"];
            this.quocGiaId = _data["QuocGiaId"];
            this.registrationNumber = _data["RegistrationNumber"];
            this.title = _data["Title"];
            this.weight = _data["Weight"];
            if (Array.isArray(_data["lstImage"])) {
                this.lstImage = [] as any;
                for (let item of _data["lstImage"])
                    this.lstImage!.push(item);
            }
            this.type = _data["Type"];
            this.productUnitId = _data["ProductUnitId"];
            if (Array.isArray(_data["LstPrice"])) {
                this.lstPrice = [] as any;
                for (let item of _data["LstPrice"])
                    this.lstPrice!.push(ProductPriceMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Abbreviations"] = this.abbreviations;
        data["Barcode"] = this.barcode;
        data["BodyUsedId"] = this.bodyUsedId;
        data["CategoryId"] = this.categoryId;
        data["Code"] = this.code;
        data["Description"] = this.description;
        data["HamLuong"] = this.hamLuong;
        data["HoatChat"] = this.hoatChat;
        data["InventoryMax"] = this.inventoryMax;
        data["InventoryMin"] = this.inventoryMin;
        data["Inventory"] = this.inventory;
        data["IsHomepage"] = this.isHomepage;
        data["ManufacturerId"] = this.manufacturerId;
        data["NoteOrder"] = this.noteOrder;
        data["Packing"] = this.packing;
        data["PositionId"] = this.positionId;
        data["PriceCost"] = this.priceCost;
        data["Price"] = this.price;
        data["QuocGiaId"] = this.quocGiaId;
        data["RegistrationNumber"] = this.registrationNumber;
        data["Title"] = this.title;
        data["Weight"] = this.weight;
        if (Array.isArray(this.lstImage)) {
            data["lstImage"] = [];
            for (let item of this.lstImage)
                data["lstImage"].push(item);
        }
        data["Type"] = this.type;
        data["ProductUnitId"] = this.productUnitId;
        if (Array.isArray(this.lstPrice)) {
            data["LstPrice"] = [];
            for (let item of this.lstPrice)
                data["LstPrice"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductRequest {
    id?: string | undefined;
    abbreviations?: string | undefined;
    barcode?: string | undefined;
    bodyUsedId: number;
    categoryId: number;
    code?: string | undefined;
    description?: string | undefined;
    hamLuong?: string | undefined;
    hoatChat?: string | undefined;
    inventoryMax: number;
    inventoryMin: number;
    inventory: number;
    isHomepage: boolean;
    manufacturerId?: number | undefined;
    noteOrder?: string | undefined;
    packing?: string | undefined;
    positionId: number;
    priceCost: number;
    price: number;
    quocGiaId: number;
    registrationNumber?: string | undefined;
    title?: string | undefined;
    weight: number;
    lstImage?: string[] | undefined;
    type: number;
    productUnitId: number;
    lstPrice?: ProductPriceMapping[] | undefined;
}

export class PaginatorResponseOfGetListProductPickupResponse implements IPaginatorResponseOfGetListProductPickupResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: GetListProductPickupResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfGetListProductPickupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(GetListProductPickupResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfGetListProductPickupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfGetListProductPickupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfGetListProductPickupResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: GetListProductPickupResponse[] | undefined;
}

export class GetListProductPickupResponse implements IGetListProductPickupResponse {
    id!: string;
    date?: Date | undefined;
    personPickup?: string | undefined;
    cashGiven!: number;
    cashInReturn!: number;
    createdTime!: Date;
    updatedTime?: Date | undefined;
    deletedTime?: Date | undefined;
    createdId!: string;
    updatedId?: string | undefined;
    deletedId?: string | undefined;
    note?: string | undefined;
    totalProduct!: number;
    totalOrder!: number;
    amountNote!: number;
    supplierId!: number;
    remainingDebt?: string | undefined;
    status!: number;
    paymentDate?: Date | undefined;
    debtAmount!: number;
    supplierName?: string | undefined;
    productId?: string | undefined;

    constructor(data?: IGetListProductPickupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.personPickup = _data["PersonPickup"];
            this.cashGiven = _data["CashGiven"];
            this.cashInReturn = _data["CashInReturn"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.updatedTime = _data["UpdatedTime"] ? new Date(_data["UpdatedTime"].toString()) : <any>undefined;
            this.deletedTime = _data["DeletedTime"] ? new Date(_data["DeletedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.updatedId = _data["UpdatedId"];
            this.deletedId = _data["DeletedId"];
            this.note = _data["Note"];
            this.totalProduct = _data["TotalProduct"];
            this.totalOrder = _data["TotalOrder"];
            this.amountNote = _data["AmountNote"];
            this.supplierId = _data["SupplierId"];
            this.remainingDebt = _data["RemainingDebt"];
            this.status = _data["Status"];
            this.paymentDate = _data["PaymentDate"] ? new Date(_data["PaymentDate"].toString()) : <any>undefined;
            this.debtAmount = _data["DebtAmount"];
            this.supplierName = _data["SupplierName"];
            this.productId = _data["ProductId"];
        }
    }

    static fromJS(data: any): GetListProductPickupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListProductPickupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["PersonPickup"] = this.personPickup;
        data["CashGiven"] = this.cashGiven;
        data["CashInReturn"] = this.cashInReturn;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["UpdatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
        data["DeletedTime"] = this.deletedTime ? this.deletedTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["UpdatedId"] = this.updatedId;
        data["DeletedId"] = this.deletedId;
        data["Note"] = this.note;
        data["TotalProduct"] = this.totalProduct;
        data["TotalOrder"] = this.totalOrder;
        data["AmountNote"] = this.amountNote;
        data["SupplierId"] = this.supplierId;
        data["RemainingDebt"] = this.remainingDebt;
        data["Status"] = this.status;
        data["PaymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["DebtAmount"] = this.debtAmount;
        data["SupplierName"] = this.supplierName;
        data["ProductId"] = this.productId;
        return data;
    }
}

export interface IGetListProductPickupResponse {
    id: string;
    date?: Date | undefined;
    personPickup?: string | undefined;
    cashGiven: number;
    cashInReturn: number;
    createdTime: Date;
    updatedTime?: Date | undefined;
    deletedTime?: Date | undefined;
    createdId: string;
    updatedId?: string | undefined;
    deletedId?: string | undefined;
    note?: string | undefined;
    totalProduct: number;
    totalOrder: number;
    amountNote: number;
    supplierId: number;
    remainingDebt?: string | undefined;
    status: number;
    paymentDate?: Date | undefined;
    debtAmount: number;
    supplierName?: string | undefined;
    productId?: string | undefined;
}

export class GetListProductPickupRequest implements IGetListProductPickupRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    keySearch?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    cashFlowNegative?: number | undefined;
    status?: number | undefined;
    paymentDateFrom?: Date | undefined;
    paymentDateTo?: Date | undefined;
    supplierId?: number | undefined;
    productId?: string | undefined;
    isUnpaidSupplier?: boolean | undefined;

    constructor(data?: IGetListProductPickupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.keySearch = _data["KeySearch"];
            this.from = _data["From"] ? new Date(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? new Date(_data["To"].toString()) : <any>undefined;
            this.cashFlowNegative = _data["CashFlowNegative"];
            this.status = _data["Status"];
            this.paymentDateFrom = _data["PaymentDateFrom"] ? new Date(_data["PaymentDateFrom"].toString()) : <any>undefined;
            this.paymentDateTo = _data["PaymentDateTo"] ? new Date(_data["PaymentDateTo"].toString()) : <any>undefined;
            this.supplierId = _data["SupplierId"];
            this.productId = _data["ProductId"];
            this.isUnpaidSupplier = _data["IsUnpaidSupplier"];
        }
    }

    static fromJS(data: any): GetListProductPickupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListProductPickupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["KeySearch"] = this.keySearch;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["CashFlowNegative"] = this.cashFlowNegative;
        data["Status"] = this.status;
        data["PaymentDateFrom"] = this.paymentDateFrom ? this.paymentDateFrom.toISOString() : <any>undefined;
        data["PaymentDateTo"] = this.paymentDateTo ? this.paymentDateTo.toISOString() : <any>undefined;
        data["SupplierId"] = this.supplierId;
        data["ProductId"] = this.productId;
        data["IsUnpaidSupplier"] = this.isUnpaidSupplier;
        return data;
    }
}

export interface IGetListProductPickupRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    keySearch?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    cashFlowNegative?: number | undefined;
    status?: number | undefined;
    paymentDateFrom?: Date | undefined;
    paymentDateTo?: Date | undefined;
    supplierId?: number | undefined;
    productId?: string | undefined;
    isUnpaidSupplier?: boolean | undefined;
}

export class ProductPickupDto implements IProductPickupDto {
    id!: string;
    date?: Date | undefined;
    createdTime!: Date;
    updatedTime?: Date | undefined;
    deletedTime?: Date | undefined;
    createdId!: string;
    updatedId?: string | undefined;
    deletedId?: string | undefined;
    supplierId!: number;
    productPickupMappings?: CreateProductPickupMappingRequest[] | undefined;
    personPickup?: string | undefined;
    cashGiven!: number;
    cashInReturn!: number;
    note?: string | undefined;
    totalProduct!: number;
    remainingDebt?: string | undefined;
    totalOrder!: number;
    debtAmount!: number;
    amountNote!: number;
    status!: number;

    constructor(data?: IProductPickupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.updatedTime = _data["UpdatedTime"] ? new Date(_data["UpdatedTime"].toString()) : <any>undefined;
            this.deletedTime = _data["DeletedTime"] ? new Date(_data["DeletedTime"].toString()) : <any>undefined;
            this.createdId = _data["CreatedId"];
            this.updatedId = _data["UpdatedId"];
            this.deletedId = _data["DeletedId"];
            this.supplierId = _data["SupplierId"];
            if (Array.isArray(_data["ProductPickupMappings"])) {
                this.productPickupMappings = [] as any;
                for (let item of _data["ProductPickupMappings"])
                    this.productPickupMappings!.push(CreateProductPickupMappingRequest.fromJS(item));
            }
            this.personPickup = _data["PersonPickup"];
            this.cashGiven = _data["CashGiven"];
            this.cashInReturn = _data["CashInReturn"];
            this.note = _data["Note"];
            this.totalProduct = _data["TotalProduct"];
            this.remainingDebt = _data["RemainingDebt"];
            this.totalOrder = _data["TotalOrder"];
            this.debtAmount = _data["DebtAmount"];
            this.amountNote = _data["AmountNote"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): ProductPickupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPickupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["UpdatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
        data["DeletedTime"] = this.deletedTime ? this.deletedTime.toISOString() : <any>undefined;
        data["CreatedId"] = this.createdId;
        data["UpdatedId"] = this.updatedId;
        data["DeletedId"] = this.deletedId;
        data["SupplierId"] = this.supplierId;
        if (Array.isArray(this.productPickupMappings)) {
            data["ProductPickupMappings"] = [];
            for (let item of this.productPickupMappings)
                data["ProductPickupMappings"].push(item.toJSON());
        }
        data["PersonPickup"] = this.personPickup;
        data["CashGiven"] = this.cashGiven;
        data["CashInReturn"] = this.cashInReturn;
        data["Note"] = this.note;
        data["TotalProduct"] = this.totalProduct;
        data["RemainingDebt"] = this.remainingDebt;
        data["TotalOrder"] = this.totalOrder;
        data["DebtAmount"] = this.debtAmount;
        data["AmountNote"] = this.amountNote;
        data["Status"] = this.status;
        return data;
    }
}

export interface IProductPickupDto {
    id: string;
    date?: Date | undefined;
    createdTime: Date;
    updatedTime?: Date | undefined;
    deletedTime?: Date | undefined;
    createdId: string;
    updatedId?: string | undefined;
    deletedId?: string | undefined;
    supplierId: number;
    productPickupMappings?: CreateProductPickupMappingRequest[] | undefined;
    personPickup?: string | undefined;
    cashGiven: number;
    cashInReturn: number;
    note?: string | undefined;
    totalProduct: number;
    remainingDebt?: string | undefined;
    totalOrder: number;
    debtAmount: number;
    amountNote: number;
    status: number;
}

export class CreateProductPickupMappingRequest implements ICreateProductPickupMappingRequest {
    id?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    productUnitMapping!: number;
    unitPrice!: number;
    unitPriceExpect!: number;
    quantity!: number;
    totalPrice!: number;
    note?: string | undefined;
    productUnitName?: string | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;

    constructor(data?: ICreateProductPickupMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.productId = _data["ProductId"];
            this.productName = _data["ProductName"];
            this.productUnitMapping = _data["ProductUnitMapping"];
            this.unitPrice = _data["UnitPrice"];
            this.unitPriceExpect = _data["UnitPriceExpect"];
            this.quantity = _data["Quantity"];
            this.totalPrice = _data["TotalPrice"];
            this.note = _data["Note"];
            this.productUnitName = _data["ProductUnitName"];
            this.supplierId = _data["SupplierId"];
            this.supplierName = _data["SupplierName"];
        }
    }

    static fromJS(data: any): CreateProductPickupMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductPickupMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ProductId"] = this.productId;
        data["ProductName"] = this.productName;
        data["ProductUnitMapping"] = this.productUnitMapping;
        data["UnitPrice"] = this.unitPrice;
        data["UnitPriceExpect"] = this.unitPriceExpect;
        data["Quantity"] = this.quantity;
        data["TotalPrice"] = this.totalPrice;
        data["Note"] = this.note;
        data["ProductUnitName"] = this.productUnitName;
        data["SupplierId"] = this.supplierId;
        data["SupplierName"] = this.supplierName;
        return data;
    }
}

export interface ICreateProductPickupMappingRequest {
    id?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    productUnitMapping: number;
    unitPrice: number;
    unitPriceExpect: number;
    quantity: number;
    totalPrice: number;
    note?: string | undefined;
    productUnitName?: string | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
}

export class QuickUpdateProductPickupRequest implements IQuickUpdateProductPickupRequest {
    id!: string;
    note?: string | undefined;
    remainingDebt?: string | undefined;
    amountNote!: number;
    debtAmount!: number;
    mappingRequests?: QuickUpdateProductPickupMappingRequest[] | undefined;

    constructor(data?: IQuickUpdateProductPickupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.note = _data["Note"];
            this.remainingDebt = _data["RemainingDebt"];
            this.amountNote = _data["AmountNote"];
            this.debtAmount = _data["DebtAmount"];
            if (Array.isArray(_data["MappingRequests"])) {
                this.mappingRequests = [] as any;
                for (let item of _data["MappingRequests"])
                    this.mappingRequests!.push(QuickUpdateProductPickupMappingRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuickUpdateProductPickupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuickUpdateProductPickupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Note"] = this.note;
        data["RemainingDebt"] = this.remainingDebt;
        data["AmountNote"] = this.amountNote;
        data["DebtAmount"] = this.debtAmount;
        if (Array.isArray(this.mappingRequests)) {
            data["MappingRequests"] = [];
            for (let item of this.mappingRequests)
                data["MappingRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuickUpdateProductPickupRequest {
    id: string;
    note?: string | undefined;
    remainingDebt?: string | undefined;
    amountNote: number;
    debtAmount: number;
    mappingRequests?: QuickUpdateProductPickupMappingRequest[] | undefined;
}

export class QuickUpdateProductPickupMappingRequest implements IQuickUpdateProductPickupMappingRequest {
    id!: string;
    supplierId?: number | undefined;

    constructor(data?: IQuickUpdateProductPickupMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.supplierId = _data["SupplierId"];
        }
    }

    static fromJS(data: any): QuickUpdateProductPickupMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuickUpdateProductPickupMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SupplierId"] = this.supplierId;
        return data;
    }
}

export interface IQuickUpdateProductPickupMappingRequest {
    id: string;
    supplierId?: number | undefined;
}

export class CreateProductPickupRequest implements ICreateProductPickupRequest {
    id?: string | undefined;
    date!: Date;
    personPickup?: string | undefined;
    cashGiven!: number;
    cashInReturn!: number;
    note?: string | undefined;
    totalProduct!: number;
    remainingDebt?: string | undefined;
    totalOrder!: number;
    amountNote!: number;
    supplierId!: number;
    debtAmount!: number;
    status!: number;
    createProductPickupMappingRequests?: CreateProductPickupMappingRequest[] | undefined;

    constructor(data?: ICreateProductPickupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.personPickup = _data["PersonPickup"];
            this.cashGiven = _data["CashGiven"];
            this.cashInReturn = _data["CashInReturn"];
            this.note = _data["Note"];
            this.totalProduct = _data["TotalProduct"];
            this.remainingDebt = _data["RemainingDebt"];
            this.totalOrder = _data["TotalOrder"];
            this.amountNote = _data["AmountNote"];
            this.supplierId = _data["SupplierId"];
            this.debtAmount = _data["DebtAmount"];
            this.status = _data["Status"];
            if (Array.isArray(_data["CreateProductPickupMappingRequests"])) {
                this.createProductPickupMappingRequests = [] as any;
                for (let item of _data["CreateProductPickupMappingRequests"])
                    this.createProductPickupMappingRequests!.push(CreateProductPickupMappingRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProductPickupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductPickupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["PersonPickup"] = this.personPickup;
        data["CashGiven"] = this.cashGiven;
        data["CashInReturn"] = this.cashInReturn;
        data["Note"] = this.note;
        data["TotalProduct"] = this.totalProduct;
        data["RemainingDebt"] = this.remainingDebt;
        data["TotalOrder"] = this.totalOrder;
        data["AmountNote"] = this.amountNote;
        data["SupplierId"] = this.supplierId;
        data["DebtAmount"] = this.debtAmount;
        data["Status"] = this.status;
        if (Array.isArray(this.createProductPickupMappingRequests)) {
            data["CreateProductPickupMappingRequests"] = [];
            for (let item of this.createProductPickupMappingRequests)
                data["CreateProductPickupMappingRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateProductPickupRequest {
    id?: string | undefined;
    date: Date;
    personPickup?: string | undefined;
    cashGiven: number;
    cashInReturn: number;
    note?: string | undefined;
    totalProduct: number;
    remainingDebt?: string | undefined;
    totalOrder: number;
    amountNote: number;
    supplierId: number;
    debtAmount: number;
    status: number;
    createProductPickupMappingRequests?: CreateProductPickupMappingRequest[] | undefined;
}

export class SupplierPaymentDto implements ISupplierPaymentDto {
    id!: string;
    supplierId!: number;
    supplierName?: string | undefined;
    amount!: number;
    isPaid!: boolean;
    paidDate?: Date | undefined;
    mappingCount!: number;

    constructor(data?: ISupplierPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.supplierId = _data["SupplierId"];
            this.supplierName = _data["SupplierName"];
            this.amount = _data["Amount"];
            this.isPaid = _data["IsPaid"];
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : <any>undefined;
            this.mappingCount = _data["MappingCount"];
        }
    }

    static fromJS(data: any): SupplierPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SupplierId"] = this.supplierId;
        data["SupplierName"] = this.supplierName;
        data["Amount"] = this.amount;
        data["IsPaid"] = this.isPaid;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["MappingCount"] = this.mappingCount;
        return data;
    }
}

export interface ISupplierPaymentDto {
    id: string;
    supplierId: number;
    supplierName?: string | undefined;
    amount: number;
    isPaid: boolean;
    paidDate?: Date | undefined;
    mappingCount: number;
}

export class UpdateSupplierPaymentRequest implements IUpdateSupplierPaymentRequest {
    id!: string;
    isPaid!: boolean;
    paidDate?: Date | undefined;
    amount?: number | undefined;

    constructor(data?: IUpdateSupplierPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.isPaid = _data["IsPaid"];
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
        }
    }

    static fromJS(data: any): UpdateSupplierPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupplierPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["IsPaid"] = this.isPaid;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        return data;
    }
}

export interface IUpdateSupplierPaymentRequest {
    id: string;
    isPaid: boolean;
    paidDate?: Date | undefined;
    amount?: number | undefined;
}

export class ProductUnitDto implements IProductUnitDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IProductUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): ProductUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IProductUnitDto {
    id: number;
    name?: string | undefined;
}

export class PaginatorResponseOfListPurchaseOrderResponse implements IPaginatorResponseOfListPurchaseOrderResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: ListPurchaseOrderResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfListPurchaseOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ListPurchaseOrderResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfListPurchaseOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfListPurchaseOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfListPurchaseOrderResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: ListPurchaseOrderResponse[] | undefined;
}

export class ListPurchaseOrderResponse implements IListPurchaseOrderResponse {
    code?: string | undefined;
    createdId!: string;
    createdTime!: Date;
    status!: PurchaseOrderStatusEnum;
    statusStr?: string | undefined;
    totalOrder!: number;
    note?: string | undefined;
    discount?: number | undefined;
    discountType?: number | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    debt?: number | undefined;
    payingAmount!: number;
    remainingDebt!: number;
    purchaseOrderDateTime!: Date;
    id!: string;
    importerId!: string;
    updatedId?: string | undefined;
    updatedTime?: Date | undefined;
    productIds?: string[] | undefined;
    paymentType!: number;
    purchaseOrderItemDtos?: PurchaseOrderItemDto[] | undefined;

    constructor(data?: IListPurchaseOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.createdId = _data["CreatedId"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.statusStr = _data["StatusStr"];
            this.totalOrder = _data["TotalOrder"];
            this.note = _data["Note"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.supplierId = _data["SupplierId"];
            this.supplierName = _data["SupplierName"];
            this.debt = _data["Debt"];
            this.payingAmount = _data["PayingAmount"];
            this.remainingDebt = _data["RemainingDebt"];
            this.purchaseOrderDateTime = _data["PurchaseOrderDateTime"] ? new Date(_data["PurchaseOrderDateTime"].toString()) : <any>undefined;
            this.id = _data["Id"];
            this.importerId = _data["ImporterId"];
            this.updatedId = _data["UpdatedId"];
            this.updatedTime = _data["UpdatedTime"] ? new Date(_data["UpdatedTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["ProductIds"])) {
                this.productIds = [] as any;
                for (let item of _data["ProductIds"])
                    this.productIds!.push(item);
            }
            this.paymentType = _data["PaymentType"];
            if (Array.isArray(_data["PurchaseOrderItemDtos"])) {
                this.purchaseOrderItemDtos = [] as any;
                for (let item of _data["PurchaseOrderItemDtos"])
                    this.purchaseOrderItemDtos!.push(PurchaseOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListPurchaseOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListPurchaseOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["CreatedId"] = this.createdId;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["StatusStr"] = this.statusStr;
        data["TotalOrder"] = this.totalOrder;
        data["Note"] = this.note;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["SupplierId"] = this.supplierId;
        data["SupplierName"] = this.supplierName;
        data["Debt"] = this.debt;
        data["PayingAmount"] = this.payingAmount;
        data["RemainingDebt"] = this.remainingDebt;
        data["PurchaseOrderDateTime"] = this.purchaseOrderDateTime ? this.purchaseOrderDateTime.toISOString() : <any>undefined;
        data["Id"] = this.id;
        data["ImporterId"] = this.importerId;
        data["UpdatedId"] = this.updatedId;
        data["UpdatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
        if (Array.isArray(this.productIds)) {
            data["ProductIds"] = [];
            for (let item of this.productIds)
                data["ProductIds"].push(item);
        }
        data["PaymentType"] = this.paymentType;
        if (Array.isArray(this.purchaseOrderItemDtos)) {
            data["PurchaseOrderItemDtos"] = [];
            for (let item of this.purchaseOrderItemDtos)
                data["PurchaseOrderItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListPurchaseOrderResponse {
    code?: string | undefined;
    createdId: string;
    createdTime: Date;
    status: PurchaseOrderStatusEnum;
    statusStr?: string | undefined;
    totalOrder: number;
    note?: string | undefined;
    discount?: number | undefined;
    discountType?: number | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    debt?: number | undefined;
    payingAmount: number;
    remainingDebt: number;
    purchaseOrderDateTime: Date;
    id: string;
    importerId: string;
    updatedId?: string | undefined;
    updatedTime?: Date | undefined;
    productIds?: string[] | undefined;
    paymentType: number;
    purchaseOrderItemDtos?: PurchaseOrderItemDto[] | undefined;
}

export class PurchaseOrderItemDto implements IPurchaseOrderItemDto {
    id!: number;
    productId!: string;
    quantity!: number;
    unitPrice!: number;
    discount!: number;
    discountType!: number;
    totalPrice!: number;
    note?: string | undefined;
    purchaseOrderId!: string;
    productCode?: string | undefined;
    productName?: string | undefined;
    supplierName?: string | undefined;

    constructor(data?: IPurchaseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.productId = _data["ProductId"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.totalPrice = _data["TotalPrice"];
            this.note = _data["Note"];
            this.purchaseOrderId = _data["PurchaseOrderId"];
            this.productCode = _data["ProductCode"];
            this.productName = _data["ProductName"];
            this.supplierName = _data["SupplierName"];
        }
    }

    static fromJS(data: any): PurchaseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ProductId"] = this.productId;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["TotalPrice"] = this.totalPrice;
        data["Note"] = this.note;
        data["PurchaseOrderId"] = this.purchaseOrderId;
        data["ProductCode"] = this.productCode;
        data["ProductName"] = this.productName;
        data["SupplierName"] = this.supplierName;
        return data;
    }
}

export interface IPurchaseOrderItemDto {
    id: number;
    productId: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    discountType: number;
    totalPrice: number;
    note?: string | undefined;
    purchaseOrderId: string;
    productCode?: string | undefined;
    productName?: string | undefined;
    supplierName?: string | undefined;
}

export class SearchPurchaseOrderRequest implements ISearchPurchaseOrderRequest {
    from?: Date | undefined;
    to?: Date | undefined;
    status?: number | undefined;
    createdId?: string | undefined;
    importerId?: string | undefined;
    supplierId?: number | undefined;
    keySearch?: string | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    productId?: string | undefined;
    unpaidSuppliers!: boolean;
    isSearchError!: boolean;

    constructor(data?: ISearchPurchaseOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["From"] ? new Date(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? new Date(_data["To"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.createdId = _data["CreatedId"];
            this.importerId = _data["ImporterId"];
            this.supplierId = _data["SupplierId"];
            this.keySearch = _data["KeySearch"];
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.productId = _data["ProductId"];
            this.unpaidSuppliers = _data["UnpaidSuppliers"];
            this.isSearchError = _data["IsSearchError"];
        }
    }

    static fromJS(data: any): SearchPurchaseOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPurchaseOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["CreatedId"] = this.createdId;
        data["ImporterId"] = this.importerId;
        data["SupplierId"] = this.supplierId;
        data["KeySearch"] = this.keySearch;
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["ProductId"] = this.productId;
        data["UnpaidSuppliers"] = this.unpaidSuppliers;
        data["IsSearchError"] = this.isSearchError;
        return data;
    }
}

export interface ISearchPurchaseOrderRequest {
    from?: Date | undefined;
    to?: Date | undefined;
    status?: number | undefined;
    createdId?: string | undefined;
    importerId?: string | undefined;
    supplierId?: number | undefined;
    keySearch?: string | undefined;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    productId?: string | undefined;
    unpaidSuppliers: boolean;
    isSearchError: boolean;
}

export class PaginatorResponseOfPurchaseOrderItemDto implements IPaginatorResponseOfPurchaseOrderItemDto {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: PurchaseOrderItemDto[] | undefined;

    constructor(data?: IPaginatorResponseOfPurchaseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PurchaseOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfPurchaseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfPurchaseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfPurchaseOrderItemDto {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: PurchaseOrderItemDto[] | undefined;
}

export class SearchPurchaseOrderItemsRequest implements ISearchPurchaseOrderItemsRequest {
    code?: string | undefined;
    name?: string | undefined;
    purchaserOrderId!: string;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;

    constructor(data?: ISearchPurchaseOrderItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.purchaserOrderId = _data["PurchaserOrderId"];
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
        }
    }

    static fromJS(data: any): SearchPurchaseOrderItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPurchaseOrderItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["PurchaserOrderId"] = this.purchaserOrderId;
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        return data;
    }
}

export interface ISearchPurchaseOrderItemsRequest {
    code?: string | undefined;
    name?: string | undefined;
    purchaserOrderId: string;
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
}

export class PurchaseOrderDto implements IPurchaseOrderDto {
    code?: string | undefined;
    createdId!: string;
    createdTime!: Date;
    status!: PurchaseOrderStatusEnum;
    statusStr?: string | undefined;
    totalOrder!: number;
    note?: string | undefined;
    discount!: number;
    discountType!: number;
    supplierId!: number;
    totalQuantity!: number;
    totalDiscount!: number;
    supplierName?: string | undefined;
    payingAmount!: number;
    remainingDebt!: number;
    purchaseOrderDateTime!: Date;
    id!: string;
    importerId!: string;
    updatedId!: string;
    updatedTime!: Date;
    totalProduct!: number;
    paymentType!: number;

    constructor(data?: IPurchaseOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.createdId = _data["CreatedId"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.statusStr = _data["StatusStr"];
            this.totalOrder = _data["TotalOrder"];
            this.note = _data["Note"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.supplierId = _data["SupplierId"];
            this.totalQuantity = _data["TotalQuantity"];
            this.totalDiscount = _data["TotalDiscount"];
            this.supplierName = _data["SupplierName"];
            this.payingAmount = _data["PayingAmount"];
            this.remainingDebt = _data["RemainingDebt"];
            this.purchaseOrderDateTime = _data["PurchaseOrderDateTime"] ? new Date(_data["PurchaseOrderDateTime"].toString()) : <any>undefined;
            this.id = _data["Id"];
            this.importerId = _data["ImporterId"];
            this.updatedId = _data["UpdatedId"];
            this.updatedTime = _data["UpdatedTime"] ? new Date(_data["UpdatedTime"].toString()) : <any>undefined;
            this.totalProduct = _data["TotalProduct"];
            this.paymentType = _data["PaymentType"];
        }
    }

    static fromJS(data: any): PurchaseOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["CreatedId"] = this.createdId;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["StatusStr"] = this.statusStr;
        data["TotalOrder"] = this.totalOrder;
        data["Note"] = this.note;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["SupplierId"] = this.supplierId;
        data["TotalQuantity"] = this.totalQuantity;
        data["TotalDiscount"] = this.totalDiscount;
        data["SupplierName"] = this.supplierName;
        data["PayingAmount"] = this.payingAmount;
        data["RemainingDebt"] = this.remainingDebt;
        data["PurchaseOrderDateTime"] = this.purchaseOrderDateTime ? this.purchaseOrderDateTime.toISOString() : <any>undefined;
        data["Id"] = this.id;
        data["ImporterId"] = this.importerId;
        data["UpdatedId"] = this.updatedId;
        data["UpdatedTime"] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
        data["TotalProduct"] = this.totalProduct;
        data["PaymentType"] = this.paymentType;
        return data;
    }
}

export interface IPurchaseOrderDto {
    code?: string | undefined;
    createdId: string;
    createdTime: Date;
    status: PurchaseOrderStatusEnum;
    statusStr?: string | undefined;
    totalOrder: number;
    note?: string | undefined;
    discount: number;
    discountType: number;
    supplierId: number;
    totalQuantity: number;
    totalDiscount: number;
    supplierName?: string | undefined;
    payingAmount: number;
    remainingDebt: number;
    purchaseOrderDateTime: Date;
    id: string;
    importerId: string;
    updatedId: string;
    updatedTime: Date;
    totalProduct: number;
    paymentType: number;
}

export class CreatePurchaseOrderRequest implements ICreatePurchaseOrderRequest {
    id?: string | undefined;
    purchaseOrderItems?: PurchaseOrderItem[] | undefined;
    note?: string | undefined;
    purchaseOrderDateTime!: Date;
    payingAmount!: number;
    totalOrder!: number;
    discount!: number;
    discountType!: DiscountTypeEnum;
    status!: PurchaseOrderStatusEnum;
    paymentTime!: Date;
    paymentNote?: string | undefined;
    supplierId!: number;
    code?: string | undefined;
    importerId!: string;
    quantity!: number;
    paymentType!: PaymentTypeEnum;

    constructor(data?: ICreatePurchaseOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            if (Array.isArray(_data["PurchaseOrderItems"])) {
                this.purchaseOrderItems = [] as any;
                for (let item of _data["PurchaseOrderItems"])
                    this.purchaseOrderItems!.push(PurchaseOrderItem.fromJS(item));
            }
            this.note = _data["Note"];
            this.purchaseOrderDateTime = _data["PurchaseOrderDateTime"] ? new Date(_data["PurchaseOrderDateTime"].toString()) : <any>undefined;
            this.payingAmount = _data["PayingAmount"];
            this.totalOrder = _data["TotalOrder"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.status = _data["Status"];
            this.paymentTime = _data["PaymentTime"] ? new Date(_data["PaymentTime"].toString()) : <any>undefined;
            this.paymentNote = _data["PaymentNote"];
            this.supplierId = _data["SupplierId"];
            this.code = _data["Code"];
            this.importerId = _data["ImporterId"];
            this.quantity = _data["Quantity"];
            this.paymentType = _data["PaymentType"];
        }
    }

    static fromJS(data: any): CreatePurchaseOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        if (Array.isArray(this.purchaseOrderItems)) {
            data["PurchaseOrderItems"] = [];
            for (let item of this.purchaseOrderItems)
                data["PurchaseOrderItems"].push(item.toJSON());
        }
        data["Note"] = this.note;
        data["PurchaseOrderDateTime"] = this.purchaseOrderDateTime ? this.purchaseOrderDateTime.toISOString() : <any>undefined;
        data["PayingAmount"] = this.payingAmount;
        data["TotalOrder"] = this.totalOrder;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["Status"] = this.status;
        data["PaymentTime"] = this.paymentTime ? this.paymentTime.toISOString() : <any>undefined;
        data["PaymentNote"] = this.paymentNote;
        data["SupplierId"] = this.supplierId;
        data["Code"] = this.code;
        data["ImporterId"] = this.importerId;
        data["Quantity"] = this.quantity;
        data["PaymentType"] = this.paymentType;
        return data;
    }
}

export interface ICreatePurchaseOrderRequest {
    id?: string | undefined;
    purchaseOrderItems?: PurchaseOrderItem[] | undefined;
    note?: string | undefined;
    purchaseOrderDateTime: Date;
    payingAmount: number;
    totalOrder: number;
    discount: number;
    discountType: DiscountTypeEnum;
    status: PurchaseOrderStatusEnum;
    paymentTime: Date;
    paymentNote?: string | undefined;
    supplierId: number;
    code?: string | undefined;
    importerId: string;
    quantity: number;
    paymentType: PaymentTypeEnum;
}

export class PurchaseOrderItem implements IPurchaseOrderItem {
    productId!: string;
    quantity!: number;
    unitPrice!: number;
    discount!: number;
    discountType!: DiscountTypeEnum;
    purchaseOrderId!: string;
    note?: string | undefined;
    totalPrice!: number;

    constructor(data?: IPurchaseOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.quantity = _data["Quantity"];
            this.unitPrice = _data["UnitPrice"];
            this.discount = _data["Discount"];
            this.discountType = _data["DiscountType"];
            this.purchaseOrderId = _data["PurchaseOrderId"];
            this.note = _data["Note"];
            this.totalPrice = _data["TotalPrice"];
        }
    }

    static fromJS(data: any): PurchaseOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["Quantity"] = this.quantity;
        data["UnitPrice"] = this.unitPrice;
        data["Discount"] = this.discount;
        data["DiscountType"] = this.discountType;
        data["PurchaseOrderId"] = this.purchaseOrderId;
        data["Note"] = this.note;
        data["TotalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IPurchaseOrderItem {
    productId: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    discountType: DiscountTypeEnum;
    purchaseOrderId: string;
    note?: string | undefined;
    totalPrice: number;
}

export class PaymentHistoryReponse implements IPaymentHistoryReponse {
    id!: string;
    orderCustomerId?: string | undefined;
    purchaseOrderId?: string | undefined;
    amount!: number;
    paymentTime!: Date;
    paymentMethod!: number;
    note?: string | undefined;
    createdId!: string;
    createdTime!: Date;
    isDeleted!: boolean;

    constructor(data?: IPaymentHistoryReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.orderCustomerId = _data["OrderCustomerId"];
            this.purchaseOrderId = _data["PurchaseOrderId"];
            this.amount = _data["Amount"];
            this.paymentTime = _data["PaymentTime"] ? new Date(_data["PaymentTime"].toString()) : <any>undefined;
            this.paymentMethod = _data["PaymentMethod"];
            this.note = _data["Note"];
            this.createdId = _data["CreatedId"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.isDeleted = _data["IsDeleted"];
        }
    }

    static fromJS(data: any): PaymentHistoryReponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentHistoryReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["OrderCustomerId"] = this.orderCustomerId;
        data["PurchaseOrderId"] = this.purchaseOrderId;
        data["Amount"] = this.amount;
        data["PaymentTime"] = this.paymentTime ? this.paymentTime.toISOString() : <any>undefined;
        data["PaymentMethod"] = this.paymentMethod;
        data["Note"] = this.note;
        data["CreatedId"] = this.createdId;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["IsDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IPaymentHistoryReponse {
    id: string;
    orderCustomerId?: string | undefined;
    purchaseOrderId?: string | undefined;
    amount: number;
    paymentTime: Date;
    paymentMethod: number;
    note?: string | undefined;
    createdId: string;
    createdTime: Date;
    isDeleted: boolean;
}

export class UpdatePurchaseOrderNoteRequest implements IUpdatePurchaseOrderNoteRequest {
    id?: string | undefined;
    note?: string | undefined;

    constructor(data?: IUpdatePurchaseOrderNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.note = _data["Note"];
        }
    }

    static fromJS(data: any): UpdatePurchaseOrderNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Note"] = this.note;
        return data;
    }
}

export interface IUpdatePurchaseOrderNoteRequest {
    id?: string | undefined;
    note?: string | undefined;
}

export class UpdatePurchaseOrderRequest implements IUpdatePurchaseOrderRequest {
    id!: string;
    createdId!: string;
    importerId!: string;
    note?: string | undefined;
    purchaseOrderDateTime!: Date;

    constructor(data?: IUpdatePurchaseOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.createdId = _data["CreatedId"];
            this.importerId = _data["ImporterId"];
            this.note = _data["Note"];
            this.purchaseOrderDateTime = _data["PurchaseOrderDateTime"] ? new Date(_data["PurchaseOrderDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePurchaseOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedId"] = this.createdId;
        data["ImporterId"] = this.importerId;
        data["Note"] = this.note;
        data["PurchaseOrderDateTime"] = this.purchaseOrderDateTime ? this.purchaseOrderDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdatePurchaseOrderRequest {
    id: string;
    createdId: string;
    importerId: string;
    note?: string | undefined;
    purchaseOrderDateTime: Date;
}

export class PaginatorResponseOfListReceiptBookItemResponse implements IPaginatorResponseOfListReceiptBookItemResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: ListReceiptBookItemResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfListReceiptBookItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ListReceiptBookItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfListReceiptBookItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfListReceiptBookItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfListReceiptBookItemResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: ListReceiptBookItemResponse[] | undefined;
}

export class ListReceiptBookItemResponse implements IListReceiptBookItemResponse {
    receiptBookCategoryName?: string | undefined;
    receiptBookCategoryId!: string;
    note?: string | undefined;
    money!: number;
    id!: string;
    date!: Date;
    icon?: string | undefined;
    color?: string | undefined;

    constructor(data?: IListReceiptBookItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptBookCategoryName = _data["ReceiptBookCategoryName"];
            this.receiptBookCategoryId = _data["ReceiptBookCategoryId"];
            this.note = _data["Note"];
            this.money = _data["Money"];
            this.id = _data["Id"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.icon = _data["Icon"];
            this.color = _data["Color"];
        }
    }

    static fromJS(data: any): ListReceiptBookItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListReceiptBookItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReceiptBookCategoryName"] = this.receiptBookCategoryName;
        data["ReceiptBookCategoryId"] = this.receiptBookCategoryId;
        data["Note"] = this.note;
        data["Money"] = this.money;
        data["Id"] = this.id;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Icon"] = this.icon;
        data["Color"] = this.color;
        return data;
    }
}

export interface IListReceiptBookItemResponse {
    receiptBookCategoryName?: string | undefined;
    receiptBookCategoryId: string;
    note?: string | undefined;
    money: number;
    id: string;
    date: Date;
    icon?: string | undefined;
    color?: string | undefined;
}

export class ListReceiptBookItemRequest implements IListReceiptBookItemRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IListReceiptBookItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.from = _data["From"] ? new Date(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? new Date(_data["To"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListReceiptBookItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListReceiptBookItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IListReceiptBookItemRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
}

export class PaginatorResponseOfProductPickupResponse implements IPaginatorResponseOfProductPickupResponse {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: ProductPickupResponse[] | undefined;

    constructor(data?: IPaginatorResponseOfProductPickupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ProductPickupResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfProductPickupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfProductPickupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfProductPickupResponse {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: ProductPickupResponse[] | undefined;
}

export class ProductPickupResponse implements IProductPickupResponse {
    id!: string;
    name?: string | undefined;
    note?: string | undefined;
    color?: string | undefined;
    type!: number;
    icon?: string | undefined;
    money!: number;
    createdTime!: Date;

    constructor(data?: IProductPickupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.note = _data["Note"];
            this.color = _data["Color"];
            this.type = _data["Type"];
            this.icon = _data["Icon"];
            this.money = _data["Money"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductPickupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPickupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Note"] = this.note;
        data["Color"] = this.color;
        data["Type"] = this.type;
        data["Icon"] = this.icon;
        data["Money"] = this.money;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductPickupResponse {
    id: string;
    name?: string | undefined;
    note?: string | undefined;
    color?: string | undefined;
    type: number;
    icon?: string | undefined;
    money: number;
    createdTime: Date;
}

export class ListReceiptBookCategoryRequest implements IListReceiptBookCategoryRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    keySearch?: string | undefined;

    constructor(data?: IListReceiptBookCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageSize = _data["PageSize"];
            this.pageIndex = _data["PageIndex"];
            this.keySearch = _data["KeySearch"];
        }
    }

    static fromJS(data: any): ListReceiptBookCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListReceiptBookCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageSize"] = this.pageSize;
        data["PageIndex"] = this.pageIndex;
        data["KeySearch"] = this.keySearch;
        return data;
    }
}

export interface IListReceiptBookCategoryRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
    keySearch?: string | undefined;
}

export class UpdateReceiptBookItemRequest implements IUpdateReceiptBookItemRequest {
    id!: string;
    receiptBookCategoryId!: string;
    note?: string | undefined;
    money!: number;

    constructor(data?: IUpdateReceiptBookItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.receiptBookCategoryId = _data["ReceiptBookCategoryId"];
            this.note = _data["Note"];
            this.money = _data["Money"];
        }
    }

    static fromJS(data: any): UpdateReceiptBookItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReceiptBookItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ReceiptBookCategoryId"] = this.receiptBookCategoryId;
        data["Note"] = this.note;
        data["Money"] = this.money;
        return data;
    }
}

export interface IUpdateReceiptBookItemRequest {
    id: string;
    receiptBookCategoryId: string;
    note?: string | undefined;
    money: number;
}

export class ReceiptBookCategoryDto implements IReceiptBookCategoryDto {
    id!: string;
    icon?: string | undefined;
    name?: string | undefined;
    color?: string | undefined;
    type!: number;
    parentId!: number;
    money!: number;
    note?: string | undefined;

    constructor(data?: IReceiptBookCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.icon = _data["Icon"];
            this.name = _data["Name"];
            this.color = _data["Color"];
            this.type = _data["Type"];
            this.parentId = _data["ParentId"];
            this.money = _data["Money"];
            this.note = _data["Note"];
        }
    }

    static fromJS(data: any): ReceiptBookCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptBookCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Icon"] = this.icon;
        data["Name"] = this.name;
        data["Color"] = this.color;
        data["Type"] = this.type;
        data["ParentId"] = this.parentId;
        data["Money"] = this.money;
        data["Note"] = this.note;
        return data;
    }
}

export interface IReceiptBookCategoryDto {
    id: string;
    icon?: string | undefined;
    name?: string | undefined;
    color?: string | undefined;
    type: number;
    parentId: number;
    money: number;
    note?: string | undefined;
}

export class AddOrUpdateReceiptBookCategoryRequest implements IAddOrUpdateReceiptBookCategoryRequest {
    id?: string | undefined;
    icon?: string | undefined;
    name?: string | undefined;
    color?: string | undefined;
    type!: number;
    parentId!: number;
    money!: number;
    note?: string | undefined;
    createdTime?: Date | undefined;

    constructor(data?: IAddOrUpdateReceiptBookCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.icon = _data["Icon"];
            this.name = _data["Name"];
            this.color = _data["Color"];
            this.type = _data["Type"];
            this.parentId = _data["ParentId"];
            this.money = _data["Money"];
            this.note = _data["Note"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AddOrUpdateReceiptBookCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateReceiptBookCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Icon"] = this.icon;
        data["Name"] = this.name;
        data["Color"] = this.color;
        data["Type"] = this.type;
        data["ParentId"] = this.parentId;
        data["Money"] = this.money;
        data["Note"] = this.note;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAddOrUpdateReceiptBookCategoryRequest {
    id?: string | undefined;
    icon?: string | undefined;
    name?: string | undefined;
    color?: string | undefined;
    type: number;
    parentId: number;
    money: number;
    note?: string | undefined;
    createdTime?: Date | undefined;
}

export class ReceiptBookItemRequest implements IReceiptBookItemRequest {
    receiptBookCategoryId!: string;
    note?: string | undefined;
    money!: number;
    date!: Date;

    constructor(data?: IReceiptBookItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptBookCategoryId = _data["ReceiptBookCategoryId"];
            this.note = _data["Note"];
            this.money = _data["Money"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReceiptBookItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptBookItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReceiptBookCategoryId"] = this.receiptBookCategoryId;
        data["Note"] = this.note;
        data["Money"] = this.money;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReceiptBookItemRequest {
    receiptBookCategoryId: string;
    note?: string | undefined;
    money: number;
    date: Date;
}

export class SupplierDto implements ISupplierDto {
    id!: number;
    code?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    phuongXaCode?: string | undefined;
    fullAddress?: string | undefined;
    address?: string | undefined;
    branchId!: number;
    email?: string | undefined;
    company?: string | undefined;
    maSoThue?: string | undefined;
    note?: string | undefined;
    createdId!: string;
    createdTime!: Date;
    isActive!: boolean;
    debt!: number;

    constructor(data?: ISupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.phone = _data["Phone"];
            this.tinhThanhCode = _data["TinhThanhCode"];
            this.quanHuyenCode = _data["QuanHuyenCode"];
            this.phuongXaCode = _data["PhuongXaCode"];
            this.fullAddress = _data["FullAddress"];
            this.address = _data["Address"];
            this.branchId = _data["BranchId"];
            this.email = _data["Email"];
            this.company = _data["Company"];
            this.maSoThue = _data["MaSoThue"];
            this.note = _data["Note"];
            this.createdId = _data["CreatedId"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.isActive = _data["IsActive"];
            this.debt = _data["Debt"];
        }
    }

    static fromJS(data: any): SupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["Phone"] = this.phone;
        data["TinhThanhCode"] = this.tinhThanhCode;
        data["QuanHuyenCode"] = this.quanHuyenCode;
        data["PhuongXaCode"] = this.phuongXaCode;
        data["FullAddress"] = this.fullAddress;
        data["Address"] = this.address;
        data["BranchId"] = this.branchId;
        data["Email"] = this.email;
        data["Company"] = this.company;
        data["MaSoThue"] = this.maSoThue;
        data["Note"] = this.note;
        data["CreatedId"] = this.createdId;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["IsActive"] = this.isActive;
        data["Debt"] = this.debt;
        return data;
    }
}

export interface ISupplierDto {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    phuongXaCode?: string | undefined;
    fullAddress?: string | undefined;
    address?: string | undefined;
    branchId: number;
    email?: string | undefined;
    company?: string | undefined;
    maSoThue?: string | undefined;
    note?: string | undefined;
    createdId: string;
    createdTime: Date;
    isActive: boolean;
    debt: number;
}

export class PaginatorResponseOfSupplierDto implements IPaginatorResponseOfSupplierDto {
    count!: number;
    totalMoney!: number;
    payingAmount!: number;
    totalIncome!: number;
    totalSpend!: number;
    totalDebt!: number;
    totalOrderAmount!: number;
    totalPaid!: number;
    nhapHang_SoTienDaDua!: number;
    nhapHang_SoLuongSanPham!: number;
    nhapHang_TongTienSanPham!: number;
    nhapHang_HoanTien!: number;
    nhapHang_GhiChuTien!: number;
    items?: SupplierDto[] | undefined;

    constructor(data?: IPaginatorResponseOfSupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.totalMoney = _data["TotalMoney"];
            this.payingAmount = _data["PayingAmount"];
            this.totalIncome = _data["TotalIncome"];
            this.totalSpend = _data["TotalSpend"];
            this.totalDebt = _data["TotalDebt"];
            this.totalOrderAmount = _data["TotalOrderAmount"];
            this.totalPaid = _data["TotalPaid"];
            this.nhapHang_SoTienDaDua = _data["NhapHang_SoTienDaDua"];
            this.nhapHang_SoLuongSanPham = _data["NhapHang_SoLuongSanPham"];
            this.nhapHang_TongTienSanPham = _data["NhapHang_TongTienSanPham"];
            this.nhapHang_HoanTien = _data["NhapHang_HoanTien"];
            this.nhapHang_GhiChuTien = _data["NhapHang_GhiChuTien"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(SupplierDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorResponseOfSupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorResponseOfSupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TotalMoney"] = this.totalMoney;
        data["PayingAmount"] = this.payingAmount;
        data["TotalIncome"] = this.totalIncome;
        data["TotalSpend"] = this.totalSpend;
        data["TotalDebt"] = this.totalDebt;
        data["TotalOrderAmount"] = this.totalOrderAmount;
        data["TotalPaid"] = this.totalPaid;
        data["NhapHang_SoTienDaDua"] = this.nhapHang_SoTienDaDua;
        data["NhapHang_SoLuongSanPham"] = this.nhapHang_SoLuongSanPham;
        data["NhapHang_TongTienSanPham"] = this.nhapHang_TongTienSanPham;
        data["NhapHang_HoanTien"] = this.nhapHang_HoanTien;
        data["NhapHang_GhiChuTien"] = this.nhapHang_GhiChuTien;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatorResponseOfSupplierDto {
    count: number;
    totalMoney: number;
    payingAmount: number;
    totalIncome: number;
    totalSpend: number;
    totalDebt: number;
    totalOrderAmount: number;
    totalPaid: number;
    nhapHang_SoTienDaDua: number;
    nhapHang_SoLuongSanPham: number;
    nhapHang_TongTienSanPham: number;
    nhapHang_HoanTien: number;
    nhapHang_GhiChuTien: number;
    items?: SupplierDto[] | undefined;
}

export class CreateSupplierRequest implements ICreateSupplierRequest {
    id!: number;
    code?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    phuongXaCode?: string | undefined;
    address?: string | undefined;
    branchId!: number;
    email?: string | undefined;
    company?: string | undefined;
    maSoThue?: string | undefined;
    note?: string | undefined;
    isActive!: boolean;
    debt!: number;
    purchaseOrderId?: string | undefined;
    payAmount?: number | undefined;
    supplierType!: SupplierTypeEnum;

    constructor(data?: ICreateSupplierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.phone = _data["Phone"];
            this.tinhThanhCode = _data["TinhThanhCode"];
            this.quanHuyenCode = _data["QuanHuyenCode"];
            this.phuongXaCode = _data["PhuongXaCode"];
            this.address = _data["Address"];
            this.branchId = _data["BranchId"];
            this.email = _data["Email"];
            this.company = _data["Company"];
            this.maSoThue = _data["MaSoThue"];
            this.note = _data["Note"];
            this.isActive = _data["IsActive"];
            this.debt = _data["Debt"];
            this.purchaseOrderId = _data["PurchaseOrderId"];
            this.payAmount = _data["PayAmount"];
            this.supplierType = _data["SupplierType"];
        }
    }

    static fromJS(data: any): CreateSupplierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["Phone"] = this.phone;
        data["TinhThanhCode"] = this.tinhThanhCode;
        data["QuanHuyenCode"] = this.quanHuyenCode;
        data["PhuongXaCode"] = this.phuongXaCode;
        data["Address"] = this.address;
        data["BranchId"] = this.branchId;
        data["Email"] = this.email;
        data["Company"] = this.company;
        data["MaSoThue"] = this.maSoThue;
        data["Note"] = this.note;
        data["IsActive"] = this.isActive;
        data["Debt"] = this.debt;
        data["PurchaseOrderId"] = this.purchaseOrderId;
        data["PayAmount"] = this.payAmount;
        data["SupplierType"] = this.supplierType;
        return data;
    }
}

export interface ICreateSupplierRequest {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    tinhThanhCode?: string | undefined;
    quanHuyenCode?: string | undefined;
    phuongXaCode?: string | undefined;
    address?: string | undefined;
    branchId: number;
    email?: string | undefined;
    company?: string | undefined;
    maSoThue?: string | undefined;
    note?: string | undefined;
    isActive: boolean;
    debt: number;
    purchaseOrderId?: string | undefined;
    payAmount?: number | undefined;
    supplierType: SupplierTypeEnum;
}

export class ThongBaoDto implements IThongBaoDto {
    id!: number;
    type!: TypeNotificationEnum;
    tieuDe?: string | undefined;
    noiDung?: string | undefined;
    daDoc!: boolean;
    createdTime!: Date;
    createTimeStr?: string | undefined;

    constructor(data?: IThongBaoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.tieuDe = _data["TieuDe"];
            this.noiDung = _data["NoiDung"];
            this.daDoc = _data["DaDoc"];
            this.createdTime = _data["CreatedTime"] ? new Date(_data["CreatedTime"].toString()) : <any>undefined;
            this.createTimeStr = _data["CreateTimeStr"];
        }
    }

    static fromJS(data: any): ThongBaoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThongBaoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["TieuDe"] = this.tieuDe;
        data["NoiDung"] = this.noiDung;
        data["DaDoc"] = this.daDoc;
        data["CreatedTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["CreateTimeStr"] = this.createTimeStr;
        return data;
    }
}

export interface IThongBaoDto {
    id: number;
    type: TypeNotificationEnum;
    tieuDe?: string | undefined;
    noiDung?: string | undefined;
    daDoc: boolean;
    createdTime: Date;
    createTimeStr?: string | undefined;
}

export enum TypeNotificationEnum {
    Default = 0,
    Success = 1,
    Error = 2,
}

export class TestPushNotificationRequest implements ITestPushNotificationRequest {
    title?: string | undefined;
    content?: string | undefined;
    type?: TypeNotificationEnum | undefined;

    constructor(data?: ITestPushNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.content = _data["Content"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): TestPushNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestPushNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Content"] = this.content;
        data["Type"] = this.type;
        return data;
    }
}

export interface ITestPushNotificationRequest {
    title?: string | undefined;
    content?: string | undefined;
    type?: TypeNotificationEnum | undefined;
}

export class FundHistoryDto implements IFundHistoryDto {
    id!: number;
    transactionDate!: Date;
    transactionType?: string | undefined;
    fromCategoryId?: number | undefined;
    toCategoryId?: number | undefined;
    initiatorId?: number | undefined;
    sender?: string | undefined;
    receiver?: string | undefined;
    initiator?: string | undefined;
    amount!: number;
    description?: string | undefined;
    reference?: string | undefined;
    statusColor?: string | undefined;
    displayDescription?: string | undefined;

    constructor(data?: IFundHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.transactionDate = _data["TransactionDate"] ? new Date(_data["TransactionDate"].toString()) : <any>undefined;
            this.transactionType = _data["TransactionType"];
            this.fromCategoryId = _data["FromCategoryId"];
            this.toCategoryId = _data["ToCategoryId"];
            this.initiatorId = _data["InitiatorId"];
            this.sender = _data["Sender"];
            this.receiver = _data["Receiver"];
            this.initiator = _data["Initiator"];
            this.amount = _data["Amount"];
            this.description = _data["Description"];
            this.reference = _data["Reference"];
            this.statusColor = _data["StatusColor"];
            this.displayDescription = _data["DisplayDescription"];
        }
    }

    static fromJS(data: any): FundHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FundHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TransactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["TransactionType"] = this.transactionType;
        data["FromCategoryId"] = this.fromCategoryId;
        data["ToCategoryId"] = this.toCategoryId;
        data["InitiatorId"] = this.initiatorId;
        data["Sender"] = this.sender;
        data["Receiver"] = this.receiver;
        data["Initiator"] = this.initiator;
        data["Amount"] = this.amount;
        data["Description"] = this.description;
        data["Reference"] = this.reference;
        data["StatusColor"] = this.statusColor;
        data["DisplayDescription"] = this.displayDescription;
        return data;
    }
}

export interface IFundHistoryDto {
    id: number;
    transactionDate: Date;
    transactionType?: string | undefined;
    fromCategoryId?: number | undefined;
    toCategoryId?: number | undefined;
    initiatorId?: number | undefined;
    sender?: string | undefined;
    receiver?: string | undefined;
    initiator?: string | undefined;
    amount: number;
    description?: string | undefined;
    reference?: string | undefined;
    statusColor?: string | undefined;
    displayDescription?: string | undefined;
}

export class GetFundHistoryRequest implements IGetFundHistoryRequest {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    transactionType?: string | undefined;
    categoryIds?: number[] | undefined;
    reportCode?: string | undefined;

    constructor(data?: IGetFundHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : <any>undefined;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : <any>undefined;
            this.transactionType = _data["TransactionType"];
            if (Array.isArray(_data["CategoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["CategoryIds"])
                    this.categoryIds!.push(item);
            }
            this.reportCode = _data["ReportCode"];
        }
    }

    static fromJS(data: any): GetFundHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFundHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["TransactionType"] = this.transactionType;
        if (Array.isArray(this.categoryIds)) {
            data["CategoryIds"] = [];
            for (let item of this.categoryIds)
                data["CategoryIds"].push(item);
        }
        data["ReportCode"] = this.reportCode;
        return data;
    }
}

export interface IGetFundHistoryRequest {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    transactionType?: string | undefined;
    categoryIds?: number[] | undefined;
    reportCode?: string | undefined;
}

export class FundSummaryDto implements IFundSummaryDto {
    totalAdvanced!: number;
    totalReturned!: number;
    totalTransferred!: number;

    constructor(data?: IFundSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAdvanced = _data["TotalAdvanced"];
            this.totalReturned = _data["TotalReturned"];
            this.totalTransferred = _data["TotalTransferred"];
        }
    }

    static fromJS(data: any): FundSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FundSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TotalAdvanced"] = this.totalAdvanced;
        data["TotalReturned"] = this.totalReturned;
        data["TotalTransferred"] = this.totalTransferred;
        return data;
    }
}

export interface IFundSummaryDto {
    totalAdvanced: number;
    totalReturned: number;
    totalTransferred: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}